/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
  /** Object custom scalar type */
  Object: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AcceptIntroRequestForMatchInput = {
  cancelOpenIntroRequestsOnSupervisorMatch?: InputMaybe<Scalars['Boolean']['input']>;
  introRequestId: Scalars['String']['input'];
};

export type AcceptIntroRequestForMatchResult = {
  __typename?: 'AcceptIntroRequestForMatchResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Actor = {
  __typename?: 'Actor';
  admin?: Maybe<Admin>;
  id: Scalars['Int']['output'];
  organizationAdmin?: Maybe<OrganizationAdmin>;
  refId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  user?: Maybe<User>;
};

export enum ActorType {
  Admin = 'admin',
  OrganizationAdmin = 'organization_admin',
  System = 'system',
  User = 'user'
}

export type AddFormQuestionInput = {
  choices?: InputMaybe<Array<FormQuestionChoice>>;
  formVersionId: Scalars['String']['input'];
  question: Scalars['String']['input'];
  questionTypeId: Scalars['Int']['input'];
  sort: Scalars['Int']['input'];
};

export type AddFormQuestionResult = {
  __typename?: 'AddFormQuestionResult';
  success: Scalars['Boolean']['output'];
};

export type AddLicensePairingNoteInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  superviseeLicenseCategoryId: Scalars['Int']['input'];
  superviseeSpecificLicenseId: Scalars['Int']['input'];
  supervisorCredentialId?: InputMaybe<Scalars['Int']['input']>;
  supervisorLicenseCategoryId: Scalars['Int']['input'];
  supervisorSpecificLicenseId: Scalars['Int']['input'];
  usStateId: Scalars['Int']['input'];
};

export type AddOrganizationUserToMatchQueueInput = {
  organizationUserId: Scalars['Int']['input'];
};

export type AddSupervisionRuleInput = {
  additionalSupervisionNotes?: InputMaybe<Scalars['String']['input']>;
  boardApprovalAdditionalNotes?: InputMaybe<Scalars['String']['input']>;
  boardApprovalForms?: InputMaybe<Scalars['String']['input']>;
  boardApprovalReference?: InputMaybe<Scalars['String']['input']>;
  boardApprovalRequired?: InputMaybe<Scalars['String']['input']>;
  dyadHoursRequired?: InputMaybe<Scalars['String']['input']>;
  groupHoursRequired?: InputMaybe<Scalars['String']['input']>;
  groupSize?: InputMaybe<Scalars['String']['input']>;
  individualHoursRequired?: InputMaybe<Scalars['String']['input']>;
  licenseCategoryId: Scalars['Int']['input'];
  minimumSupervisionFrequency?: InputMaybe<Scalars['String']['input']>;
  stateSpecificLicense: Scalars['String']['input'];
  supervisionAgreementRequired?: InputMaybe<Scalars['String']['input']>;
  supervisionRulesReferences: Scalars['String']['input'];
  supervisionTotalHoursRequired: Scalars['String']['input'];
  telesupervisionBoardContact: Scalars['String']['input'];
  telesupervisionLastUpdatedOn: Scalars['String']['input'];
  telesupervisionMotivoAssessment: Scalars['String']['input'];
  telesupervisionRuleDetails: Scalars['String']['input'];
  telesupervisionRuleLocation: Scalars['String']['input'];
  telesupervisionRuleUrl: Scalars['String']['input'];
  usStateId: Scalars['Int']['input'];
};

export type Admin = {
  __typename?: 'Admin';
  adminRoles: Array<AdminRole>;
  authId: Scalars['String']['output'];
  calendlyUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  slackUserId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  zoomUserId?: Maybe<Scalars['String']['output']>;
};

export type AdminRole = {
  __typename?: 'AdminRole';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdminSlackUser = {
  __typename?: 'AdminSlackUser';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  realName?: Maybe<Scalars['String']['output']>;
};

export type ApproveProposedSessionInput = {
  id: Scalars['Int']['input'];
};

export type ApproveSuperviseeInput = {
  organizationUserId: Scalars['Int']['input'];
};

export type ApproveSuperviseeMatchInput = {
  id: Scalars['Int']['input'];
};

export type ApproveSuperviseeMatchResult = {
  __typename?: 'ApproveSuperviseeMatchResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ApproveSuperviseeResult = {
  __typename?: 'ApproveSuperviseeResult';
  firstName?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ApproveSupervisorApplicationForOpportunityInput = {
  opportunitiesCandidateId: Scalars['String']['input'];
};

export type ApproveSupervisorApplicationForOpportunityResult = {
  __typename?: 'ApproveSupervisorApplicationForOpportunityResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignDiscountToUserInput = {
  discountTypeId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type AssignDiscountToUserResult = {
  __typename?: 'AssignDiscountToUserResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignOrganizationProgramDirectorInput = {
  organizationAdminId: Scalars['Int']['input'];
  programId: Scalars['String']['input'];
};

export type AssignOrganizationProgramDirectorResult = {
  __typename?: 'AssignOrganizationProgramDirectorResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AvailableTimeSlot = {
  __typename?: 'AvailableTimeSlot';
  date: Scalars['String']['output'];
  times: Array<Scalars['String']['output']>;
};

export type B2CSessionAttendee = {
  __typename?: 'B2CSessionAttendee';
  id: Scalars['String']['output'];
  sessionAttendeeId: Scalars['Int']['output'];
  sessionRate: SessionRate;
  sessionRateId: Scalars['Int']['output'];
};

export type BalanceTransactionsByOrganizationIdResult = {
  __typename?: 'BalanceTransactionsByOrganizationIdResult';
  balanceTransactions: Array<StripeBalanceTransaction>;
  totalBalance: Scalars['Int']['output'];
};

export type BaseError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type BaseUser = {
  activeIntroRequestsAsSupervisee: Array<IntroRequest>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  avatarPath?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  canSuperviseesBookSessions: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  clinicalSettings: Array<ClinicalSetting>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creditCards?: Maybe<Array<CreditCard>>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emergencyContact?: Maybe<EmergencyContact>;
  enrolledCourses?: Maybe<Array<Course>>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasPrimaryCalendar: Scalars['Boolean']['output'];
  hasSetPassword: Scalars['Boolean']['output'];
  hubspotId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  isSupervisee: Scalars['Boolean']['output'];
  isSupervisor: Scalars['Boolean']['output'];
  languages: Array<Language>;
  largeAvatar?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latLng?: Maybe<LatLng>;
  learningTermsAcceptedAt?: Maybe<Scalars['Date']['output']>;
  mediumAvatar?: Maybe<Scalars['String']['output']>;
  modalities?: Maybe<Array<Modality>>;
  opportunities: Array<Opportunity>;
  organizationSuperviseeOnboardingRequest?: Maybe<OrganizationSuperviseeOnboardingRequest>;
  organizationUser?: Maybe<OrganizationUser>;
  passwordSetAt?: Maybe<Scalars['Date']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  populations: Array<Population>;
  postnominals?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  prenominals?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  smallAvatar?: Maybe<Scalars['String']['output']>;
  specialties: Array<Specialty>;
  stateId?: Maybe<Scalars['Int']['output']>;
  stripeConnectedAccountId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeVerified?: Maybe<Scalars['Boolean']['output']>;
  superviseeMatches: Array<Match>;
  superviseeOnboardingInfo?: Maybe<SuperviseeOnboardingInfo>;
  superviseeProfile?: Maybe<SuperviseeProfile>;
  supervisorApplication?: Maybe<SupervisorApplication>;
  supervisorMatches: Array<Match>;
  supervisorProfile?: Maybe<SupervisorProfile>;
  supervisorTerminationRequest?: Maybe<SupervisorTerminationRequest>;
  timezone?: Maybe<Scalars['String']['output']>;
  userAvailabilities: Array<UserAvailability>;
  userBookedTimeslots?: Maybe<Array<BookedTimeSlot>>;
  userClinicalTrainings: Array<UserClinicalTraining>;
  userPrimaryCalendar?: Maybe<UserPrimaryCalendar>;
  userSubscription?: Maybe<UsersSubscription>;
  usersClinicalSettings: Array<UsersClinicalSetting>;
  usersDegrees: Array<UsersDegree>;
  usersLicenses: Array<UsersLicense>;
  usersModalities: Array<UsersModality>;
  usersPopulations: Array<UsersPopulation>;
  usersSpecialties: Array<UsersSpecialty>;
  usersSupervisionCredentials: Array<UsersSupervisionCredential>;
  zipcode?: Maybe<Scalars['String']['output']>;
  zoomUserId?: Maybe<Scalars['String']['output']>;
};


export type BaseUserModalitiesArgs = {
  filtered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseUserOrganizationUserArgs = {
  deletedForOrganizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type BaseUserSpecialtiesArgs = {
  filtered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseUserSupervisorMatchesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillableWorkAssignee = {
  __typename?: 'BillableWorkAssignee';
  assigneeUserId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
  organizationPrograms: Array<OrganizationProgram>;
  user: User;
};

export type BillableWorkRecord = {
  __typename?: 'BillableWorkRecord';
  assigneeUser: User;
  assigneeUserId: Scalars['Int']['output'];
  billableWorkRecordType: BillableWorkRecordType;
  billableWorkRecordTypeId: Scalars['Int']['output'];
  completedOn: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['Int']['output'];
  organizationProgram?: Maybe<OrganizationProgram>;
  organizationProgramId?: Maybe<Scalars['String']['output']>;
  organizationRate: OrganizationRate;
  organizationRateId: Scalars['String']['output'];
  transfer?: Maybe<Transfer>;
};

export type BillableWorkRecordCap = {
  __typename?: 'BillableWorkRecordCap';
  billableWorkRecordCapTypeId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  frequencyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  organizationProgramId?: Maybe<Scalars['String']['output']>;
};

export type BillableWorkRecordCapInput = {
  billableWorkRecordCapTypeId: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  frequencyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  organizationProgramId?: InputMaybe<Scalars['String']['input']>;
};

export type BillableWorkRecordCapType = {
  __typename?: 'BillableWorkRecordCapType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BillableWorkRecordType = {
  __typename?: 'BillableWorkRecordType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BillableWorkRecordsAdminResult = {
  __typename?: 'BillableWorkRecordsAdminResult';
  result: Array<BillableWorkRecord>;
  totalDuration: Scalars['Int']['output'];
};

export type BillableWorkRecordsForOrganizationAdminResult = {
  __typename?: 'BillableWorkRecordsForOrganizationAdminResult';
  result: Array<BillableWorkRecord>;
  total: Scalars['Int']['output'];
};

export type BillableWorkRecordsResult = {
  __typename?: 'BillableWorkRecordsResult';
  result: Array<BillableWorkRecord>;
  total: Scalars['Int']['output'];
};

export type BookedTimeSlot = {
  __typename?: 'BookedTimeSlot';
  endTime?: Maybe<Scalars['Date']['output']>;
  startTime?: Maybe<Scalars['Date']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Timeslot>;
};

export type BouncedEmailsQueryResult = {
  __typename?: 'BouncedEmailsQueryResult';
  result?: Maybe<Array<UserWithError>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum BusinessProfileEnum {
  Company = 'company',
  Individual = 'individual'
}

export type CeInvoice = {
  __typename?: 'CEInvoice';
  amount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  paidOn: Scalars['Date']['output'];
  pdfUrl: Scalars['String']['output'];
};

export type CancelChronosTaskMutationResult = {
  __typename?: 'CancelChronosTaskMutationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelScheduledOrganizationUserRemovalInput = {
  id: Scalars['Int']['input'];
};

export type CancelScheduledOrganizationUserRemovalResult = {
  __typename?: 'CancelScheduledOrganizationUserRemovalResult';
  success: Scalars['Boolean']['output'];
};

export type CancelSessionInput = {
  id: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  sessionCancellationReasonId?: InputMaybe<Scalars['Int']['input']>;
  shouldCancelThisAndFollowing: Scalars['Boolean']['input'];
  unavailablePartyUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelSubscriptionResult = {
  __typename?: 'CancelSubscriptionResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CandidateTypeEnum {
  Email = 'email',
  SupervisorApplication = 'supervisorApplication',
  User = 'user'
}

export type Chat = {
  __typename?: 'Chat';
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  latestChatMessage?: Maybe<ChatMessage>;
  participants: Array<ChatActor>;
};

export type ChatActor = {
  __typename?: 'ChatActor';
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  smallAvatar?: Maybe<Scalars['String']['output']>;
  type: ActorType;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  chatId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  senderActorId: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type ChatMessagesResult = {
  __typename?: 'ChatMessagesResult';
  nextCursor?: Maybe<Scalars['String']['output']>;
  result: Array<ChatMessage>;
};

export type ChronosJob = {
  __typename?: 'ChronosJob';
  jobName: Scalars['String']['output'];
  lastStartedAt?: Maybe<Scalars['Date']['output']>;
};

export type ChronosTask = {
  __typename?: 'ChronosTask';
  args?: Maybe<Scalars['Object']['output']>;
  chronosTaskStatusId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  jobName: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Date']['output']>;
};

export type ChronosTasksQueryResult = {
  __typename?: 'ChronosTasksQueryResult';
  chronosTasks: Array<ChronosTask>;
  total: Scalars['Int']['output'];
};

export type ChurnOrganizationInput = {
  churnedDate: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type ClinicalSetting = {
  __typename?: 'ClinicalSetting';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CloseOpportunityInput = {
  id: Scalars['String']['input'];
};

export type CloseOpportunityResult = {
  __typename?: 'CloseOpportunityResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Comment = {
  __typename?: 'Comment';
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  submittedByAdmin: Admin;
  submittedByAdminId: Scalars['Int']['output'];
};

export enum CommentRelatedEntityTypeEnum {
  ExternalSupervisorRequest = 'EXTERNAL_SUPERVISOR_REQUEST',
  Organization = 'ORGANIZATION',
  SupervisorIncident = 'SUPERVISOR_INCIDENT'
}

export type CommercialStatus = {
  __typename?: 'CommercialStatus';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ComplianceIssue = {
  __typename?: 'ComplianceIssue';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ConductIssue = {
  __typename?: 'ConductIssue';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ConfirmEmailChangeInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  verificationToken: Scalars['String']['input'];
};

export type ContinuingEducationSummaryResult = {
  __typename?: 'ContinuingEducationSummaryResult';
  coursesCompletedCount: Scalars['Int']['output'];
  coursesInProgressCount: Scalars['Int']['output'];
  creditsCompletedCount: Scalars['Float']['output'];
  inProgressOnDemandCourse?: Maybe<Course>;
  upcomingLiveCourse?: Maybe<Course>;
};

export type Course = {
  __typename?: 'Course';
  courseContent?: Maybe<CourseContent>;
  courseCredentialingBodyApprovals?: Maybe<Array<CourseCredentialingBodyApproval>>;
  courseStatus?: Maybe<CourseStatus>;
  courseStatusId: Scalars['Int']['output'];
  courseTypeId: Scalars['Int']['output'];
  coursesLicenseCategories?: Maybe<Array<CoursesLicenseCategory>>;
  coursesTopics?: Maybe<Array<CoursesTopic>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  credentialingBodyAccreditations?: Maybe<Array<CredentialingBodyAccreditation>>;
  creditHours: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  evaluationForm?: Maybe<Form>;
  evaluationFormId?: Maybe<Scalars['String']['output']>;
  flagship?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  licenseCategories?: Maybe<Array<LicenseCategory>>;
  liveHostStartUrl?: Maybe<Scalars['String']['output']>;
  liveJoinUrl?: Maybe<Scalars['String']['output']>;
  masteryForm?: Maybe<Form>;
  masteryFormId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onePagerGcsUrl?: Maybe<Scalars['String']['output']>;
  panelists?: Maybe<Array<Panelist>>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  publishedByAdmin?: Maybe<Admin>;
  publishedByAdminId?: Maybe<Scalars['Int']['output']>;
  scheduledFor?: Maybe<Scalars['Date']['output']>;
  slug: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  thumbnailPath?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Topic>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  viewerEnrollment?: Maybe<CourseEnrollment>;
};

export type CourseContent = {
  __typename?: 'CourseContent';
  createdAt?: Maybe<Scalars['Date']['output']>;
  hlsManifestUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  storageUrl: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CourseCredentialingBodyApproval = {
  __typename?: 'CourseCredentialingBodyApproval';
  approvalStatement?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['String']['output']>;
  credentialingBodyAccreditation?: Maybe<CredentialingBodyAccreditation>;
  credentialingBodyAccreditationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type CourseEnrollment = {
  __typename?: 'CourseEnrollment';
  completedCourseAt?: Maybe<Scalars['Date']['output']>;
  completedEvaluationAt?: Maybe<Scalars['Date']['output']>;
  completedMasteryAt?: Maybe<Scalars['Date']['output']>;
  course: Course;
  courseId: Scalars['String']['output'];
  enrolledAsLive?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
};

export type CourseStatus = {
  __typename?: 'CourseStatus';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CoursesLicenseCategory = {
  __typename?: 'CoursesLicenseCategory';
  courseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  licenseCategoryId?: Maybe<Scalars['Int']['output']>;
};

export type CoursesResult = {
  __typename?: 'CoursesResult';
  result: Array<Course>;
  total: Scalars['Int']['output'];
};

export type CoursesTopic = {
  __typename?: 'CoursesTopic';
  courseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  topicId?: Maybe<Scalars['Int']['output']>;
};

export type CreateAccountError = {
  __typename?: 'CreateAccountError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CreateAccountFromSupervisorApplicationUserInput = {
  password: Scalars['String']['input'];
  subscribeToNewsletter: Scalars['Boolean']['input'];
  supervisorApplicationId: Scalars['String']['input'];
  supervisorTermsAccepted: Scalars['Boolean']['input'];
  timezone: Scalars['String']['input'];
};

export type CreateAccountFromSupervisorApplicationUserResult = {
  __typename?: 'CreateAccountFromSupervisorApplicationUserResult';
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type CreateAccountInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  fromMotivoProduct?: InputMaybe<FromMotivoProduct>;
  lastName: Scalars['String']['input'];
  learningTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  potentialSupervisorUserId?: InputMaybe<Scalars['Int']['input']>;
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  superviseeOnboardingData?: InputMaybe<SuperviseeOnboardingDataInput>;
  superviseeTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorApplicationId?: InputMaybe<Scalars['String']['input']>;
  supervisorTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userSignupSourceData?: InputMaybe<UserSignupSourceDataInput>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAccountResult = {
  __typename?: 'CreateAccountResult';
  errors?: Maybe<Array<CreateAccountError>>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<CreateAccountUserResult>;
};

export type CreateAccountUserResult = {
  __typename?: 'CreateAccountUserResult';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type CreateAdminInput = {
  adminRoleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  calendlyUrl?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  slackUserId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zoomUserId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdminResult = {
  __typename?: 'CreateAdminResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateB2BMatchInput = {
  programId?: InputMaybe<Scalars['String']['input']>;
  superviseeId: Scalars['Int']['input'];
  supervisorId: Scalars['Int']['input'];
};

export type CreateB2BMatchResult = {
  __typename?: 'CreateB2BMatchResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateBillableWorkAssigneeInput = {
  organizationId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type CreateBillableWorkAssigneeResult = {
  __typename?: 'CreateBillableWorkAssigneeResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateBillableWorkRecordError = CreateBillableWorkRecordInvalidOrgError | CreateBillableWorkRecordLimitExceededError | CreateBillableWorkRecordOutsideTimeRangeError;

export type CreateBillableWorkRecordInput = {
  billableWorkRecordTypeId?: InputMaybe<Scalars['Int']['input']>;
  completedOn: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  organizationProgramId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateBillableWorkRecordInvalidOrgError = {
  __typename?: 'CreateBillableWorkRecordInvalidOrgError';
  userMessage: Scalars['String']['output'];
};

export type CreateBillableWorkRecordLimitExceededError = {
  __typename?: 'CreateBillableWorkRecordLimitExceededError';
  limitDescription: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
};

export type CreateBillableWorkRecordOutsideTimeRangeError = {
  __typename?: 'CreateBillableWorkRecordOutsideTimeRangeError';
  minAllowableCompletedOn: Scalars['String']['output'];
};

export type CreateBillableWorkRecordResult = {
  __typename?: 'CreateBillableWorkRecordResult';
  error?: Maybe<CreateBillableWorkRecordError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCommentInput = {
  comment: Scalars['String']['input'];
  relatedEntityId: Scalars['Int']['input'];
  relatedEntityType: CommentRelatedEntityTypeEnum;
};

export type CreateCourseContentInput = {
  courseId: Scalars['String']['input'];
  hostStartUrl?: InputMaybe<Scalars['String']['input']>;
  itemOrder: Scalars['Int']['input'];
  joinUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  storageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCourseContentResult = {
  __typename?: 'CreateCourseContentResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCourseInput = {
  accreditationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  courseTypeId: Scalars['Int']['input'];
  creditHours: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  flagship?: InputMaybe<Scalars['Boolean']['input']>;
  licenseCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  scheduledFor?: InputMaybe<Scalars['Date']['input']>;
  summary: Scalars['String']['input'];
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateCourseResult = {
  __typename?: 'CreateCourseResult';
  id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCredentialingBodyAccreditationInput = {
  approvalStatementTemplate: Scalars['String']['input'];
  approvedOn: Scalars['String']['input'];
  expiresOn: Scalars['String']['input'];
  name: Scalars['String']['input'];
  providerNumber: Scalars['String']['input'];
};

export type CreateCredentialingBodyAccreditationResult = {
  __typename?: 'CreateCredentialingBodyAccreditationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCreditCardError = {
  __typename?: 'CreateCreditCardError';
  error?: Maybe<Scalars['String']['output']>;
  remainingAmountInCents?: Maybe<Scalars['Int']['output']>;
  remainingSessionsCount?: Maybe<Scalars['Int']['output']>;
};

export type CreateCreditCardForOrganizationInput = {
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCreditCardForOrganizationResult = {
  __typename?: 'CreateCreditCardForOrganizationResult';
  success: Scalars['Boolean']['output'];
};

export type CreateCreditCardInput = {
  numberOfDeclines?: InputMaybe<Scalars['Int']['input']>;
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  stripePaymentMethodId: Scalars['String']['input'];
};

export type CreateCreditCardResult = CreateCreditCardError | CreateCreditCardSuccess;

export type CreateCreditCardSuccess = {
  __typename?: 'CreateCreditCardSuccess';
  success: Scalars['Boolean']['output'];
};

export type CreateCreditNoteInput = {
  amountInCents: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
  shouldCreateStripeBalanceTransaction: Scalars['Boolean']['input'];
  stripeInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCreditNoteResult = {
  __typename?: 'CreateCreditNoteResult';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateDiscountTypeInput = {
  amountInCentsOff?: InputMaybe<Scalars['Int']['input']>;
  maxUses: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  percentOff?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDiscountTypeResult = {
  __typename?: 'CreateDiscountTypeResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateExternalSupervisorRequestCandidateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalSupervisorRequestId: Scalars['Int']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  supervisorApplicationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateExternalSupervisorRequestCommentInput = {
  comment: Scalars['String']['input'];
  externalSupervisorRequestId: Scalars['Int']['input'];
};

export type CreateExternalSupervisorRequestInput = {
  desiredStartDate?: InputMaybe<Scalars['String']['input']>;
  externalSupervisorRequestStatusId?: InputMaybe<Scalars['Int']['input']>;
  externalSupervisorRequestUrgencyId: Scalars['Int']['input'];
  isSpecialtyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  licenseCategoryId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfSupervisees?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  sessionTypeIds: Array<Scalars['Int']['input']>;
  usStateId: Scalars['Int']['input'];
};

export type CreateFormInput = {
  graded: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  passingPercentage?: InputMaybe<Scalars['Int']['input']>;
  questions: Array<QuestionInput>;
};

export type CreateFormResult = {
  __typename?: 'CreateFormResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateIntroRequestInput = {
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  availableSlots: Array<Scalars['Date']['input']>;
  feeAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  introRequestOrganizationInfoId?: InputMaybe<Scalars['String']['input']>;
  opportunitiesCandidateId?: InputMaybe<Scalars['String']['input']>;
  supervisorUserId: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};

export type CreateIntroRequestOrganizationInfoInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  clinicalQuestions?: InputMaybe<Scalars['String']['input']>;
  sessionTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  superviseeInfo: Scalars['String']['input'];
  supervisionStartTime: Scalars['String']['input'];
  weeklyHours: Scalars['Int']['input'];
};

export type CreateIntroRequestOrganizationInfoResult = {
  __typename?: 'CreateIntroRequestOrganizationInfoResult';
  id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateIntroRequestResult = {
  __typename?: 'CreateIntroRequestResult';
  error?: Maybe<Scalars['String']['output']>;
  introRequestId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateJobListingInput = {
  county?: InputMaybe<Scalars['String']['input']>;
  descriptionMarkdown: Scalars['String']['input'];
  externalJobId?: InputMaybe<Scalars['String']['input']>;
  externalJobUrl?: InputMaybe<Scalars['String']['input']>;
  jobListingLocationId?: InputMaybe<Scalars['Int']['input']>;
  licenseCategoryIds: Array<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['Int']['input'];
  salary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  usStateId: Scalars['Int']['input'];
};

export type CreateLicenseInput = {
  isCertification?: InputMaybe<Scalars['Boolean']['input']>;
  licenseCategoryId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateLicenseResult = {
  __typename?: 'CreateLicenseResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMatchDocumentInput = {
  creatorAttestedNoPhiAt: Scalars['Date']['input'];
  document: Scalars['Upload']['input'];
  matchId: Scalars['Int']['input'];
};

export type CreateOnePagerInput = {
  courseId: Scalars['String']['input'];
  onePager?: InputMaybe<Scalars['Upload']['input']>;
};

export type CreateOnePagerResult = {
  __typename?: 'CreateOnePagerResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOpportunitiesCandidateInput = {
  opportunityId: Scalars['String']['input'];
  supervisorApplicationId?: InputMaybe<Scalars['String']['input']>;
  supervisorUserId?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type CreateOpportunitiesCandidateResult = {
  __typename?: 'CreateOpportunitiesCandidateResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOpportunityInput = {
  licenseCategoryId: Scalars['Int']['input'];
  manualQueue?: InputMaybe<Scalars['Boolean']['input']>;
  modalityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  organizationAdminId?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['Int']['input'];
  populationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  requiresIntroCalls?: InputMaybe<Scalars['Boolean']['input']>;
  sessionTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  specialtyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  superviseeUserIds: Array<Scalars['Int']['input']>;
  supervisionAvailability?: InputMaybe<Scalars['String']['input']>;
  supervisionStartBy?: InputMaybe<Scalars['String']['input']>;
  usStateId: Scalars['Int']['input'];
  weeklyHours?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOpportunityResult = {
  __typename?: 'CreateOpportunityResult';
  id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrActivateMatchInput = {
  superviseeId: Scalars['Int']['input'];
  supervisorId: Scalars['Int']['input'];
};

export type CreateOrActivateMatchResult = {
  __typename?: 'CreateOrActivateMatchResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrActivateOrganizationMatchInput = {
  organizationId: Scalars['Int']['input'];
  supervisorId: Scalars['Int']['input'];
};

export type CreateOrActivateOrganizationMatchResult = {
  __typename?: 'CreateOrActivateOrganizationMatchResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrUpdateSessionAttendeeNpsResponseInput = {
  additionalFeedback?: InputMaybe<Scalars['String']['input']>;
  communicationRating?: InputMaybe<Scalars['Int']['input']>;
  feedbackRating?: InputMaybe<Scalars['Int']['input']>;
  finalize?: InputMaybe<Scalars['Boolean']['input']>;
  goalsRating?: InputMaybe<Scalars['Int']['input']>;
  npsScore?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['Int']['input'];
  supportRating?: InputMaybe<Scalars['Int']['input']>;
  trustRating?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrUpdateSessionNoteDraftsInput = {
  sessionId: Scalars['Int']['input'];
  sessionNoteDrafts: Array<SessionNoteDraftInput>;
};

export type CreateOrUpdateSessionNoteDraftsResult = {
  __typename?: 'CreateOrUpdateSessionNoteDraftsResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrganizationAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['Int']['input'];
  organizationTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  programIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roleId: Scalars['Int']['input'];
};

export type CreateOrganizationAdminResult = {
  __typename?: 'CreateOrganizationAdminResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrganizationContinuingEducationUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};

export type CreateOrganizationContinuingEducationUserResult = {
  __typename?: 'CreateOrganizationContinuingEducationUserResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrganizationGrantDiscountInput = {
  discountPercent: Scalars['Int']['input'];
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  organizationGrantId: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
  usStateIds: Array<Scalars['Int']['input']>;
};

export type CreateOrganizationGrantInput = {
  grantTypeId: Scalars['Int']['input'];
  monthlyGrantCapInCents: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
};

export type CreateOrganizationInput = {
  accountManagerAdminId?: InputMaybe<Scalars['Int']['input']>;
  autoChargeInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  canRemoveSupervisees?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dyadRateTotalInCents?: InputMaybe<Scalars['Int']['input']>;
  dyadTotalPayoutAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  groupRateTotalInCents?: InputMaybe<Scalars['Int']['input']>;
  groupTotalPayoutAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  individualRateTotalInCents?: InputMaybe<Scalars['Int']['input']>;
  individualTotalPayoutAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  introCallPreferenceId?: InputMaybe<Scalars['Int']['input']>;
  licenseCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  modalityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  monthlyMinimumHours?: InputMaybe<Scalars['Float']['input']>;
  monthlyMinimumInCents?: InputMaybe<Scalars['Int']['input']>;
  monthlyServiceFeeInCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingFeeInCents?: InputMaybe<Scalars['Int']['input']>;
  populationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  requiresNotesInReports?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSupervisorAdminHours?: InputMaybe<Scalars['Boolean']['input']>;
  specialtyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  supervisionAvailability?: InputMaybe<Scalars['String']['input']>;
  tier: Scalars['Int']['input'];
  usStateIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationOnboardingRequestInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  organizationSizeId: Scalars['Int']['input'];
  organizationTypeId?: InputMaybe<Scalars['Int']['input']>;
  organizationTypeText?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  referralSourceId: Scalars['Int']['input'];
  referrerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  referrerName?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  totalOrganizationSizeId?: InputMaybe<Scalars['Int']['input']>;
  usStateIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationOnboardingRequestResult = {
  __typename?: 'CreateOrganizationOnboardingRequestResult';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrganizationProgramInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};

export type CreateOrganizationProgramResult = {
  __typename?: 'CreateOrganizationProgramResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrganizationResult = {
  __typename?: 'CreateOrganizationResult';
  id?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrganizationUserInput = {
  organizationId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type CreatePanelistInput = {
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  postnominals?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePanelistResult = {
  __typename?: 'CreatePanelistResult';
  id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSessionInput = {
  duration: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
  matchIds: Array<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  recurrence: CreateSessionRecurrenceInput;
  scheduledAt: Scalars['Date']['input'];
  supervisorId?: InputMaybe<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
};

export type CreateSessionNoteInput = {
  sessionId: Scalars['Int']['input'];
  sessionNotes: Array<SessionNoteInput>;
  verifiedNoPHI?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSessionNotesResult = {
  __typename?: 'CreateSessionNotesResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSessionRecurrenceInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  occurrenceCount?: InputMaybe<Scalars['Int']['input']>;
  recurrenceTypeKey?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSessionResult = {
  __typename?: 'CreateSessionResult';
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSetupIntentForOrganizationResult = {
  __typename?: 'CreateSetupIntentForOrganizationResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type CreateSetupIntentResult = {
  __typename?: 'CreateSetupIntentResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type CreateSignedUrlForUploadMutationInput = {
  courseId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type CreateSignedUrlForUploadMutationResult = {
  __typename?: 'CreateSignedUrlForUploadMutationResult';
  signedUrl: Scalars['String']['output'];
  storageUrl: Scalars['String']['output'];
};

export type CreateSubscriptionInput = {
  deleteCreditCardOnFailure?: InputMaybe<Scalars['Boolean']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  termsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSubscriptionResult = {
  __typename?: 'CreateSubscriptionResult';
  finalAmountInCents: Scalars['Int']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSupervisionCredentialInput = {
  name: Scalars['String']['input'];
};

export type CreateSupervisionCredentialResult = {
  __typename?: 'CreateSupervisionCredentialResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSupervisionGoalInput = {
  goals: Scalars['String']['input'];
  superviseeUserId: Scalars['Int']['input'];
};

export type CreateSupervisionGoalResult = {
  __typename?: 'CreateSupervisionGoalResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSupervisorIncidentInput = {
  actionsTaken?: InputMaybe<Scalars['String']['input']>;
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  assignedToAdminId?: InputMaybe<Scalars['Int']['input']>;
  complianceIssueIds: Array<Scalars['Int']['input']>;
  complianceIssuesOther?: InputMaybe<Scalars['String']['input']>;
  conductIssueIds: Array<Scalars['Int']['input']>;
  conductIssuesOther?: InputMaybe<Scalars['String']['input']>;
  incidentDate: Scalars['String']['input'];
  incidentDescription: Scalars['String']['input'];
  incidentReportMethods: Array<Scalars['Int']['input']>;
  incidentReportMethodsOther?: InputMaybe<Scalars['String']['input']>;
  incidentReporterNames: Scalars['String']['input'];
  incidentReporters: Array<Scalars['Int']['input']>;
  incidentReportersOther?: InputMaybe<Scalars['String']['input']>;
  linksToSupportingDocuments?: InputMaybe<Scalars['String']['input']>;
  possibleImpactOfIncident?: InputMaybe<Scalars['String']['input']>;
  recommendations?: InputMaybe<Scalars['String']['input']>;
  superviseeUserId?: InputMaybe<Scalars['Int']['input']>;
  supervisorUserId: Scalars['Int']['input'];
};

export type CreateSupervisorIncidentStrikeInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  supervisorIncidentId: Scalars['Int']['input'];
};

export type CreateTopicInput = {
  name: Scalars['String']['input'];
};

export type CreateTopicResult = {
  __typename?: 'CreateTopicResult';
  id?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUserAvailabilitiesInput = {
  availabilities?: InputMaybe<Array<UserAvailabilitiesListInput>>;
  weeklyAvailableHours?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateUserAvailabilitiesResult = {
  __typename?: 'CreateUserAvailabilitiesResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUserDocumentInput = {
  document: Scalars['Upload']['input'];
  userDocumentTypeId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type CreateUserDocumentResult = {
  __typename?: 'CreateUserDocumentResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUserFromSupervisorApplicationInput = {
  beganPracticingYear: Scalars['Int']['input'];
  document: Scalars['Upload']['input'];
  email: Scalars['String']['input'];
  externalSupervisorRequestCandidateId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  referralSourceText?: InputMaybe<Scalars['String']['input']>;
  supervisorReferralSourceId: Scalars['Int']['input'];
  zipcode: Scalars['String']['input'];
};

export type CreateUserFromSupervisorApplicationResult = {
  __typename?: 'CreateUserFromSupervisorApplicationResult';
  errors?: Maybe<Array<Error>>;
  id?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateUserHolidayBonusGoalExtraSessionCreditInput = {
  description: Scalars['String']['input'];
  userHolidayBonusGoalId: Scalars['Int']['input'];
};

export type CreateUserHolidayBonusGoalInput = {
  qualifyingSessionCountGoal: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type CreateUsersForOrganizationInput = {
  onboardingFormSlug?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['Int']['input'];
  organizationProgramId?: InputMaybe<Scalars['String']['input']>;
  users: Array<CreateUsersForOrganizationUserInput>;
};

export type CreateUsersForOrganizationResult = {
  __typename?: 'CreateUsersForOrganizationResult';
  statuses?: Maybe<Array<CreateUsersForOrganizationStatus>>;
};

export type CreateUsersForOrganizationStatus = {
  __typename?: 'CreateUsersForOrganizationStatus';
  code: CreateUsersForOrganizationStatusCode;
  email?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum CreateUsersForOrganizationStatusCode {
  CreateError = 'CREATE_ERROR',
  DuplicateEmailError = 'DUPLICATE_EMAIL_ERROR',
  PostCreateError = 'POST_CREATE_ERROR',
  PostPostCreateError = 'POST_POST_CREATE_ERROR',
  Success = 'SUCCESS'
}

export type CreateUsersForOrganizationUserInput = {
  billingCode?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isStudent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  scheduledStartDate?: InputMaybe<Scalars['String']['input']>;
  sessionTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  supervisorUserId?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  usStateId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateZoomCredentialsForSessionMutationCredentialsResult = {
  __typename?: 'CreateZoomCredentialsForSessionMutationCredentialsResult';
  hostZak?: Maybe<Scalars['String']['output']>;
  jwt: Scalars['String']['output'];
  meetingId: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export enum CreateZoomCredentialsForSessionMutationMeetingStatus {
  Finished = 'finished',
  HostNotStarted = 'hostNotStarted',
  NotTimeYet = 'notTimeYet'
}

export type CreateZoomCredentialsForSessionMutationResult = CreateZoomCredentialsForSessionMutationCredentialsResult | CreateZoomCredentialsForSessionMutationSessionInactiveResult | CreateZoomCredentialsForSessionMutationUrlResult;

export type CreateZoomCredentialsForSessionMutationSessionInactiveResult = {
  __typename?: 'CreateZoomCredentialsForSessionMutationSessionInactiveResult';
  meetingStatus: CreateZoomCredentialsForSessionMutationMeetingStatus;
  scheduledAt: Scalars['Date']['output'];
};

export type CreateZoomCredentialsForSessionMutationUrlResult = {
  __typename?: 'CreateZoomCredentialsForSessionMutationURLResult';
  url: Scalars['String']['output'];
};

export type CredentialingBodyAccreditation = {
  __typename?: 'CredentialingBodyAccreditation';
  approvalStatementTemplate: Scalars['String']['output'];
  approvedOn: Scalars['String']['output'];
  expiresOn: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerNumber: Scalars['String']['output'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  cardType: Scalars['String']['output'];
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastFourDigits: Scalars['String']['output'];
  preferred: Scalars['Boolean']['output'];
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
};

export type DeactivateMatchInput = {
  id: Scalars['Int']['input'];
  superviseeNeedsNewSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  unmatchResponsibilityAcknowledgedBySupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  unmatchSuperviseeReasonId?: InputMaybe<Scalars['Int']['input']>;
  unmatchSuperviseeReasonOther?: InputMaybe<Scalars['String']['input']>;
};

export type DeactivateMatchResult = {
  __typename?: 'DeactivateMatchResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeactivateOrganizationMatchInput = {
  organizationId: Scalars['Int']['input'];
  supervisorId: Scalars['Int']['input'];
};

export type DeactivateOrganizationMatchResult = {
  __typename?: 'DeactivateOrganizationMatchResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeclineIntroRequestInput = {
  declineReasonText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  introRequestDeclineReasonId: Scalars['Int']['input'];
  shouldChargeNoShowFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeclineIntroRequestResult = {
  __typename?: 'DeclineIntroRequestResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeclineOpportunitiesCandidateInput = {
  id: Scalars['String']['input'];
  opportunitiesCandidateDeclineReasonId?: InputMaybe<Scalars['Int']['input']>;
  opportunitiesCandidateDeclineReasonText?: InputMaybe<Scalars['String']['input']>;
};

export type DeclineOpportunitiesCandidateResult = {
  __typename?: 'DeclineOpportunitiesCandidateResult';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeclineOrCancelProposedSessionInput = {
  id: Scalars['Int']['input'];
};

export type DeclineSuperviseeMatchInput = {
  declinedReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeclineSuperviseeMatchResult = {
  __typename?: 'DeclineSuperviseeMatchResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeclineSupervisorApplicationInput = {
  declineReasonId?: InputMaybe<Scalars['Int']['input']>;
  declineReasonText?: InputMaybe<Scalars['String']['input']>;
  supervisorApplicationId: Scalars['String']['input'];
};

export type DeclineSupervisorApplicationResult = {
  __typename?: 'DeclineSupervisorApplicationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeclinedChargesResult = {
  __typename?: 'DeclinedChargesResult';
  sessionsCount?: Maybe<Scalars['Int']['output']>;
  totalAmountDueInCents?: Maybe<Scalars['Int']['output']>;
};

export type Degree = {
  __typename?: 'Degree';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DeleteAdminInput = {
  id: Scalars['Int']['input'];
};

export type DeleteAdminResult = {
  __typename?: 'DeleteAdminResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteAllDiscountsForOrganizationInput = {
  organizationId: Scalars['Int']['input'];
};

export type DeleteBillableWorkAssigneeInput = {
  id: Scalars['String']['input'];
};

export type DeleteBillableWorkAssigneeResult = {
  __typename?: 'DeleteBillableWorkAssigneeResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBillableWorkRecordByIdInput = {
  id: Scalars['String']['input'];
};

export type DeleteBillableWorkRecordByIdResult = {
  __typename?: 'DeleteBillableWorkRecordByIdResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteCreditCardForOrganizationInput = {
  id: Scalars['String']['input'];
};

export type DeleteCreditCardForOrganizationResult = DeleteCreditCardForOrganizationSuccessResult | Error | FinalCardDeletionError;

export type DeleteCreditCardForOrganizationSuccessResult = {
  __typename?: 'DeleteCreditCardForOrganizationSuccessResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteCreditCardInput = {
  id: Scalars['String']['input'];
};

export type DeleteCreditCardResult = DeleteCreditCardSuccessResult | Error | FinalCardDeletionError;

export type DeleteCreditCardSuccessResult = {
  __typename?: 'DeleteCreditCardSuccessResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteDiscountTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteDiscountTypeResult = {
  __typename?: 'DeleteDiscountTypeResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteIntroRequestByIdInput = {
  id: Scalars['String']['input'];
};

export type DeleteIntroRequestByIdResult = {
  __typename?: 'DeleteIntroRequestByIdResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteMatchDocumentInput = {
  matchDocumentId: Scalars['String']['input'];
};

export type DeleteOpportunitiesCandidateInput = {
  id: Scalars['String']['input'];
};

export type DeleteOpportunitiesCandidateResult = {
  __typename?: 'DeleteOpportunitiesCandidateResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOrganizationAdminInput = {
  id: Scalars['Int']['input'];
};

export type DeleteOrganizationInvoiceInput = {
  organizationInvoiceId: Scalars['String']['input'];
  voidReason?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteOrganizationInvoiceResult = {
  __typename?: 'DeleteOrganizationInvoiceResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationProgramInput = {
  programId: Scalars['String']['input'];
};

export type DeleteOrganizationProgramResult = {
  __typename?: 'DeleteOrganizationProgramResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOrganizationRateInput = {
  id: Scalars['String']['input'];
};

export type DeleteOrganizationRateResult = {
  __typename?: 'DeleteOrganizationRateResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOrganizationSuperviseeOnboardingRequestInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationSuperviseeOnboardingRequestResult = {
  __typename?: 'DeleteOrganizationSuperviseeOnboardingRequestResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOrganizationUserInput = {
  id: Scalars['Int']['input'];
  removalReasonId: Scalars['Int']['input'];
  removalReasonText?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteSupervisionGoalInput = {
  id: Scalars['Int']['input'];
};

export type DeleteSupervisionGoalResult = {
  __typename?: 'DeleteSupervisionGoalResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteSupervisorIncidentInput = {
  supervisorIncidentId: Scalars['Int']['input'];
};

export type DeleteUserConfirmation = {
  __typename?: 'DeleteUserConfirmation';
  activeMatchesCount: Scalars['Int']['output'];
  declinedChargesCount: Scalars['Int']['output'];
  upcomingSessionsCount: Scalars['Int']['output'];
};

export type DeleteUserDocumentInput = {
  id: Scalars['String']['input'];
};

export type DeleteUserDocumentResult = {
  __typename?: 'DeleteUserDocumentResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUserHolidayBonusGoalExtraSessionCreditInput = {
  id: Scalars['Int']['input'];
};

export type DeleteUserHolidayBonusGoalInput = {
  id: Scalars['Int']['input'];
};

export type DeleteUserInput = {
  blockUser?: InputMaybe<Scalars['Boolean']['input']>;
  deleteReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  userDeleteReasonId: Scalars['Int']['input'];
};

export type DeleteUserResult = {
  __typename?: 'DeleteUserResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUsersLicenseMonitorInput = {
  usersLicenseId: Scalars['Int']['input'];
};

export type DiscountType = {
  __typename?: 'DiscountType';
  amountInCentsOff?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  maxUses: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Int']['output']>;
};

export type EditLicensePairingNoteInput = {
  id: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  superviseeLicenseCategoryId: Scalars['Int']['input'];
  superviseeSpecificLicenseId: Scalars['Int']['input'];
  supervisorCredentialId?: InputMaybe<Scalars['Int']['input']>;
  supervisorLicenseCategoryId: Scalars['Int']['input'];
  supervisorSpecificLicenseId: Scalars['Int']['input'];
  usStateId: Scalars['Int']['input'];
};

export type EditSupervisionRuleInput = {
  additionalSupervisionNotes?: InputMaybe<Scalars['String']['input']>;
  boardApprovalAdditionalNotes?: InputMaybe<Scalars['String']['input']>;
  boardApprovalForms?: InputMaybe<Scalars['String']['input']>;
  boardApprovalReference?: InputMaybe<Scalars['String']['input']>;
  boardApprovalRequired?: InputMaybe<Scalars['String']['input']>;
  dyadHoursRequired?: InputMaybe<Scalars['String']['input']>;
  groupHoursRequired?: InputMaybe<Scalars['String']['input']>;
  groupSize?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  individualHoursRequired?: InputMaybe<Scalars['String']['input']>;
  licenseCategoryId: Scalars['Int']['input'];
  minimumSupervisionFrequency?: InputMaybe<Scalars['String']['input']>;
  stateSpecificLicense: Scalars['String']['input'];
  supervisionAgreementRequired?: InputMaybe<Scalars['String']['input']>;
  supervisionRulesReferences: Scalars['String']['input'];
  supervisionTotalHoursRequired: Scalars['String']['input'];
  telesupervisionBoardContact: Scalars['String']['input'];
  telesupervisionLastUpdatedOn: Scalars['String']['input'];
  telesupervisionMotivoAssessment: Scalars['String']['input'];
  telesupervisionRuleDetails: Scalars['String']['input'];
  telesupervisionRuleLocation: Scalars['String']['input'];
  telesupervisionRuleUrl: Scalars['String']['input'];
  usStateId: Scalars['Int']['input'];
};

export type EmailInformationActivity = {
  __typename?: 'EmailInformationActivity';
  clicksCount: Scalars['Int']['output'];
  lastEventTime: Scalars['Date']['output'];
  msgId: Scalars['String']['output'];
  opensCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type EmailInformationBounce = {
  __typename?: 'EmailInformationBounce';
  created: Scalars['Date']['output'];
  reason: Scalars['String']['output'];
};

export type EmailInformationInput = {
  userId: Scalars['Int']['input'];
  userType: UserTypeEnum;
};

export type EmailInformationResult = {
  __typename?: 'EmailInformationResult';
  activities: Array<EmailInformationActivity>;
  bounce?: Maybe<EmailInformationBounce>;
  suppressions: Array<EmailInformationSuppression>;
};

export type EmailInformationSuppression = {
  __typename?: 'EmailInformationSuppression';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  contactAllowed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type EmergencyContactInput = {
  contactAllowed: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type EnrollUserInCourseInput = {
  courseId: Scalars['String']['input'];
};

export type EnrollUserInCourseResult = {
  __typename?: 'EnrollUserInCourseResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EnrolledCoursesResult = {
  __typename?: 'EnrolledCoursesResult';
  result: Array<Course>;
  total: Scalars['Int']['output'];
};

export type Error = BaseError & {
  __typename?: 'Error';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type EsignDocument = {
  __typename?: 'EsignDocument';
  dropboxSignSignatureId: Scalars['String']['output'];
  dropboxSignSignatureRequestId: Scalars['String']['output'];
  esignDocumentType: EsignDocumentType;
  esignDocumentTypeId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  signUrl?: Maybe<Scalars['String']['output']>;
  signedOn?: Maybe<Scalars['String']['output']>;
  signedPdfUrl?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type EsignDocumentType = {
  __typename?: 'EsignDocumentType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ExpressInterestForOpportunityInput = {
  opportunityId: Scalars['String']['input'];
};

export type ExpressInterestForOpportunityResult = {
  __typename?: 'ExpressInterestForOpportunityResult';
  error?: Maybe<Scalars['String']['output']>;
  isImmediatelyEvaluating?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalSupervisorRequest = {
  __typename?: 'ExternalSupervisorRequest';
  createdAt: Scalars['Date']['output'];
  desiredStartDate?: Maybe<Scalars['String']['output']>;
  externalSupervisorRequestCandidates: Array<ExternalSupervisorRequestCandidate>;
  externalSupervisorRequestComments: Array<Comment>;
  externalSupervisorRequestSource?: Maybe<ExternalSupervisorRequestSource>;
  externalSupervisorRequestSourceId?: Maybe<Scalars['Int']['output']>;
  externalSupervisorRequestStatus: ExternalSupervisorRequestStatus;
  externalSupervisorRequestStatusId: Scalars['Int']['output'];
  externalSupervisorRequestUrgency: ExternalSupervisorRequestUrgency;
  externalSupervisorRequestUrgencyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSpecialtyRequest: Scalars['Boolean']['output'];
  licenseCategory: LicenseCategory;
  licenseCategoryId: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  numberOfSupervisees?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  sessionTypeIds: Array<Scalars['Int']['output']>;
  submittedByAdmin: Admin;
  submittedByAdminId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  usState: UsState;
  usStateId: Scalars['Int']['output'];
};

export type ExternalSupervisorRequestCandidate = {
  __typename?: 'ExternalSupervisorRequestCandidate';
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  externalSupervisorRequestId: Scalars['Int']['output'];
  externalSupervisorRequestSource: ExternalSupervisorRequestSource;
  externalSupervisorRequestSourceId: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  supervisorApplication?: Maybe<SupervisorApplication>;
  supervisorApplicationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ExternalSupervisorRequestCandidateMaskedEmailByIdResult = {
  __typename?: 'ExternalSupervisorRequestCandidateMaskedEmailByIdResult';
  maskedEmail: Scalars['String']['output'];
};

export type ExternalSupervisorRequestSource = {
  __typename?: 'ExternalSupervisorRequestSource';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ExternalSupervisorRequestStatus = {
  __typename?: 'ExternalSupervisorRequestStatus';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ExternalSupervisorRequestUrgency = {
  __typename?: 'ExternalSupervisorRequestUrgency';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ExternalSupervisorRequestsResult = {
  __typename?: 'ExternalSupervisorRequestsResult';
  result: Array<ExternalSupervisorRequest>;
  total: Scalars['Int']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  everyone: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  userIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type FeatureFlagsQueryResult = {
  __typename?: 'FeatureFlagsQueryResult';
  flags?: Maybe<Array<FeatureFlag>>;
};

export type FinalCardDeletionError = BaseError & {
  __typename?: 'FinalCardDeletionError';
  finalCardDeletionError?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FinalizeSessionInput = {
  sessionAttendance: Array<SessionAttendeeInputType>;
  sessionId: Scalars['Int']['input'];
  sessionNotes?: InputMaybe<Array<SessionNoteInput>>;
  verifiedNoPHI?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinalizeSessionResult = {
  __typename?: 'FinalizeSessionResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FindOrCreateChatInput = {
  otherActorIds: Array<Scalars['Int']['input']>;
};

export type FindOrCreateChatResult = {
  __typename?: 'FindOrCreateChatResult';
  id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ForceRunChronosJobInput = {
  jobName: Scalars['String']['input'];
};

export type Form = {
  __typename?: 'Form';
  formVersions?: Maybe<Array<FormVersion>>;
  graded: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publishedFormVersion?: Maybe<FormVersion>;
  questions?: Maybe<Array<FormQuestion>>;
};

export type FormAnswer = {
  __typename?: 'FormAnswer';
  formQuestionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FormQuestion = FreeTextQuestion | LikertScaleQuestion | MultipleChoiceQuestion | TrueFalseQuestion;

export type FormQuestionChoice = {
  isCorrect: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum FormQuestionTypeEnum {
  FreeText = 'FREE_TEXT',
  LikertScale = 'LIKERT_SCALE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  TrueFalse = 'TRUE_FALSE'
}

export type FormResponse = {
  __typename?: 'FormResponse';
  answers?: Maybe<Array<FormAnswer>>;
  id: Scalars['String']['output'];
  passing?: Maybe<Scalars['Boolean']['output']>;
  scorePercentage?: Maybe<Scalars['Float']['output']>;
};

export type FormVersion = {
  __typename?: 'FormVersion';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  passingPercentage?: Maybe<Scalars['Int']['output']>;
  published: Scalars['Boolean']['output'];
  questions?: Maybe<Array<FormQuestion>>;
};

export type FormsResult = {
  __typename?: 'FormsResult';
  result: Array<Form>;
  total: Scalars['Int']['output'];
};

export type FreeTextInputQuestion = {
  question: Scalars['String']['input'];
  questionTypeId: Scalars['Int']['input'];
  sort: Scalars['Int']['input'];
};

export type FreeTextQuestion = {
  __typename?: 'FreeTextQuestion';
  id: Scalars['String']['output'];
  question: Scalars['String']['output'];
  questionTypeId: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
};

export type Frequency = {
  __typename?: 'Frequency';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum FromMotivoProduct {
  ContinuingEducation = 'CONTINUING_EDUCATION',
  Supervision = 'SUPERVISION'
}

export type FrontSignatureDetails = {
  __typename?: 'FrontSignatureDetails';
  frontChatId: Scalars['String']['output'];
  frontUserHash: Scalars['String']['output'];
};

export type GenerateOrganizationInvoiceInput = {
  month: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type GrantDiscountByState = {
  __typename?: 'GrantDiscountByState';
  result: Array<OrganizationGrantDiscount>;
  usState: UsState;
  usStateId?: Maybe<Scalars['Int']['output']>;
};

export type GrantType = {
  __typename?: 'GrantType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GroupedOrganizationMatches = {
  __typename?: 'GroupedOrganizationMatches';
  matches: Array<Match>;
  organization?: Maybe<Organization>;
};

export type IncidentReportMethod = {
  __typename?: 'IncidentReportMethod';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type IncidentReportStatus = {
  __typename?: 'IncidentReportStatus';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type IncidentReporter = {
  __typename?: 'IncidentReporter';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type IntroRequest = {
  __typename?: 'IntroRequest';
  assignedAdmin?: Maybe<Admin>;
  availableSlots: Array<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  introRequestDeclineReasonId?: Maybe<Scalars['Int']['output']>;
  introRequestNoShowFee?: Maybe<IntroRequestNoShowFee>;
  introRequestOrganizationInfo?: Maybe<IntroRequestOrganizationInfo>;
  introRequestStatusId: Scalars['Int']['output'];
  joinUrl?: Maybe<Scalars['String']['output']>;
  match?: Maybe<Match>;
  meetingUrl?: Maybe<Scalars['String']['output']>;
  opportunitiesCandidate?: Maybe<OpportunitiesCandidate>;
  organizationAdmin?: Maybe<OrganizationAdmin>;
  organizationAdminId?: Maybe<Scalars['Int']['output']>;
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  supervisee?: Maybe<User>;
  superviseeUserId?: Maybe<Scalars['Int']['output']>;
  supervisor: User;
  supervisorUserId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type IntroRequestDeclineReason = {
  __typename?: 'IntroRequestDeclineReason';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type IntroRequestNoShowFee = {
  __typename?: 'IntroRequestNoShowFee';
  amountInCents: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type IntroRequestOrganizationInfo = {
  __typename?: 'IntroRequestOrganizationInfo';
  additionalDetails?: Maybe<Scalars['String']['output']>;
  clinicalQuestions?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  introRequestId?: Maybe<Scalars['String']['output']>;
  organizationAdminId?: Maybe<Scalars['Int']['output']>;
  sessionTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
  superviseeInfo?: Maybe<Scalars['String']['output']>;
  supervisionStartTime?: Maybe<Scalars['String']['output']>;
  weeklyHours?: Maybe<Scalars['Int']['output']>;
};

export type IntroRequestsForAdminResult = {
  __typename?: 'IntroRequestsForAdminResult';
  result: Array<IntroRequest>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type IntroRequestsResult = {
  __typename?: 'IntroRequestsResult';
  result?: Maybe<Array<IntroRequest>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type JobListing = {
  __typename?: 'JobListing';
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  descriptionMarkdown: Scalars['String']['output'];
  externalJobId?: Maybe<Scalars['String']['output']>;
  externalJobUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  internalJobId: Scalars['String']['output'];
  jobListingLocation?: Maybe<JobListingLocation>;
  jobListingLocationId?: Maybe<Scalars['Int']['output']>;
  licenseCategories: Array<LicenseCategory>;
  location?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  salary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  usState: UsState;
  usStateId: Scalars['Int']['output'];
};

export type JobListingLocation = {
  __typename?: 'JobListingLocation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type JobListingSearchOptionsResult = {
  __typename?: 'JobListingSearchOptionsResult';
  licenseCategories: Array<LicenseCategory>;
  usStates: Array<UsState>;
};

export type Language = {
  __typename?: 'Language';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LatLng = {
  __typename?: 'LatLng';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LevelOfEffort = {
  __typename?: 'LevelOfEffort';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type License = {
  __typename?: 'License';
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCertification: Scalars['Boolean']['output'];
  licenseCategory: LicenseCategory;
  licenseCategoryId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LicenseCategory = {
  __typename?: 'LicenseCategory';
  abbreviation: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type LikertScaleInputQuestion = {
  choices: LikertScaleInputQuestionChoice;
  question: Scalars['String']['input'];
  questionTypeId: Scalars['Int']['input'];
  sort: Scalars['Int']['input'];
};

export type LikertScaleInputQuestionChoice = {
  from: Scalars['Int']['input'];
  fromLabel: Scalars['String']['input'];
  to: Scalars['Int']['input'];
  toLabel: Scalars['String']['input'];
};

export type LikertScaleQuestion = {
  __typename?: 'LikertScaleQuestion';
  choices: LikertScaleQuestionChoice;
  id: Scalars['String']['output'];
  question: Scalars['String']['output'];
  questionTypeId: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
};

export type LikertScaleQuestionChoice = {
  __typename?: 'LikertScaleQuestionChoice';
  from: Scalars['Int']['output'];
  fromLabel: Scalars['String']['output'];
  to: Scalars['Int']['output'];
  toLabel: Scalars['String']['output'];
};

export type MarkEsignDocumentSignedInput = {
  id: Scalars['String']['input'];
};

export type MarkEsignDocumentSignedResult = {
  __typename?: 'MarkEsignDocumentSignedResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum MarkLiveCourseAttendedError {
  JoinedTooEarly = 'JOINED_TOO_EARLY',
  JoinedTooLate = 'JOINED_TOO_LATE'
}

export type MarkLiveCourseAttendedErrorResult = {
  __typename?: 'MarkLiveCourseAttendedErrorResult';
  course: Course;
  error?: Maybe<MarkLiveCourseAttendedError>;
};

export type MarkLiveCourseAttendedInput = {
  id: Scalars['String']['input'];
};

export type MarkLiveCourseAttendedNotEnrolledErrorResult = {
  __typename?: 'MarkLiveCourseAttendedNotEnrolledErrorResult';
  notEnrolled: Scalars['Boolean']['output'];
};

export type MarkLiveCourseAttendedResult = MarkLiveCourseAttendedErrorResult | MarkLiveCourseAttendedNotEnrolledErrorResult | MarkLiveCourseAttendedSuccessResult;

export type MarkLiveCourseAttendedSuccessResult = {
  __typename?: 'MarkLiveCourseAttendedSuccessResult';
  courseLiveJoinUrl?: Maybe<Scalars['String']['output']>;
};

export type Match = {
  __typename?: 'Match';
  createdAt: Scalars['Date']['output'];
  deactivatedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  matchStatusId: Scalars['Int']['output'];
  matchableId: Scalars['Int']['output'];
  recommendation?: Maybe<Recommendation>;
  sessionRate?: Maybe<SessionRate>;
  sessionRateId: Scalars['Int']['output'];
  supervisee: User;
  supervisor: User;
  supervisorId: Scalars['Int']['output'];
};

export type MatchDocument = {
  __typename?: 'MatchDocument';
  createdAt: Scalars['Date']['output'];
  createdByUserId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  matchId: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type MatchDocumentResults = {
  __typename?: 'MatchDocumentResults';
  result: Array<MatchDocument>;
};

export type MatchStatus = {
  __typename?: 'MatchStatus';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MatchSupervisorForOpportunityInput = {
  opportunityId: Scalars['String']['input'];
  superviseeUserIds: Array<Scalars['Int']['input']>;
  supervisorUserId: Scalars['Int']['input'];
};

export type MatchSupervisorForOpportunityResult = {
  __typename?: 'MatchSupervisorForOpportunityResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MatchesByUserIdResult = {
  __typename?: 'MatchesByUserIdResult';
  superviseeMatches: Array<Match>;
  supervisorMatches: Array<Match>;
};

export type MatchesForSuperviseeHoursResult = {
  __typename?: 'MatchesForSuperviseeHoursResult';
  matches: Array<Match>;
  unmatched: Array<User>;
};

export type MatchesResult = {
  __typename?: 'MatchesResult';
  superviseeMatches: Array<Match>;
  supervisorMatches: Array<Match>;
};

export type Modality = {
  __typename?: 'Modality';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ModerateRecommendationInput = {
  approved: Scalars['Boolean']['input'];
  recommendationId: Scalars['String']['input'];
};

export type ModerateRecommendationResult = {
  __typename?: 'ModerateRecommendationResult';
  success: Scalars['Boolean']['output'];
};

export type MultipleChoiceInputQuestion = {
  choices: MultipleChoiceInputQuestionChoices;
  question: Scalars['String']['input'];
  questionTypeId: Scalars['Int']['input'];
  sort: Scalars['Int']['input'];
};

export type MultipleChoiceInputQuestionChoices = {
  isCorrect: Scalars['Int']['input'];
  options: Array<MultipleChoiceInputQuestionOption>;
};

export type MultipleChoiceInputQuestionOption = {
  key: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultipleChoiceQuestion = {
  __typename?: 'MultipleChoiceQuestion';
  choices: MultipleChoiceQuestionChoices;
  id: Scalars['String']['output'];
  question: Scalars['String']['output'];
  questionTypeId: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
};

export type MultipleChoiceQuestionChoices = {
  __typename?: 'MultipleChoiceQuestionChoices';
  isCorrect: Scalars['Int']['output'];
  options: Array<MultipleChoiceQuestionOption>;
};

export type MultipleChoiceQuestionOption = {
  __typename?: 'MultipleChoiceQuestionOption';
  key: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptIntroRequestForMatch?: Maybe<AcceptIntroRequestForMatchResult>;
  addFormQuestion?: Maybe<AddFormQuestionResult>;
  addLicensePairingNote?: Maybe<SuccessMutationResult>;
  addOrganizationUserToMatchQueue?: Maybe<SuccessMutationResult>;
  addSupervisionRule?: Maybe<SuccessMutationResult>;
  approveProposedSession?: Maybe<SuccessMutationResult>;
  approveSupervisee?: Maybe<ApproveSuperviseeResult>;
  approveSuperviseeMatch?: Maybe<ApproveSuperviseeMatchResult>;
  approveSupervisorApplicationForOpportunity?: Maybe<ApproveSupervisorApplicationForOpportunityResult>;
  assignDiscountToUser?: Maybe<AssignDiscountToUserResult>;
  assignOrganizationProgramDirector?: Maybe<AssignOrganizationProgramDirectorResult>;
  cancelChronosTask?: Maybe<CancelChronosTaskMutationResult>;
  cancelEmailChange?: Maybe<SuccessMutationResult>;
  cancelScheduledOrganizationUserRemoval?: Maybe<CancelScheduledOrganizationUserRemovalResult>;
  cancelSession?: Maybe<SuccessWithErrorMessageMutationResult>;
  cancelSubscription?: Maybe<CancelSubscriptionResult>;
  churnOrganization?: Maybe<SuccessMutationResult>;
  closeOpportunity?: Maybe<CloseOpportunityResult>;
  confirmEmailChange?: Maybe<SuccessMutationResult>;
  createAccount?: Maybe<CreateAccountResult>;
  createAccountFromSupervisorApplicationUser: CreateAccountFromSupervisorApplicationUserResult;
  createAdmin?: Maybe<CreateAdminResult>;
  createB2BMatch?: Maybe<CreateB2BMatchResult>;
  createBillableWorkAssignee?: Maybe<CreateBillableWorkAssigneeResult>;
  createBillableWorkRecord: CreateBillableWorkRecordResult;
  createComment?: Maybe<SuccessMutationResult>;
  createCourse?: Maybe<CreateCourseResult>;
  createCourseContent?: Maybe<CreateCourseContentResult>;
  createCredentialingBodyAccreditation?: Maybe<CreateCredentialingBodyAccreditationResult>;
  createCreditCard?: Maybe<CreateCreditCardResult>;
  createCreditCardForOrganization?: Maybe<CreateCreditCardForOrganizationResult>;
  createCreditNote?: Maybe<CreateCreditNoteResult>;
  createDiscountType?: Maybe<CreateDiscountTypeResult>;
  createExternalSupervisorRequest: SuccessMutationResult;
  createExternalSupervisorRequestCandidate?: Maybe<SuccessMutationResult>;
  createExternalSupervisorRequestComment?: Maybe<SuccessMutationResult>;
  createForm?: Maybe<CreateFormResult>;
  createIntroRequest: CreateIntroRequestResult;
  createIntroRequestOrganizationInfo?: Maybe<CreateIntroRequestOrganizationInfoResult>;
  createJobListing?: Maybe<SuccessMutationResult>;
  createLicense?: Maybe<CreateLicenseResult>;
  createMatchDocument?: Maybe<SuccessMutationResult>;
  createOnePager?: Maybe<CreateOnePagerResult>;
  createOpportunitiesCandidate?: Maybe<CreateOpportunitiesCandidateResult>;
  createOpportunity?: Maybe<CreateOpportunityResult>;
  createOrActivateMatch?: Maybe<CreateOrActivateMatchResult>;
  createOrActivateOrganizationMatch?: Maybe<CreateOrActivateOrganizationMatchResult>;
  createOrUpdateSessionAttendeeNpsResponse?: Maybe<SuccessMutationResult>;
  createOrUpdateSessionNoteDrafts?: Maybe<CreateOrUpdateSessionNoteDraftsResult>;
  createOrganization?: Maybe<CreateOrganizationResult>;
  createOrganizationAdmin?: Maybe<CreateOrganizationAdminResult>;
  createOrganizationContinuingEducationUser?: Maybe<CreateOrganizationContinuingEducationUserResult>;
  createOrganizationGrant?: Maybe<SuccessWithErrorMessageMutationResult>;
  createOrganizationGrantDiscount?: Maybe<SuccessWithErrorMessageMutationResult>;
  createOrganizationOnboardingRequest?: Maybe<CreateOrganizationOnboardingRequestResult>;
  createOrganizationProgram?: Maybe<CreateOrganizationProgramResult>;
  createOrganizationUser?: Maybe<SuccessWithErrorMessageMutationResult>;
  createPanelist?: Maybe<CreatePanelistResult>;
  createSession?: Maybe<CreateSessionResult>;
  createSessionNotes?: Maybe<CreateSessionNotesResult>;
  createSetupIntent?: Maybe<CreateSetupIntentResult>;
  createSetupIntentForOrganization?: Maybe<CreateSetupIntentForOrganizationResult>;
  createSignedUrlForUploadMutation?: Maybe<CreateSignedUrlForUploadMutationResult>;
  createSubscription?: Maybe<CreateSubscriptionResult>;
  createSupervisionCredential?: Maybe<CreateSupervisionCredentialResult>;
  createSupervisionGoal?: Maybe<CreateSupervisionGoalResult>;
  createSupervisorIncident?: Maybe<SuccessMutationResult>;
  createSupervisorIncidentStrike?: Maybe<SuccessMutationResult>;
  createTopic?: Maybe<CreateTopicResult>;
  createUserAvailabilities?: Maybe<CreateUserAvailabilitiesResult>;
  createUserDocument?: Maybe<CreateUserDocumentResult>;
  createUserFromSupervisorApplication: CreateUserFromSupervisorApplicationResult;
  createUserHolidayBonusGoal?: Maybe<SuccessWithErrorMessageMutationResult>;
  createUserHolidayBonusGoalExtraSessionCredit?: Maybe<SuccessMutationResult>;
  createUsersForOrganization?: Maybe<CreateUsersForOrganizationResult>;
  createZoomCredentialsForSession: CreateZoomCredentialsForSessionMutationResult;
  deactivateMatch?: Maybe<DeactivateMatchResult>;
  deactivateOrganizationMatch?: Maybe<DeactivateOrganizationMatchResult>;
  declineIntroRequest?: Maybe<DeclineIntroRequestResult>;
  declineOpportunitiesCandidate?: Maybe<DeclineOpportunitiesCandidateResult>;
  declineOrCancelProposedSession?: Maybe<SuccessMutationResult>;
  declineSuperviseeMatch?: Maybe<DeclineSuperviseeMatchResult>;
  declineSupervisorApplication?: Maybe<DeclineSupervisorApplicationResult>;
  deleteAdmin?: Maybe<DeleteAdminResult>;
  deleteAllDiscountsForOrganization?: Maybe<SuccessMutationResult>;
  deleteBillableWorkAssignee?: Maybe<DeleteBillableWorkAssigneeResult>;
  deleteBillableWorkRecordById: DeleteBillableWorkRecordByIdResult;
  deleteCreditCard?: Maybe<DeleteCreditCardResult>;
  deleteCreditCardForOrganization?: Maybe<DeleteCreditCardForOrganizationResult>;
  deleteDiscountType?: Maybe<DeleteDiscountTypeResult>;
  deleteIntroRequestById?: Maybe<DeleteIntroRequestByIdResult>;
  deleteJobListing?: Maybe<SuccessMutationResult>;
  deleteMatchDocument?: Maybe<SuccessMutationResult>;
  deleteOpportunitiesCandidate?: Maybe<DeleteOpportunitiesCandidateResult>;
  deleteOrganizationAdmin: SuccessMutationResult;
  deleteOrganizationInvoice?: Maybe<DeleteOrganizationInvoiceResult>;
  deleteOrganizationProgram?: Maybe<DeleteOrganizationProgramResult>;
  deleteOrganizationRate?: Maybe<DeleteOrganizationRateResult>;
  deleteOrganizationSuperviseeOnboardingRequest?: Maybe<DeleteOrganizationSuperviseeOnboardingRequestResult>;
  deleteOrganizationUser?: Maybe<SuccessMutationResult>;
  deleteSupervisionGoal?: Maybe<DeleteSupervisionGoalResult>;
  deleteSupervisorIncident?: Maybe<SuccessMutationResult>;
  deleteUser?: Maybe<DeleteUserResult>;
  deleteUserDocument?: Maybe<DeleteUserDocumentResult>;
  deleteUserHolidayBonusGoal?: Maybe<SuccessMutationResult>;
  deleteUserHolidayBonusGoalExtraSessionCredit?: Maybe<SuccessMutationResult>;
  deleteUsersLicenseMonitor?: Maybe<SuccessMutationResult>;
  editLicensePairingNote?: Maybe<SuccessMutationResult>;
  editSupervisionRule?: Maybe<SuccessMutationResult>;
  enrollUserInCourse?: Maybe<EnrollUserInCourseResult>;
  expressInterestForOpportunity?: Maybe<ExpressInterestForOpportunityResult>;
  finalizeSession?: Maybe<FinalizeSessionResult>;
  findOrCreateChat: FindOrCreateChatResult;
  findOrCreateRequiredEsignDocuments: Array<EsignDocument>;
  forceRunChronosJob?: Maybe<SuccessMutationResult>;
  generateOrganizationInvoice?: Maybe<SuccessWithErrorMessageMutationResult>;
  markEsignDocumentSigned?: Maybe<MarkEsignDocumentSignedResult>;
  markLiveCourseAttended?: Maybe<MarkLiveCourseAttendedResult>;
  matchSupervisorForOpportunity?: Maybe<MatchSupervisorForOpportunityResult>;
  moderateRecommendation?: Maybe<ModerateRecommendationResult>;
  pauseUserSupervision?: Maybe<SuccessMutationResult>;
  proposeOrCreateSession?: Maybe<ProposeOrCreateSessionResult>;
  publishCourse?: Maybe<PublishCourseResult>;
  publishFormVersion?: Maybe<PublishFormVersionResult>;
  publishJobListing?: Maybe<SuccessMutationResult>;
  reactivateSubscription?: Maybe<ReactivateSubscriptionResult>;
  refundPayment?: Maybe<RefundPaymentResult>;
  regenerateOrganizationInvoice?: Maybe<RegenerateOrganizationInvoiceResult>;
  removeBounceByUserId?: Maybe<RemoveBounceByUserIdResult>;
  removeSelfFromSession?: Maybe<RemoveSelfFromSessionResult>;
  removeUserFromSuppressionGroup?: Maybe<RemoveUserFromSuppressionGroupResult>;
  requestEmailChange?: Maybe<SuccessMutationResult>;
  requestOpportunitiesCandidate?: Maybe<RequestOpportunitiesCandidateResult>;
  requestOpportunitiesCandidateSupport?: Maybe<RequestOpportunitiesCandidateSupportResult>;
  requestRecommendation?: Maybe<RequestRecommendationResult>;
  requestSupervisorTermination?: Maybe<RequestSupervisorTerminationResult>;
  resendTransactionReceipt?: Maybe<ResendTransactionReceiptResult>;
  resetAdminPassword?: Maybe<ResetAdminPasswordResult>;
  resetNewUserPassword?: Maybe<ResetNewUserPasswordResult>;
  resetOrganizationAdminPassword?: Maybe<ResetPasswordResult>;
  resetUserPassword?: Maybe<ResetPasswordResult>;
  resumeUserSupervision?: Maybe<SuccessMutationResult>;
  retryCharge?: Maybe<RetryChargeResult>;
  revokeOAuthToken?: Maybe<SuccessMutationResult>;
  scheduleIntroRequest?: Maybe<ScheduleIntroRequestResult>;
  scheduleOrganizationUserForRemoval?: Maybe<ScheduleOrganizationUserForRemovalResult>;
  sendIntroCallRequestForOpportunity?: Maybe<SuccessMutationResult>;
  sendMissingAttendanceEmail: SendMissingAttendanceEmailResult;
  sendMissingNotesNotification?: Maybe<SendMissingNotesNotificationResult>;
  sendOrganizationInvoice?: Maybe<SendOrganizationInvoiceResult>;
  sendResetOrganizationAdminPasswordEmail?: Maybe<SendResetOrganizationAdminPasswordEmailResult>;
  sendSupervisorApplicationApproval?: Maybe<SuccessWithErrorMessageMutationResult>;
  setHighPriorityStateLicenseCategoryCombination?: Maybe<SuccessMutationResult>;
  setPreferredCreditCard?: Maybe<SetPreferredCreditCardResult>;
  setPreferredCreditCardForOrganization?: Maybe<SetPreferredCreditCardForOrganizationResult>;
  signSessionNotesAsSupervisee?: Maybe<SignSessionNotesAsSuperviseeResult>;
  submitCourseForm?: Maybe<SubmitCourseFormResult>;
  suggestAlternateIntroRequestTimes?: Maybe<SuggestAlternateIntroRequestTimesResult>;
  toggleOpportunityAutoRequest?: Maybe<SuccessMutationResult>;
  unenrollUserFromCourse?: Maybe<UnenrollUserFromCourseResult>;
  unpublishSupervisorProfile?: Maybe<UnpublishSupervisorProfileResult>;
  updateAdminProfile?: Maybe<UpdateAdminProfileResult>;
  updateBillableWorkAssigneeById?: Maybe<UpdateBillableWorkAssigneeByIdResult>;
  updateCourse?: Maybe<UpdateCourseResult>;
  updateCourseFormResponseProgress?: Maybe<UpdateCourseFormResponseProgressResult>;
  updateCourseThumbnail?: Maybe<UpdateCourseThumbnailResult>;
  updateCredentialingBodyAccreditation?: Maybe<UpdateCredentialingBodyAccreditationResult>;
  updateExternalSupervisorRequest: SuccessMutationResult;
  updateForm?: Maybe<UpdateFormResult>;
  updateInternalUserNotes?: Maybe<UpdateInternalUserNotesResult>;
  updateIntroRequestById?: Maybe<UpdateIntroRequestByIdResult>;
  updateIntroRequestOrganizationInfo?: Maybe<UpdateIntroRequestOrganizationInfoResult>;
  updateJobListing?: Maybe<SuccessMutationResult>;
  updateMatchDocument?: Maybe<SuccessMutationResult>;
  updateNotificationSubscriptions?: Maybe<UpdateNotificationSubscriptionsResult>;
  updateOpportunitiesCandidate?: Maybe<UpdateOpportunitiesCandidateResult>;
  updateOpportunity?: Maybe<UpdateOpportunityResult>;
  updateOrganization?: Maybe<UpdateOrganizationResult>;
  updateOrganizationAdmin?: Maybe<UpdateOrganizationAdminResult>;
  updateOrganizationAdminProfile?: Maybe<UpdateOrganizationAdminProfileResult>;
  updateOrganizationCheckInsPreference?: Maybe<SuccessMutationResult>;
  updateOrganizationGrant?: Maybe<SuccessMutationResult>;
  updateOrganizationProgramName?: Maybe<SuccessMutationResult>;
  updateOrganizationProgramSettings?: Maybe<SuccessMutationResult>;
  updateOrganizationSuperviseeOnboardingRequest?: Maybe<SuccessMutationResult>;
  updateOrganizationUserBillingCode?: Maybe<UpdateOrganizationUserBillingCodeResult>;
  updateOrganizationUserDiscount?: Maybe<SuccessWithErrorMessageMutationResult>;
  updatePanelist?: Maybe<UpdatePanelistResult>;
  updateProfile?: Maybe<UpdateProfileResult>;
  updateSession?: Maybe<UpdateSessionResult>;
  updateSessionForAdmin?: Maybe<UpdateSessionForAdminResult>;
  updateSignature?: Maybe<UpdateSignatureResult>;
  updateStripeAccount?: Maybe<UpdateStripeAccountMutationResult>;
  updateSuperviseeExternalHours?: Maybe<UpdateSuperviseeExternalHoursResult>;
  updateSuperviseeOnboardingInfo?: Maybe<UpdateSuperviseeOnboardingInfoResult>;
  updateSuperviseeProgram?: Maybe<SuccessMutationResult>;
  updateSuperviseesInProgram?: Maybe<SuccessMutationResult>;
  updateSupervisionGoal?: Maybe<UpdateSupervisionGoalResult>;
  updateSupervisorBandwidth?: Maybe<UpdateSupervisorBandwidthResult>;
  updateSupervisorIncident?: Maybe<SuccessMutationResult>;
  updateSupervisorInformationByUserId?: Maybe<UpdateSupervisorInformationResult>;
  updateSupervisorVettingStartedByAdminId?: Maybe<SuccessMutationResult>;
  updateTopic?: Maybe<UpdateTopicResult>;
  updateUserFromSupervisorApplication: SuccessMutationResult;
  updateUserHolidayBonusGoal?: Maybe<SuccessMutationResult>;
  updateUserHolidayBonusGoalExtraSessionCredit?: Maybe<SuccessMutationResult>;
  updateUserNotificationPreferences: SuccessMutationResult;
  updateUserPrimaryCalendar?: Maybe<SuccessMutationResult>;
  updateUserProfile?: Maybe<UpdateUserProfileResult>;
  updateVettingNotesForSupervisor?: Maybe<SuccessMutationResult>;
  upsertFeatureFlag?: Maybe<UpsertFeatureFlagResult>;
  vetSupervisor?: Maybe<SuccessMutationResult>;
  writeRecommendation?: Maybe<WriteRecommendationResult>;
};


export type MutationAcceptIntroRequestForMatchArgs = {
  input: AcceptIntroRequestForMatchInput;
};


export type MutationAddFormQuestionArgs = {
  input: AddFormQuestionInput;
};


export type MutationAddLicensePairingNoteArgs = {
  input: AddLicensePairingNoteInput;
};


export type MutationAddOrganizationUserToMatchQueueArgs = {
  input?: InputMaybe<AddOrganizationUserToMatchQueueInput>;
};


export type MutationAddSupervisionRuleArgs = {
  input: AddSupervisionRuleInput;
};


export type MutationApproveProposedSessionArgs = {
  input: ApproveProposedSessionInput;
};


export type MutationApproveSuperviseeArgs = {
  input?: InputMaybe<ApproveSuperviseeInput>;
};


export type MutationApproveSuperviseeMatchArgs = {
  input: ApproveSuperviseeMatchInput;
};


export type MutationApproveSupervisorApplicationForOpportunityArgs = {
  input?: InputMaybe<ApproveSupervisorApplicationForOpportunityInput>;
};


export type MutationAssignDiscountToUserArgs = {
  input: AssignDiscountToUserInput;
};


export type MutationAssignOrganizationProgramDirectorArgs = {
  input?: InputMaybe<AssignOrganizationProgramDirectorInput>;
};


export type MutationCancelChronosTaskArgs = {
  chronosTaskId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCancelScheduledOrganizationUserRemovalArgs = {
  input?: InputMaybe<CancelScheduledOrganizationUserRemovalInput>;
};


export type MutationCancelSessionArgs = {
  input: CancelSessionInput;
};


export type MutationChurnOrganizationArgs = {
  input?: InputMaybe<ChurnOrganizationInput>;
};


export type MutationCloseOpportunityArgs = {
  input?: InputMaybe<CloseOpportunityInput>;
};


export type MutationConfirmEmailChangeArgs = {
  input: ConfirmEmailChangeInput;
};


export type MutationCreateAccountArgs = {
  input?: InputMaybe<CreateAccountInput>;
};


export type MutationCreateAccountFromSupervisorApplicationUserArgs = {
  input: CreateAccountFromSupervisorApplicationUserInput;
};


export type MutationCreateAdminArgs = {
  input?: InputMaybe<CreateAdminInput>;
};


export type MutationCreateB2BMatchArgs = {
  input: CreateB2BMatchInput;
};


export type MutationCreateBillableWorkAssigneeArgs = {
  input: CreateBillableWorkAssigneeInput;
};


export type MutationCreateBillableWorkRecordArgs = {
  input: CreateBillableWorkRecordInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
};


export type MutationCreateCourseContentArgs = {
  input: CreateCourseContentInput;
};


export type MutationCreateCredentialingBodyAccreditationArgs = {
  input: CreateCredentialingBodyAccreditationInput;
};


export type MutationCreateCreditCardArgs = {
  input?: InputMaybe<CreateCreditCardInput>;
};


export type MutationCreateCreditCardForOrganizationArgs = {
  input: CreateCreditCardForOrganizationInput;
};


export type MutationCreateCreditNoteArgs = {
  input?: InputMaybe<CreateCreditNoteInput>;
};


export type MutationCreateDiscountTypeArgs = {
  input: CreateDiscountTypeInput;
};


export type MutationCreateExternalSupervisorRequestArgs = {
  input: CreateExternalSupervisorRequestInput;
};


export type MutationCreateExternalSupervisorRequestCandidateArgs = {
  input: CreateExternalSupervisorRequestCandidateInput;
};


export type MutationCreateExternalSupervisorRequestCommentArgs = {
  input: CreateExternalSupervisorRequestCommentInput;
};


export type MutationCreateFormArgs = {
  input: CreateFormInput;
};


export type MutationCreateIntroRequestArgs = {
  input: CreateIntroRequestInput;
};


export type MutationCreateIntroRequestOrganizationInfoArgs = {
  input?: InputMaybe<CreateIntroRequestOrganizationInfoInput>;
};


export type MutationCreateJobListingArgs = {
  input: CreateJobListingInput;
};


export type MutationCreateLicenseArgs = {
  input: CreateLicenseInput;
};


export type MutationCreateMatchDocumentArgs = {
  input: CreateMatchDocumentInput;
};


export type MutationCreateOnePagerArgs = {
  input: CreateOnePagerInput;
};


export type MutationCreateOpportunitiesCandidateArgs = {
  input?: InputMaybe<CreateOpportunitiesCandidateInput>;
};


export type MutationCreateOpportunityArgs = {
  input?: InputMaybe<CreateOpportunityInput>;
};


export type MutationCreateOrActivateMatchArgs = {
  input: CreateOrActivateMatchInput;
};


export type MutationCreateOrActivateOrganizationMatchArgs = {
  input: CreateOrActivateOrganizationMatchInput;
};


export type MutationCreateOrUpdateSessionAttendeeNpsResponseArgs = {
  input: CreateOrUpdateSessionAttendeeNpsResponseInput;
};


export type MutationCreateOrUpdateSessionNoteDraftsArgs = {
  input: CreateOrUpdateSessionNoteDraftsInput;
};


export type MutationCreateOrganizationArgs = {
  input?: InputMaybe<CreateOrganizationInput>;
};


export type MutationCreateOrganizationAdminArgs = {
  input?: InputMaybe<CreateOrganizationAdminInput>;
};


export type MutationCreateOrganizationContinuingEducationUserArgs = {
  input: CreateOrganizationContinuingEducationUserInput;
};


export type MutationCreateOrganizationGrantArgs = {
  input: CreateOrganizationGrantInput;
};


export type MutationCreateOrganizationGrantDiscountArgs = {
  input: CreateOrganizationGrantDiscountInput;
};


export type MutationCreateOrganizationOnboardingRequestArgs = {
  input: CreateOrganizationOnboardingRequestInput;
};


export type MutationCreateOrganizationProgramArgs = {
  input?: InputMaybe<CreateOrganizationProgramInput>;
};


export type MutationCreateOrganizationUserArgs = {
  input?: InputMaybe<CreateOrganizationUserInput>;
};


export type MutationCreatePanelistArgs = {
  input: CreatePanelistInput;
};


export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};


export type MutationCreateSessionNotesArgs = {
  input: CreateSessionNoteInput;
};


export type MutationCreateSignedUrlForUploadMutationArgs = {
  input: CreateSignedUrlForUploadMutationInput;
};


export type MutationCreateSubscriptionArgs = {
  input?: InputMaybe<CreateSubscriptionInput>;
};


export type MutationCreateSupervisionCredentialArgs = {
  input: CreateSupervisionCredentialInput;
};


export type MutationCreateSupervisionGoalArgs = {
  input: CreateSupervisionGoalInput;
};


export type MutationCreateSupervisorIncidentArgs = {
  input: CreateSupervisorIncidentInput;
};


export type MutationCreateSupervisorIncidentStrikeArgs = {
  input: CreateSupervisorIncidentStrikeInput;
};


export type MutationCreateTopicArgs = {
  input: CreateTopicInput;
};


export type MutationCreateUserAvailabilitiesArgs = {
  input: CreateUserAvailabilitiesInput;
};


export type MutationCreateUserDocumentArgs = {
  input: CreateUserDocumentInput;
};


export type MutationCreateUserFromSupervisorApplicationArgs = {
  input: CreateUserFromSupervisorApplicationInput;
};


export type MutationCreateUserHolidayBonusGoalArgs = {
  input: CreateUserHolidayBonusGoalInput;
};


export type MutationCreateUserHolidayBonusGoalExtraSessionCreditArgs = {
  input: CreateUserHolidayBonusGoalExtraSessionCreditInput;
};


export type MutationCreateUsersForOrganizationArgs = {
  input?: InputMaybe<CreateUsersForOrganizationInput>;
};


export type MutationCreateZoomCredentialsForSessionArgs = {
  sessionId: Scalars['Int']['input'];
};


export type MutationDeactivateMatchArgs = {
  input: DeactivateMatchInput;
};


export type MutationDeactivateOrganizationMatchArgs = {
  input: DeactivateOrganizationMatchInput;
};


export type MutationDeclineIntroRequestArgs = {
  input: DeclineIntroRequestInput;
};


export type MutationDeclineOpportunitiesCandidateArgs = {
  input?: InputMaybe<DeclineOpportunitiesCandidateInput>;
};


export type MutationDeclineOrCancelProposedSessionArgs = {
  input: DeclineOrCancelProposedSessionInput;
};


export type MutationDeclineSuperviseeMatchArgs = {
  input: DeclineSuperviseeMatchInput;
};


export type MutationDeclineSupervisorApplicationArgs = {
  input?: InputMaybe<DeclineSupervisorApplicationInput>;
};


export type MutationDeleteAdminArgs = {
  input?: InputMaybe<DeleteAdminInput>;
};


export type MutationDeleteAllDiscountsForOrganizationArgs = {
  input?: InputMaybe<DeleteAllDiscountsForOrganizationInput>;
};


export type MutationDeleteBillableWorkAssigneeArgs = {
  input: DeleteBillableWorkAssigneeInput;
};


export type MutationDeleteBillableWorkRecordByIdArgs = {
  input?: InputMaybe<DeleteBillableWorkRecordByIdInput>;
};


export type MutationDeleteCreditCardArgs = {
  input?: InputMaybe<DeleteCreditCardInput>;
};


export type MutationDeleteCreditCardForOrganizationArgs = {
  input?: InputMaybe<DeleteCreditCardForOrganizationInput>;
};


export type MutationDeleteDiscountTypeArgs = {
  input?: InputMaybe<DeleteDiscountTypeInput>;
};


export type MutationDeleteIntroRequestByIdArgs = {
  input: DeleteIntroRequestByIdInput;
};


export type MutationDeleteJobListingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMatchDocumentArgs = {
  input: DeleteMatchDocumentInput;
};


export type MutationDeleteOpportunitiesCandidateArgs = {
  input?: InputMaybe<DeleteOpportunitiesCandidateInput>;
};


export type MutationDeleteOrganizationAdminArgs = {
  input?: InputMaybe<DeleteOrganizationAdminInput>;
};


export type MutationDeleteOrganizationInvoiceArgs = {
  input?: InputMaybe<DeleteOrganizationInvoiceInput>;
};


export type MutationDeleteOrganizationProgramArgs = {
  input?: InputMaybe<DeleteOrganizationProgramInput>;
};


export type MutationDeleteOrganizationRateArgs = {
  input?: InputMaybe<DeleteOrganizationRateInput>;
};


export type MutationDeleteOrganizationSuperviseeOnboardingRequestArgs = {
  input?: InputMaybe<DeleteOrganizationSuperviseeOnboardingRequestInput>;
};


export type MutationDeleteOrganizationUserArgs = {
  input?: InputMaybe<DeleteOrganizationUserInput>;
};


export type MutationDeleteSupervisionGoalArgs = {
  input?: InputMaybe<DeleteSupervisionGoalInput>;
};


export type MutationDeleteSupervisorIncidentArgs = {
  input: DeleteSupervisorIncidentInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteUserDocumentArgs = {
  input: DeleteUserDocumentInput;
};


export type MutationDeleteUserHolidayBonusGoalArgs = {
  input: DeleteUserHolidayBonusGoalInput;
};


export type MutationDeleteUserHolidayBonusGoalExtraSessionCreditArgs = {
  input: DeleteUserHolidayBonusGoalExtraSessionCreditInput;
};


export type MutationDeleteUsersLicenseMonitorArgs = {
  input: DeleteUsersLicenseMonitorInput;
};


export type MutationEditLicensePairingNoteArgs = {
  input: EditLicensePairingNoteInput;
};


export type MutationEditSupervisionRuleArgs = {
  input: EditSupervisionRuleInput;
};


export type MutationEnrollUserInCourseArgs = {
  input: EnrollUserInCourseInput;
};


export type MutationExpressInterestForOpportunityArgs = {
  input?: InputMaybe<ExpressInterestForOpportunityInput>;
};


export type MutationFinalizeSessionArgs = {
  input: FinalizeSessionInput;
};


export type MutationFindOrCreateChatArgs = {
  input: FindOrCreateChatInput;
};


export type MutationForceRunChronosJobArgs = {
  input?: InputMaybe<ForceRunChronosJobInput>;
};


export type MutationGenerateOrganizationInvoiceArgs = {
  input: GenerateOrganizationInvoiceInput;
};


export type MutationMarkEsignDocumentSignedArgs = {
  input?: InputMaybe<MarkEsignDocumentSignedInput>;
};


export type MutationMarkLiveCourseAttendedArgs = {
  input: MarkLiveCourseAttendedInput;
};


export type MutationMatchSupervisorForOpportunityArgs = {
  input?: InputMaybe<MatchSupervisorForOpportunityInput>;
};


export type MutationModerateRecommendationArgs = {
  input: ModerateRecommendationInput;
};


export type MutationPauseUserSupervisionArgs = {
  input: PauseUserSupervisionInput;
};


export type MutationProposeOrCreateSessionArgs = {
  input: ProposeOrCreateSessionInput;
};


export type MutationPublishCourseArgs = {
  input: PublishCourseInput;
};


export type MutationPublishFormVersionArgs = {
  input: PublishFormVersionInput;
};


export type MutationPublishJobListingArgs = {
  id: Scalars['String']['input'];
};


export type MutationRefundPaymentArgs = {
  input?: InputMaybe<RefundPaymentInput>;
};


export type MutationRegenerateOrganizationInvoiceArgs = {
  input?: InputMaybe<RegenerateOrganizationInvoiceInput>;
};


export type MutationRemoveBounceByUserIdArgs = {
  input: RemoveBounceByUserIdInput;
};


export type MutationRemoveSelfFromSessionArgs = {
  input: RemoveSelfFromSessionInput;
};


export type MutationRemoveUserFromSuppressionGroupArgs = {
  input: RemoveUserFromSuppressionGroupInput;
};


export type MutationRequestEmailChangeArgs = {
  input: RequestEmailChangeInput;
};


export type MutationRequestOpportunitiesCandidateArgs = {
  input?: InputMaybe<RequestOpportunitiesCandidateInput>;
};


export type MutationRequestOpportunitiesCandidateSupportArgs = {
  input?: InputMaybe<RequestOpportunitiesCandidateSupportInput>;
};


export type MutationRequestRecommendationArgs = {
  input: RequestRecommendationInput;
};


export type MutationRequestSupervisorTerminationArgs = {
  input: RequestSupervisorTerminationInput;
};


export type MutationResendTransactionReceiptArgs = {
  input?: InputMaybe<ResendTransactionInput>;
};


export type MutationResetAdminPasswordArgs = {
  input: ResetAdminPasswordInput;
};


export type MutationResetNewUserPasswordArgs = {
  input: ResetNewUserPasswordInput;
};


export type MutationResetOrganizationAdminPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetUserPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResumeUserSupervisionArgs = {
  input: ResumeUserSupervisionInput;
};


export type MutationRetryChargeArgs = {
  input: RetryChargeInput;
};


export type MutationRevokeOAuthTokenArgs = {
  input: RevokeOAuthTokenInput;
};


export type MutationScheduleIntroRequestArgs = {
  input: ScheduleIntroRequestInput;
};


export type MutationScheduleOrganizationUserForRemovalArgs = {
  input?: InputMaybe<ScheduleOrganizationUserForRemovalInput>;
};


export type MutationSendIntroCallRequestForOpportunityArgs = {
  input?: InputMaybe<SendIntroCallRequestForOpportunityInput>;
};


export type MutationSendMissingAttendanceEmailArgs = {
  input?: InputMaybe<SendMissingAttendanceEmailInput>;
};


export type MutationSendMissingNotesNotificationArgs = {
  input?: InputMaybe<SendMissingNotesNotificationInput>;
};


export type MutationSendOrganizationInvoiceArgs = {
  input?: InputMaybe<SendOrganizationInvoiceInput>;
};


export type MutationSendResetOrganizationAdminPasswordEmailArgs = {
  input: SendResetOrganizationAdminPasswordEmailInput;
};


export type MutationSendSupervisorApplicationApprovalArgs = {
  input?: InputMaybe<SendSupervisorApplicationApprovalInput>;
};


export type MutationSetHighPriorityStateLicenseCategoryCombinationArgs = {
  input: SetHighPriorityStateLicenseCategoryCombinationInput;
};


export type MutationSetPreferredCreditCardArgs = {
  input?: InputMaybe<SetPreferredCreditCardInput>;
};


export type MutationSetPreferredCreditCardForOrganizationArgs = {
  input?: InputMaybe<SetPreferredCreditCardForOrganizationInput>;
};


export type MutationSignSessionNotesAsSuperviseeArgs = {
  input: SignSessionNotesAsSuperviseeInput;
};


export type MutationSubmitCourseFormArgs = {
  input: SubmitCourseFormInput;
};


export type MutationSuggestAlternateIntroRequestTimesArgs = {
  input: SuggestAlternateIntroRequestTimesInput;
};


export type MutationToggleOpportunityAutoRequestArgs = {
  input?: InputMaybe<ToggleOpportunityAutoRequestInput>;
};


export type MutationUnenrollUserFromCourseArgs = {
  input: UnenrollUserFromCourseInput;
};


export type MutationUnpublishSupervisorProfileArgs = {
  input: UnpublishSupervisorProfileInput;
};


export type MutationUpdateAdminProfileArgs = {
  input: UpdateAdminProfileInput;
};


export type MutationUpdateBillableWorkAssigneeByIdArgs = {
  input?: InputMaybe<UpdateBillableWorkAssigneeByIdInput>;
};


export type MutationUpdateCourseArgs = {
  input: UpdateCourseInput;
};


export type MutationUpdateCourseFormResponseProgressArgs = {
  input: UpdateCourseFormResponseProgressInput;
};


export type MutationUpdateCourseThumbnailArgs = {
  input: UpdateCourseThumbnailInput;
};


export type MutationUpdateCredentialingBodyAccreditationArgs = {
  input: UpdateCredentialingBodyAccreditationInput;
};


export type MutationUpdateExternalSupervisorRequestArgs = {
  input: UpdateExternalSupervisorRequestInput;
};


export type MutationUpdateFormArgs = {
  input: UpdateFormInput;
};


export type MutationUpdateInternalUserNotesArgs = {
  input: UpdateInternalUserNotesInput;
};


export type MutationUpdateIntroRequestByIdArgs = {
  input: UpdateIntroRequestByIdInput;
};


export type MutationUpdateIntroRequestOrganizationInfoArgs = {
  input?: InputMaybe<UpdateIntroRequestOrganizationInfoInput>;
};


export type MutationUpdateJobListingArgs = {
  id: Scalars['String']['input'];
  input: UpdateJobListingInput;
};


export type MutationUpdateMatchDocumentArgs = {
  input: UpdateMatchDocumentInput;
};


export type MutationUpdateNotificationSubscriptionsArgs = {
  input?: InputMaybe<UpdateNotificationSubscriptionsInput>;
};


export type MutationUpdateOpportunitiesCandidateArgs = {
  input?: InputMaybe<UpdateOpportunitiesCandidateInput>;
};


export type MutationUpdateOpportunityArgs = {
  input?: InputMaybe<UpdateOpportunityInput>;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationAdminArgs = {
  input?: InputMaybe<UpdateOrganizationAdminInput>;
};


export type MutationUpdateOrganizationAdminProfileArgs = {
  input: UpdateOrganizationAdminProfileInput;
};


export type MutationUpdateOrganizationCheckInsPreferenceArgs = {
  input: UpdateOrganizationCheckInsPreferenceInput;
};


export type MutationUpdateOrganizationGrantArgs = {
  input: UpdateOrganizationGrantInput;
};


export type MutationUpdateOrganizationProgramNameArgs = {
  input: UpdateOrganizationProgramNameInput;
};


export type MutationUpdateOrganizationProgramSettingsArgs = {
  input: UpdateOrganizationProgramSettingsInput;
};


export type MutationUpdateOrganizationSuperviseeOnboardingRequestArgs = {
  input?: InputMaybe<UpdateOrganizationSuperviseeOnboardingRequestInput>;
};


export type MutationUpdateOrganizationUserBillingCodeArgs = {
  input: UpdateOrganizationUserBillingCodeInput;
};


export type MutationUpdateOrganizationUserDiscountArgs = {
  input: UpdateOrganizationUserDiscountInput;
};


export type MutationUpdatePanelistArgs = {
  input: UpdatePanelistInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};


export type MutationUpdateSessionForAdminArgs = {
  input: UpdateSessionForAdminInput;
};


export type MutationUpdateSignatureArgs = {
  input?: InputMaybe<UpdateSignatureInput>;
};


export type MutationUpdateStripeAccountArgs = {
  input: UpdateStripeAccountMutationInput;
};


export type MutationUpdateSuperviseeExternalHoursArgs = {
  input: UpdateSuperviseeExternalHoursInput;
};


export type MutationUpdateSuperviseeOnboardingInfoArgs = {
  input: UpdateSuperviseeOnboardingInfoInput;
};


export type MutationUpdateSuperviseeProgramArgs = {
  input?: InputMaybe<UpdateSuperviseeProgramInput>;
};


export type MutationUpdateSuperviseesInProgramArgs = {
  input?: InputMaybe<UpdateSuperviseesInProgramInput>;
};


export type MutationUpdateSupervisionGoalArgs = {
  input: UpdateSupervisionGoalInput;
};


export type MutationUpdateSupervisorBandwidthArgs = {
  input: UpdateSupervisorBandwidthInput;
};


export type MutationUpdateSupervisorIncidentArgs = {
  input: UpdateSupervisorIncidentInput;
};


export type MutationUpdateSupervisorInformationByUserIdArgs = {
  input: UpdateSupervisorInformationByUserIdInput;
};


export type MutationUpdateSupervisorVettingStartedByAdminIdArgs = {
  input: UpdateSupervisorVettingStartedByAdminIdInput;
};


export type MutationUpdateTopicArgs = {
  input: UpdateTopicInput;
};


export type MutationUpdateUserFromSupervisorApplicationArgs = {
  input: UpdateUserFromSupervisorApplicationInput;
};


export type MutationUpdateUserHolidayBonusGoalArgs = {
  input: UpdateUserHolidayBonusGoalInput;
};


export type MutationUpdateUserHolidayBonusGoalExtraSessionCreditArgs = {
  input: UpdateUserHolidayBonusGoalExtraSessionCreditInput;
};


export type MutationUpdateUserNotificationPreferencesArgs = {
  input: UpdateUserNotificationPreferencesInput;
};


export type MutationUpdateUserPrimaryCalendarArgs = {
  input?: InputMaybe<UpdateUserPrimaryCalendarInput>;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateVettingNotesForSupervisorArgs = {
  input?: InputMaybe<UpdateVettingNotesForSupervisorInput>;
};


export type MutationUpsertFeatureFlagArgs = {
  input: UpsertFeatureFlagInput;
};


export type MutationVetSupervisorArgs = {
  input: VetSupervisorInput;
};


export type MutationWriteRecommendationArgs = {
  input: WriteRecommendationInput;
};

export type NextStepsSessionsQueryResult = {
  __typename?: 'NextStepsSessionsQueryResult';
  result?: Maybe<Session>;
  total: Scalars['Int']['output'];
};

export type OAuthCalendarType = {
  __typename?: 'OAuthCalendarType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oauthTokenId: Scalars['Int']['output'];
  provider: OAuthProviderName;
};

export type OAuthConnectionType = {
  __typename?: 'OAuthConnectionType';
  calendars: Array<OAuthCalendarType>;
  email: Scalars['String']['output'];
  /** The oauthTokenId for this connection */
  id: Scalars['Int']['output'];
  isRevoked: Scalars['Boolean']['output'];
  provider: OAuthProviderName;
};

export type OAuthConnectionsQueryResult = {
  __typename?: 'OAuthConnectionsQueryResult';
  primaryCalendar?: Maybe<OAuthCalendarType>;
  result: Array<OAuthConnectionType>;
};

export enum OAuthProviderName {
  Apple = 'apple',
  Google = 'google',
  Microsoft = 'microsoft'
}

export type OpportunitiesCandidate = {
  __typename?: 'OpportunitiesCandidate';
  approvedAt?: Maybe<Scalars['Date']['output']>;
  declinedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  introRequest?: Maybe<IntroRequest>;
  introRequestInviteSentAt?: Maybe<Scalars['Date']['output']>;
  opportunitiesCandidateDeclineReason?: Maybe<OpportunitiesCandidateDeclineReason>;
  opportunitiesCandidateDeclineReasonId?: Maybe<Scalars['Int']['output']>;
  opportunitiesCandidateDeclineReasonText?: Maybe<Scalars['String']['output']>;
  opportunitiesCandidateDispositionId: Scalars['Int']['output'];
  opportunitiesCandidateStatusId: Scalars['Int']['output'];
  opportunity: Opportunity;
  opportunityChatParticipants: Array<OpportunityChatParticipant>;
  opportunityId: Scalars['String']['output'];
  organizationMatches?: Maybe<Array<OrganizationMatch>>;
  requestedAt?: Maybe<Scalars['Date']['output']>;
  supervisor?: Maybe<User>;
  supervisorApplication?: Maybe<SupervisorApplication>;
  supervisorApplicationId?: Maybe<Scalars['String']['output']>;
  supervisorUserId?: Maybe<Scalars['Int']['output']>;
  tentativeMatch?: Maybe<TentativeMatch>;
  text?: Maybe<Scalars['String']['output']>;
};

export type OpportunitiesCandidateDeclineReason = {
  __typename?: 'OpportunitiesCandidateDeclineReason';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OpportunitiesCandidateEvent = {
  __typename?: 'OpportunitiesCandidateEvent';
  actor: Actor;
  actorId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  eventDescription: Scalars['String']['output'];
  id: Scalars['String']['output'];
  opportunitiesCandidate: OpportunitiesCandidate;
  opportunitiesCandidateId: Scalars['String']['output'];
  opportunityId: Scalars['String']['output'];
};

export type OpportunitiesCandidateEventResult = {
  __typename?: 'OpportunitiesCandidateEventResult';
  result: Array<OpportunitiesCandidateEvent>;
};

export type OpportunitiesCandidateResult = {
  __typename?: 'OpportunitiesCandidateResult';
  result: Array<OpportunitiesCandidate>;
};

export type OpportunitiesCandidateStatus = {
  __typename?: 'OpportunitiesCandidateStatus';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OpportunitiesResult = {
  __typename?: 'OpportunitiesResult';
  result: Array<Opportunity>;
  total: Scalars['Int']['output'];
};

export type OpportunitiesSupervisee = {
  __typename?: 'OpportunitiesSupervisee';
  id: Scalars['String']['output'];
  matchedAt?: Maybe<Scalars['Date']['output']>;
  opportunityId: Scalars['String']['output'];
  supervisee: User;
  superviseeUserId: Scalars['Int']['output'];
};

export type Opportunity = {
  __typename?: 'Opportunity';
  admin: Admin;
  adminId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  legacy?: Maybe<Scalars['Boolean']['output']>;
  licenseCategory: LicenseCategory;
  licenseCategoryId: Scalars['Int']['output'];
  manualQueue?: Maybe<Scalars['Boolean']['output']>;
  modalities: Array<Modality>;
  opportunitiesCandidates: Array<OpportunitiesCandidate>;
  opportunitiesSupervisees: Array<OpportunitiesSupervisee>;
  opportunityStatusId: Scalars['Int']['output'];
  organization: Organization;
  organizationAdmin?: Maybe<OrganizationAdmin>;
  organizationAdminId?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['Int']['output'];
  populations: Array<Population>;
  requirements?: Maybe<Scalars['String']['output']>;
  requiresIntroCalls?: Maybe<Scalars['Boolean']['output']>;
  sessionTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
  sessionTypes?: Maybe<Array<SessionType>>;
  siteName?: Maybe<Scalars['String']['output']>;
  specialties: Array<Specialty>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  supervisees: Array<User>;
  supervisionAvailability?: Maybe<Scalars['String']['output']>;
  supervisionStartBy?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  usState: UsState;
  usStateId: Scalars['Int']['output'];
  weeklyHours?: Maybe<Scalars['Int']['output']>;
};

export type OpportunityChatParticipant = {
  __typename?: 'OpportunityChatParticipant';
  actor: Actor;
  actorId: Scalars['Int']['output'];
  chatId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastViewedChatMessageCreatedAt?: Maybe<Scalars['Date']['output']>;
  latestChatMessage?: Maybe<ChatMessage>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum OrderByEnum {
  CreatedAt = 'createdAt',
  DesiredStartDate = 'desiredStartDate',
  ResolvedAt = 'resolvedAt',
  UpdatedAt = 'updatedAt'
}

export type Organization = {
  __typename?: 'Organization';
  accountManagerAdmin?: Maybe<Admin>;
  accountManagerAdminId?: Maybe<Scalars['Int']['output']>;
  annualRateIncreasePercent: Scalars['Int']['output'];
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  autoChargeInvoices?: Maybe<Scalars['Boolean']['output']>;
  billableWorkAssignees: Array<BillableWorkAssignee>;
  billableWorkRecordCap?: Maybe<BillableWorkRecordCap>;
  canRemoveSupervisees: Scalars['Boolean']['output'];
  clinicalSettingId?: Maybe<Scalars['Int']['output']>;
  commercialStatus?: Maybe<CommercialStatus>;
  commercialStatusId?: Maybe<Scalars['Int']['output']>;
  contractStartDate?: Maybe<Scalars['String']['output']>;
  currentOrganizationRate: OrganizationRate;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Int']['output']>;
  firstRevenueDate?: Maybe<Scalars['String']['output']>;
  hasAssignedEmployerCareManager: Scalars['Boolean']['output'];
  hasCheckInsEnabled: Scalars['Boolean']['output'];
  hubspotCompanyId?: Maybe<Scalars['String']['output']>;
  hubspotDealId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internalComments: Array<Comment>;
  introCallPreferenceId: Scalars['Int']['output'];
  invoiceMemo?: Maybe<Scalars['String']['output']>;
  isEnterprise: Scalars['Boolean']['output'];
  levelOfEffort?: Maybe<LevelOfEffort>;
  levelOfEffortId?: Maybe<Scalars['Int']['output']>;
  licenseCategories: Array<LicenseCategory>;
  modalities: Array<Modality>;
  monthlyAnthemCreditCapInCents?: Maybe<Scalars['Int']['output']>;
  monthlyMinimumHours?: Maybe<Scalars['Float']['output']>;
  monthlyMinimumInCents: Scalars['Int']['output'];
  monthlyServiceFeeInCents: Scalars['Int']['output'];
  monthlyServiceFeePerSuperviseeInCents: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  onboardingFeeInCents: Scalars['Int']['output'];
  onboardingFormSlug: Scalars['String']['output'];
  organizationAdmins: Array<OrganizationAdmin>;
  organizationCheckIns: Array<OrganizationCheckIn>;
  organizationCreditCards?: Maybe<Array<OrganizationCreditCard>>;
  organizationGrant?: Maybe<OrganizationGrant>;
  organizationGrants: Array<OrganizationGrant>;
  organizationPrograms: Array<OrganizationProgram>;
  organizationSegmentation?: Maybe<OrganizationSegmentation>;
  organizationSegmentationId?: Maybe<Scalars['Int']['output']>;
  organizationUsers?: Maybe<Array<OrganizationUser>>;
  organizationUsersCount: Scalars['Int']['output'];
  populations: Array<Population>;
  primaryBillableWorkRecordTypeId?: Maybe<Scalars['Int']['output']>;
  profitStatus?: Maybe<ProfitStatus>;
  profitStatusId?: Maybe<Scalars['Int']['output']>;
  requiresNotesInReports: Scalars['Boolean']['output'];
  requiresPaymentInformation?: Maybe<Scalars['Boolean']['output']>;
  requiresSupervisorAdminHours: Scalars['Boolean']['output'];
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  specialties: Array<Specialty>;
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  supervisionAvailability?: Maybe<Scalars['String']['output']>;
  tier: Scalars['Int']['output'];
  usStates: Array<UsState>;
  usesInvoice: Scalars['Boolean']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


export type OrganizationOrganizationUsersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganizationStripeInvoiceIdArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type OrganizationAdmin = {
  __typename?: 'OrganizationAdmin';
  actorId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  mediumAvatar?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['Int']['output'];
  organizationPrograms: Array<OrganizationProgram>;
  organizationRole: OrganizationRole;
  passwordSetAt?: Maybe<Scalars['Date']['output']>;
  permissions?: Maybe<OrganizationAdminPermissionModel>;
  phone?: Maybe<Scalars['String']['output']>;
  smallAvatar?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type OrganizationAdminNotificationSubscription = {
  __typename?: 'OrganizationAdminNotificationSubscription';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  invoices: Scalars['Boolean']['output'];
  monthlyReports: Scalars['Boolean']['output'];
  noShowEmails: Scalars['Boolean']['output'];
  organizationAdminId: Scalars['Int']['output'];
  rateIncreases: Scalars['Boolean']['output'];
  supervisorMatchEmails: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type OrganizationAdminPermissionModel = {
  __typename?: 'OrganizationAdminPermissionModel';
  permissionNames: Array<OrganizationAdminPermissionName>;
  programIds?: Maybe<Array<Scalars['String']['output']>>;
};

export enum OrganizationAdminPermissionName {
  EditBilling = 'EDIT_BILLING',
  IntroCalls = 'INTRO_CALLS',
  ManageNotifications = 'MANAGE_NOTIFICATIONS',
  ManageOrganization = 'MANAGE_ORGANIZATION',
  MatchSuperviseeAndSupervisor = 'MATCH_SUPERVISEE_AND_SUPERVISOR',
  MatchSuperviseeAndSupervisorInProgram = 'MATCH_SUPERVISEE_AND_SUPERVISOR_IN_PROGRAM',
  ProgramCreate = 'PROGRAM_CREATE',
  ProgramDelete = 'PROGRAM_DELETE',
  ProgramEdit = 'PROGRAM_EDIT',
  ProgramView = 'PROGRAM_VIEW',
  ProgramViewAll = 'PROGRAM_VIEW_ALL',
  SelectPrograms = 'SELECT_PROGRAMS',
  SessionsViewAll = 'SESSIONS_VIEW_ALL',
  SuperviseesAdd = 'SUPERVISEES_ADD',
  SuperviseesDelete = 'SUPERVISEES_DELETE',
  SuperviseesEdit = 'SUPERVISEES_EDIT',
  SuperviseesViewAll = 'SUPERVISEES_VIEW_ALL',
  SupervisorsViewAll = 'SUPERVISORS_VIEW_ALL',
  UpdateAdmin = 'UPDATE_ADMIN',
  UpdateBillingManager = 'UPDATE_BILLING_MANAGER',
  UpdateClinicalDirector = 'UPDATE_CLINICAL_DIRECTOR',
  UpdateOrganization = 'UPDATE_ORGANIZATION',
  UpdateProgramDirector = 'UPDATE_PROGRAM_DIRECTOR',
  ViewBilling = 'VIEW_BILLING',
  ViewEntireTeam = 'VIEW_ENTIRE_TEAM',
  ViewTeam = 'VIEW_TEAM'
}

export type OrganizationAdminsQueryResult = {
  __typename?: 'OrganizationAdminsQueryResult';
  result?: Maybe<Array<OrganizationAdmin>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationCheckIn = {
  __typename?: 'OrganizationCheckIn';
  checkInEmailSentAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  organizationCheckInType: OrganizationCheckInType;
  organizationCheckInTypeId: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  scheduledCheckInDate: Scalars['String']['output'];
  yearsAfterStart: Scalars['Int']['output'];
};

export type OrganizationCheckInType = {
  __typename?: 'OrganizationCheckInType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationChurnConfirmationResult = {
  __typename?: 'OrganizationChurnConfirmationResult';
  matchesCount?: Maybe<Scalars['Int']['output']>;
  sessionsCount?: Maybe<Scalars['Int']['output']>;
  usersCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationContactInformationOrganizationAdminResult = {
  __typename?: 'OrganizationContactInformationOrganizationAdminResult';
  organizationAdmin: PublicAdmin;
  organizationRole: OrganizationRole;
};

export type OrganizationContactInformationResult = {
  __typename?: 'OrganizationContactInformationResult';
  accountManagerAdmin?: Maybe<PublicAdmin>;
  organization: Organization;
  organizationAdmins: Array<OrganizationContactInformationOrganizationAdminResult>;
  organizationProgram?: Maybe<OrganizationProgram>;
};

export type OrganizationCreditCard = {
  __typename?: 'OrganizationCreditCard';
  cardType: Scalars['String']['output'];
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastFourDigits: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
  preferred: Scalars['Boolean']['output'];
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationGrant = {
  __typename?: 'OrganizationGrant';
  createdAt?: Maybe<Scalars['Date']['output']>;
  grantType: GrantType;
  grantTypeId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  monthlyGrantCapInCents: Scalars['Int']['output'];
  organization: Organization;
  organizationGrantDiscounts: Array<OrganizationGrantDiscount>;
  organizationId: Scalars['Int']['output'];
};

export type OrganizationGrantDiscount = {
  __typename?: 'OrganizationGrantDiscount';
  createdAt?: Maybe<Scalars['Date']['output']>;
  discountPercent: Scalars['Int']['output'];
  effectiveDate: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['Int']['output'];
  organizationUserDiscountsCount: Scalars['Int']['output'];
  usState: UsState;
  usStateId: Scalars['Int']['output'];
};

export type OrganizationGrantDiscountsByOrganizationIdQueryResult = {
  __typename?: 'OrganizationGrantDiscountsByOrganizationIdQueryResult';
  organizationGrant: OrganizationGrant;
  result: Array<OrganizationGrantDiscount>;
  sortedResult: Array<GrantDiscountByState>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationGrantsQueryResult = {
  __typename?: 'OrganizationGrantsQueryResult';
  result: Array<OrganizationGrant>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationInvoice = {
  __typename?: 'OrganizationInvoice';
  id: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  stripeInvoice?: Maybe<StripeInvoice>;
  stripeInvoiceId: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type OrganizationMatch = {
  __typename?: 'OrganizationMatch';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  matchStatusId: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int']['output'];
  supervisor?: Maybe<User>;
  supervisorId: Scalars['Int']['output'];
};

export type OrganizationMatchesByOrganizationIdQueryResult = {
  __typename?: 'OrganizationMatchesByOrganizationIdQueryResult';
  result: Array<OrganizationMatch>;
};

export type OrganizationOneOffFee = {
  __typename?: 'OrganizationOneOffFee';
  amountInCents: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  organizationOneOffFeeType: OrganizationOneOffFeeType;
  organizationOneOffFeeTypeId: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type OrganizationOneOffFeeType = {
  __typename?: 'OrganizationOneOffFeeType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationProgram = {
  __typename?: 'OrganizationProgram';
  billableWorkRecordCap?: Maybe<BillableWorkRecordCap>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdByOrganizationAdminId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  introCallPreferenceId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationAdmins: Array<OrganizationAdmin>;
  organizationId: Scalars['Int']['output'];
  organizationUsers: Array<OrganizationUser>;
  requiresNotesInReports?: Maybe<Scalars['Boolean']['output']>;
  requiresSupervisorAdminHours?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type OrganizationRate = {
  __typename?: 'OrganizationRate';
  dyadRateTotalInCents: Scalars['Int']['output'];
  dyadTotalPayoutAmountInCents: Scalars['Int']['output'];
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  groupRateTotalInCents: Scalars['Int']['output'];
  groupTotalPayoutAmountInCents: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  individualRateTotalInCents: Scalars['Int']['output'];
  individualTotalPayoutAmountInCents: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
};

export type OrganizationReferralSource = {
  __typename?: 'OrganizationReferralSource';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationSegmentation = {
  __typename?: 'OrganizationSegmentation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationSession = {
  __typename?: 'OrganizationSession';
  id: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['Int']['output'];
  organizationRate: OrganizationRate;
  organizationRateId: Scalars['String']['output'];
  sessionId: Scalars['Int']['output'];
};

export type OrganizationSize = {
  __typename?: 'OrganizationSize';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationSummaryByIdQueryResult = {
  __typename?: 'OrganizationSummaryByIdQueryResult';
  inactiveUserCount?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  pendingUserCount?: Maybe<Scalars['Int']['output']>;
  totalMinutes?: Maybe<Scalars['Int']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationSuperviseeOnboardingRequest = {
  __typename?: 'OrganizationSuperviseeOnboardingRequest';
  billingCode?: Maybe<Scalars['String']['output']>;
  blockedReason?: Maybe<Scalars['String']['output']>;
  contactedSupervisors?: Maybe<Array<User>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  license?: Maybe<License>;
  licenseCategory: LicenseCategory;
  licenseCategoryId: Scalars['Int']['output'];
  licenseId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<Opportunity>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['Int']['output'];
  organizationSuperviseeOnboardingRequestStatus: OrganizationSuperviseeOnboardingRequestStatus;
  organizationSuperviseeOnboardingRequestStatusId: Scalars['Int']['output'];
  sessionTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
  sessionTypes?: Maybe<Array<SessionType>>;
  usState: UsState;
  usStateId: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationSuperviseeOnboardingRequestStatus = {
  __typename?: 'OrganizationSuperviseeOnboardingRequestStatus';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationSuperviseeOnboardingRequestsResult = {
  __typename?: 'OrganizationSuperviseeOnboardingRequestsResult';
  result: Array<OrganizationSuperviseeOnboardingRequest>;
  total: Scalars['Int']['output'];
};

export type OrganizationSuperviseesByIdQueryDataType = {
  __typename?: 'OrganizationSuperviseesByIdQueryDataType';
  user: User;
};

export type OrganizationSuperviseesByIdQueryResult = {
  __typename?: 'OrganizationSuperviseesByIdQueryResult';
  result: Array<OrganizationSuperviseesByIdQueryDataType>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationSupervisorsBySupervisorBandwidthQueryResult = {
  __typename?: 'OrganizationSupervisorsBySupervisorBandwidthQueryResult';
  supervisorBandwidth?: Maybe<SupervisorBandwidth>;
  supervisors?: Maybe<Array<User>>;
};

export type OrganizationSupervisorsDataType = {
  __typename?: 'OrganizationSupervisorsDataType';
  supervisees: Array<User>;
  supervisor: User;
};

export type OrganizationSupervisorsResult = {
  __typename?: 'OrganizationSupervisorsResult';
  result?: Maybe<Array<OrganizationSupervisorsDataType>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationTeamMembersQueryResult = {
  __typename?: 'OrganizationTeamMembersQueryResult';
  result: Array<OrganizationAdmin>;
  total: Scalars['Int']['output'];
};

export type OrganizationType = {
  __typename?: 'OrganizationType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  approvedBySupervisorAt?: Maybe<Scalars['Date']['output']>;
  approvedBySupervisorUserId?: Maybe<Scalars['Int']['output']>;
  billingCode?: Maybe<Scalars['String']['output']>;
  createdByOrganizationAdmin?: Maybe<OrganizationAdmin>;
  createdByOrganizationAdminId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  discountPercentOverride?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  matchEmailSentAt?: Maybe<Scalars['Date']['output']>;
  organization: Organization;
  organizationId: Scalars['Int']['output'];
  organizationProgram?: Maybe<OrganizationProgram>;
  organizationProgramId?: Maybe<Scalars['String']['output']>;
  organizationUserDiscount?: Maybe<OrganizationUserDiscounts>;
  organizationUserProgramPreference: OrganizationUserProgramPreference;
  recentSession?: Maybe<Session>;
  removalReasonId?: Maybe<Scalars['Int']['output']>;
  removalReasonText?: Maybe<Scalars['String']['output']>;
  scheduledForRemovalOn?: Maybe<Scalars['String']['output']>;
  scheduledStartDate?: Maybe<Scalars['String']['output']>;
  unmatchSuperviseeReason?: Maybe<UnmatchSuperviseeReason>;
  upcomingSession?: Maybe<Session>;
  user: User;
  userId: Scalars['Int']['output'];
};

export type OrganizationUserDiscounts = {
  __typename?: 'OrganizationUserDiscounts';
  discountPercent: Scalars['Int']['output'];
  organizationGrantDiscount?: Maybe<OrganizationGrantDiscount>;
  organizationGrantDiscountId?: Maybe<Scalars['String']['output']>;
  organizationUserId: Scalars['Int']['output'];
};

export type OrganizationUserDiscountsByOrganizationIdResult = {
  __typename?: 'OrganizationUserDiscountsByOrganizationIdResult';
  result: Array<OrganizationUserDiscounts>;
};

export type OrganizationUserProgramPreference = {
  __typename?: 'OrganizationUserProgramPreference';
  introCallPreferenceId: Scalars['Int']['output'];
  organizationUserId: Scalars['Int']['output'];
  requiresNotesInReports: Scalars['Boolean']['output'];
  requiresSupervisorAdminHours: Scalars['Boolean']['output'];
};

export type OrganizationsAndProgramsForBillableWork = {
  __typename?: 'OrganizationsAndProgramsForBillableWork';
  organization: Organization;
  organizationPrograms: Array<OrganizationProgram>;
};

export type OrganizationsForBillableWorkResult = {
  __typename?: 'OrganizationsForBillableWorkResult';
  result: Array<OrganizationsAndProgramsForBillableWork>;
};

export type OrganizationsQueryResult = {
  __typename?: 'OrganizationsQueryResult';
  result: Array<Organization>;
  total: Scalars['Int']['output'];
};

export type OrganizationsWithDiscountsQueryResult = {
  __typename?: 'OrganizationsWithDiscountsQueryResult';
  organizations: Array<Organization>;
};

export type Panelist = {
  __typename?: 'Panelist';
  avatarPath?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  courses?: Maybe<Array<Course>>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  postnominals?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  twitterUrl?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type PanelistsResult = {
  __typename?: 'PanelistsResult';
  result: Array<Panelist>;
  total: Scalars['Int']['output'];
};

export enum ParticipantTypeEnum {
  B2B = 'B2B',
  B2C = 'B2C',
  Employer = 'EMPLOYER'
}

export enum PauseStatus {
  ActiveOnly = 'ACTIVE_ONLY',
  PausedOnly = 'PAUSED_ONLY'
}

export type PauseUserSupervisionInput = {
  supervisionPausedReasonText?: InputMaybe<Scalars['String']['input']>;
  supervisionResumesOn?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type Payout = {
  __typename?: 'Payout';
  amountInCents: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  paidOutAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripePayoutId: Scalars['String']['output'];
  stripePayoutLink: Scalars['String']['output'];
  transfers?: Maybe<Array<Transfer>>;
};

export type Population = {
  __typename?: 'Population';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PostSessionResult = {
  __typename?: 'PostSessionResult';
  session: Session;
  sessionAttendeeNpsResponse?: Maybe<SessionAttendeeNpsResponse>;
  shouldShowNpsSurvey: Scalars['Boolean']['output'];
};

export type PotentialChatParticipantsResult = {
  __typename?: 'PotentialChatParticipantsResult';
  result: Array<ChatActor>;
};

export type ProfitStatus = {
  __typename?: 'ProfitStatus';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PromotionCode = {
  __typename?: 'PromotionCode';
  amountOff?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Int']['output']>;
};

export type ProposeOrCreateSessionInput = {
  duration: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
  scheduledAt: Scalars['Date']['input'];
  supervisorUserId: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};

export type ProposeOrCreateSessionResult = {
  __typename?: 'ProposeOrCreateSessionResult';
  error?: Maybe<Scalars['String']['output']>;
  proposedSessionId?: Maybe<Scalars['Int']['output']>;
  sessionId?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProposedSession = {
  __typename?: 'ProposedSession';
  duration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  scheduledAt: Scalars['Date']['output'];
  supervisee: User;
  superviseeUserId: Scalars['Int']['output'];
  supervisor: User;
  supervisorUserId: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

export type ProposedSessionsResult = {
  __typename?: 'ProposedSessionsResult';
  result: Array<ProposedSession>;
  total: Scalars['Int']['output'];
};

export type PublicAdmin = {
  __typename?: 'PublicAdmin';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
};

export type PublishCourseInput = {
  id: Scalars['String']['input'];
};

export type PublishCourseResult = {
  __typename?: 'PublishCourseResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PublishFormVersionInput = {
  formVersionId: Scalars['String']['input'];
};

export type PublishFormVersionResult = {
  __typename?: 'PublishFormVersionResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  adminById: Admin;
  adminRoles: Array<AdminRole>;
  adminSlackUsers: Array<AdminSlackUser>;
  admins: Array<Admin>;
  balanceTransactionsByOrganizationId?: Maybe<BalanceTransactionsByOrganizationIdResult>;
  billableWorkRecordCapTypes: Array<BillableWorkRecordCapType>;
  billableWorkRecordTypes: Array<BillableWorkRecordType>;
  billableWorkRecords: BillableWorkRecordsResult;
  billableWorkRecordsForAdmin: BillableWorkRecordsAdminResult;
  billableWorkRecordsForOrganizationAdmin: BillableWorkRecordsForOrganizationAdminResult;
  bouncedEmails?: Maybe<BouncedEmailsQueryResult>;
  ceInvoices?: Maybe<Array<CeInvoice>>;
  chat?: Maybe<Chat>;
  chatMessages: ChatMessagesResult;
  chats: Array<Chat>;
  chatsWithUnreadMessages: Array<Chat>;
  chronosJobs: Array<ChronosJob>;
  chronosTasks: ChronosTasksQueryResult;
  clinicalSettings: Array<ClinicalSetting>;
  commercialStatuses: Array<CommercialStatus>;
  complianceIssues: Array<ComplianceIssue>;
  conductIssues: Array<ConductIssue>;
  continuingEducationSummary: ContinuingEducationSummaryResult;
  courseById?: Maybe<Course>;
  courseBySlug?: Maybe<Course>;
  courses: CoursesResult;
  credentialingBodyAccreditationById?: Maybe<CredentialingBodyAccreditation>;
  credentialingBodyAccreditations?: Maybe<Array<CredentialingBodyAccreditation>>;
  /** A list of credit cards belonging to the current viewer */
  creditCards: Array<CreditCard>;
  /** A list of credit cards belonging to a user. Admin-access only */
  creditCardsByUserId?: Maybe<Array<CreditCard>>;
  creditHours: Array<Scalars['Float']['output']>;
  declinedCharges?: Maybe<DeclinedChargesResult>;
  degrees: Array<Degree>;
  deleteUserConfirmation: DeleteUserConfirmation;
  /** A list of all discount types */
  discountTypes?: Maybe<Array<DiscountType>>;
  emailInformationByUserId: EmailInformationResult;
  enrolledCourses: EnrolledCoursesResult;
  externalSupervisorRequestById: ExternalSupervisorRequest;
  externalSupervisorRequestCandidateMaskedEmailById?: Maybe<ExternalSupervisorRequestCandidateMaskedEmailByIdResult>;
  externalSupervisorRequestSources: Array<ExternalSupervisorRequestSource>;
  externalSupervisorRequestStatuses: Array<ExternalSupervisorRequestStatus>;
  externalSupervisorRequestUrgencies: Array<ExternalSupervisorRequestUrgency>;
  externalSupervisorRequests: ExternalSupervisorRequestsResult;
  featureFlags?: Maybe<FeatureFlagsQueryResult>;
  formById?: Maybe<Form>;
  formResponse?: Maybe<FormResponse>;
  forms?: Maybe<FormsResult>;
  frequencies: Array<Frequency>;
  grantEligibleUsStates: Array<UsState>;
  highPriorityStateLicenseCategoryCombinations: Array<UsStatesLicenseCategory>;
  incidentReportMethods: Array<IncidentReportMethod>;
  incidentReportStatuses: Array<IncidentReportStatus>;
  incidentReporters: Array<IncidentReporter>;
  introRequestById: IntroRequest;
  introRequestDeclineReasons: Array<IntroRequestDeclineReason>;
  introRequestOrganizationInfoById?: Maybe<IntroRequestOrganizationInfo>;
  introRequests?: Maybe<IntroRequestsResult>;
  introRequestsForAdmin: IntroRequestsForAdminResult;
  jobListingById: JobListing;
  jobListingLocations: Array<JobListingLocation>;
  jobListingSearchOptions: JobListingSearchOptionsResult;
  jobListings: Array<JobListing>;
  languages: Array<Language>;
  levelOfEfforts: Array<LevelOfEffort>;
  licenseCategories: Array<LicenseCategory>;
  licenses: Array<License>;
  matchById: Match;
  matchDocuments: MatchDocumentResults;
  matchStatuses: Array<MatchStatus>;
  matches: MatchesResult;
  matchesByUserId: MatchesByUserIdResult;
  matchesForSuperviseeHours: MatchesForSuperviseeHoursResult;
  modalities: Array<Modality>;
  mySessionAttendance: SessionAttendeeUser;
  nextStepsSessions?: Maybe<NextStepsSessionsQueryResult>;
  notificationSubscriptionsForOrganizationAdmin?: Maybe<OrganizationAdminNotificationSubscription>;
  oauthConnections: OAuthConnectionsQueryResult;
  opportunities: OpportunitiesResult;
  opportunitiesCandidateById: OpportunitiesCandidate;
  opportunitiesCandidateDeclineReasons: Array<OpportunitiesCandidateDeclineReason>;
  opportunitiesCandidateEvents?: Maybe<OpportunitiesCandidateEventResult>;
  opportunitiesCandidateStatuses: Array<OpportunitiesCandidateStatus>;
  opportunitiesCandidates: OpportunitiesCandidateResult;
  opportunityById: Opportunity;
  organizationAdminById?: Maybe<OrganizationAdmin>;
  organizationAdmins?: Maybe<OrganizationAdminsQueryResult>;
  organizationById: Organization;
  organizationByOnboardingFormSlug?: Maybe<Organization>;
  organizationCheckInTypes: Array<OrganizationCheckInType>;
  organizationChurnConfirmation?: Maybe<OrganizationChurnConfirmationResult>;
  organizationContactInformation: OrganizationContactInformationResult;
  /** A list of organization credit cards belonging to the current viewer organization */
  organizationCreditCards?: Maybe<Array<OrganizationCreditCard>>;
  organizationGrantDiscountsByOrganizationId?: Maybe<OrganizationGrantDiscountsByOrganizationIdQueryResult>;
  organizationGrants?: Maybe<OrganizationGrantsQueryResult>;
  /** A list of invoices belonging to an organization. Admin-access only */
  organizationInvoicesByOrganizationId: Array<OrganizationInvoice>;
  organizationMatchesByOrganizationId?: Maybe<OrganizationMatchesByOrganizationIdQueryResult>;
  organizationOneOffFeesByOrganizationId?: Maybe<Array<OrganizationOneOffFee>>;
  organizationProgramById: OrganizationProgram;
  organizationProgramDirectorsByOrganizationId?: Maybe<Array<OrganizationAdmin>>;
  organizationProgramsByOrganizationId: Array<OrganizationProgram>;
  organizationRatesByOrganizationId: Array<OrganizationRate>;
  organizationReferralSources: Array<OrganizationReferralSource>;
  organizationRoles: Array<OrganizationRole>;
  organizationSegmentations: Array<OrganizationSegmentation>;
  organizationSizes: Array<OrganizationSize>;
  organizationSummaryById?: Maybe<OrganizationSummaryByIdQueryResult>;
  organizationSuperviseeOnboardingRequests: OrganizationSuperviseeOnboardingRequestsResult;
  organizationSuperviseesById?: Maybe<OrganizationSuperviseesByIdQueryResult>;
  organizationSupervisors?: Maybe<OrganizationSupervisorsResult>;
  organizationSupervisorsBySupervisorBandwidth?: Maybe<Array<OrganizationSupervisorsBySupervisorBandwidthQueryResult>>;
  organizationTeamMembers: OrganizationTeamMembersQueryResult;
  organizationTypes: Array<OrganizationType>;
  organizationUserById?: Maybe<OrganizationUser>;
  organizationUserDiscountsByOrganizationId?: Maybe<OrganizationUserDiscountsByOrganizationIdResult>;
  organizations: OrganizationsQueryResult;
  organizationsBySuperviseeMatches?: Maybe<Array<Organization>>;
  organizationsForBillableWork: OrganizationsForBillableWorkResult;
  organizationsWithDiscounts: OrganizationsWithDiscountsQueryResult;
  panelistById?: Maybe<Panelist>;
  panelistBySlug: Panelist;
  panelists: PanelistsResult;
  payoutsByUserId?: Maybe<Array<Payout>>;
  populations: Array<Population>;
  postSession: PostSessionResult;
  potentialChatParticipants?: Maybe<PotentialChatParticipantsResult>;
  promotionCode?: Maybe<PromotionCode>;
  proposedSessionById: ProposedSession;
  proposedSessions: ProposedSessionsResult;
  recommendationById?: Maybe<Recommendation>;
  referralSources: Array<ReferralSource>;
  searchSupervisors: SearchSupervisorsQueryResult;
  sessionAttendanceBySessionId: SessionAttendees;
  sessionById: Session;
  sessionCancellationReasons: Array<SessionCancellationReason>;
  sessionChargeById?: Maybe<SessionCharge>;
  sessionChargesByAttendeeId?: Maybe<Array<SessionCharge>>;
  sessionRates: Array<SessionRate>;
  sessionTypes: Array<SessionType>;
  sessions: SessionsQueryResult;
  sessionsForBilling?: Maybe<SessionsForBillingQueryResult>;
  specialties: Array<Specialty>;
  superviseeCompletedHours: SuperviseeCompletedHoursResult;
  superviseeMatches: Array<Match>;
  superviseeMatchesGroupedByOrganization: Array<GroupedOrganizationMatches>;
  superviseeSessionsSummary?: Maybe<SessionsSummaryResult>;
  superviseeSessionsSummaryById?: Maybe<SessionsSummaryResult>;
  superviseesByOrganizationProgramId?: Maybe<SuperviseesByOrganizationProgramIdQueryResult>;
  superviseesToMatch: Array<User>;
  supervisionCredentials: Array<SupervisionCredential>;
  supervisionGoals: Array<SupervisionGoal>;
  supervisionRuleById: SupervisionRule;
  supervisionRules: Array<SupervisionRule>;
  supervisorApplicationById: SupervisorApplication;
  supervisorApplicationDeclineReasons: Array<SupervisorApplicationDeclineReason>;
  supervisorApplications: SupervisorApplicationsQueryResult;
  supervisorAvailableTimeslots?: Maybe<SupervisorAvailableTimeslotsResult>;
  supervisorAvailableTimeslotsByDay?: Maybe<SupervisorAvailableTimeslotsByDayResult>;
  supervisorBandwidths: Array<SupervisorBandwidth>;
  supervisorBookedTimeslots?: Maybe<SupervisorBookedTimeslotsResult>;
  supervisorBySlug?: Maybe<User>;
  supervisorIncidentById: SupervisorIncident;
  supervisorIncidents: SupervisorIncidentsResult;
  supervisorReferralSources: Array<SupervisorReferralSource>;
  supervisorSuperviseeLicensePairingNoteById: SupervisorSuperviseeLicensePairing;
  supervisorSuperviseeLicensePairingNotes: Array<SupervisorSuperviseeLicensePairing>;
  supervisorUnpublishReasons: Array<SupervisorUnpublishReason>;
  supervisorsByIds: Array<User>;
  supervisorsWithMissingAttendance: SupervisorsWithMissingAttendanceResult;
  supervisorsWithMissingNotes?: Maybe<SupervisorsWithMissingNotesResult>;
  topicById?: Maybe<Topic>;
  topics: Array<Topic>;
  unmatchSuperviseeReasons: Array<UnmatchSuperviseeReason>;
  unmatchedSupervisees: Array<User>;
  unvettedSupervisors: UnvettedSupervisorsResult;
  upcomingSessions: UpcomingSessionsQueryResult;
  usStates: Array<UsState>;
  usStatesForOrganizationUsers: UsStatesForOrganizationUsersResult;
  userAvailabilitiesByUserIdQuery: UserAvailabilityResult;
  userById: User;
  userDeleteReasons: Array<UserDeleteReason>;
  userDiscountsByUserId?: Maybe<Array<UserDiscount>>;
  userDocumentTypes: Array<UserDocumentType>;
  userHolidayBonusGoals: Array<UserHolidayBonusGoal>;
  userMatches?: Maybe<UserMatchesResult>;
  userNotificationPreferences: Array<UserNotificationPreferencesByCategoryType>;
  users: UsersQueryResult;
  usersByOrganizationId: UsersByOrganizationIdQueryResult;
  viewer: Viewer;
  viewerActor?: Maybe<Actor>;
};


export type QueryAdminByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminsArgs = {
  adminRoleId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBalanceTransactionsByOrganizationIdArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryBillableWorkRecordsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryBillableWorkRecordsForAdminArgs = {
  afterDateString?: InputMaybe<Scalars['String']['input']>;
  assigneeUserId?: InputMaybe<Scalars['Int']['input']>;
  beforeDateString?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillableWorkRecordsForOrganizationAdminArgs = {
  afterDateString: Scalars['String']['input'];
  beforeDateString: Scalars['String']['input'];
  organizationProgramId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBouncedEmailsArgs = {
  accountManagerAdminId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatMessagesArgs = {
  chatId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChronosTasksArgs = {
  jobName?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCourseByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCourseBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCoursesArgs = {
  accreditationId?: InputMaybe<Scalars['String']['input']>;
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditHours?: InputMaybe<Scalars['Float']['input']>;
  flagship?: InputMaybe<Scalars['Boolean']['input']>;
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  topicId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCredentialingBodyAccreditationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCreditCardsByUserIdArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryDeleteUserConfirmationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEmailInformationByUserIdArgs = {
  input: EmailInformationInput;
};


export type QueryEnrolledCoursesArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternalSupervisorRequestByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExternalSupervisorRequestCandidateMaskedEmailByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryExternalSupervisorRequestsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: OrderByEnum;
  showResolved?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFormByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFormResponseArgs = {
  enrollmentId: Scalars['String']['input'];
  formVersionId: Scalars['String']['input'];
};


export type QueryFormsArgs = {
  graded?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrantEligibleUsStatesArgs = {
  grantTypeId?: InputMaybe<Scalars['Int']['input']>;
  grantTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryIntroRequestByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryIntroRequestOrganizationInfoByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryIntroRequestsArgs = {
  openForViewer?: InputMaybe<Scalars['Boolean']['input']>;
  waitingForViewer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIntroRequestsForAdminArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  introRequestStatusId?: InputMaybe<Scalars['Int']['input']>;
  joinReasonId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  participantType?: InputMaybe<ParticipantTypeEnum>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobListingByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryJobListingsArgs = {
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  usStateId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLicenseCategoriesArgs = {
  includeOtherOption?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLicensesArgs = {
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatchByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMatchDocumentsArgs = {
  matchId: Scalars['Int']['input'];
};


export type QueryMatchesArgs = {
  matchStatusId?: InputMaybe<Scalars['Int']['input']>;
  matchStatusIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryMatchesByUserIdArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryMySessionAttendanceArgs = {
  sessionId: Scalars['Int']['input'];
};


export type QueryNotificationSubscriptionsForOrganizationAdminArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpportunitiesArgs = {
  adminId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  opportunityStatusId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  supervisorUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpportunitiesCandidateByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryOpportunitiesCandidateEventsArgs = {
  opportunityCandidateId?: InputMaybe<Scalars['String']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpportunitiesCandidatesArgs = {
  opportunityId: Scalars['String']['input'];
};


export type QueryOpportunityByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationAdminByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationAdminsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationAdminProgramId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationByOnboardingFormSlugArgs = {
  onboardingFormSlug: Scalars['String']['input'];
};


export type QueryOrganizationChurnConfirmationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationContactInformationArgs = {
  organizationId: Scalars['Int']['input'];
  organizationProgramId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationGrantDiscountsByOrganizationIdArgs = {
  grantTypeId?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['Int']['input'];
};


export type QueryOrganizationGrantsArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationInvoicesByOrganizationIdArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryOrganizationMatchesByOrganizationIdArgs = {
  matchStatusId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationOneOffFeesByOrganizationIdArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryOrganizationProgramByIdArgs = {
  organizationProgramId: Scalars['String']['input'];
};


export type QueryOrganizationProgramDirectorsByOrganizationIdArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryOrganizationProgramsByOrganizationIdArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryOrganizationRatesByOrganizationIdArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryOrganizationSummaryByIdArgs = {
  organizationId: Scalars['Int']['input'];
  programId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationSuperviseeOnboardingRequestsArgs = {
  accountManagerId?: InputMaybe<Scalars['Int']['input']>;
  introCallPreferenceId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  organizationSuperviseeOnboardingRequestStatusId?: InputMaybe<Scalars['Int']['input']>;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationSuperviseesByIdArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  isRemovedTab?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortByMostRecentSession?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrganizationSupervisorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchStatusId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationSupervisorsBySupervisorBandwidthArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationTeamMembersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryOrganizationUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationUserDiscountsByOrganizationIdArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryOrganizationsArgs = {
  accountManagerAdminId?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationSuperviseeOnboardingRequestStatusId?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationsBySuperviseeMatchesArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryOrganizationsForBillableWorkArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPanelistByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryPanelistBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPanelistsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPayoutsByUserIdArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryPostSessionArgs = {
  sessionId: Scalars['Int']['input'];
};


export type QueryPromotionCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryProposedSessionByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProposedSessionsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryRecommendationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySearchSupervisorsArgs = {
  availability?: InputMaybe<SupervisorAvailabilityInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  clinicalSettingIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  forOpportunityId?: InputMaybe<Scalars['String']['input']>;
  forOrganizationId?: InputMaybe<Scalars['Int']['input']>;
  latestSessionMinDate?: InputMaybe<Scalars['String']['input']>;
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  licenses?: InputMaybe<Array<UsersLicenseQueryInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modalityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyB2BSupervisors?: InputMaybe<Scalars['Boolean']['input']>;
  populationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recommendationStatusId?: InputMaybe<Scalars['Int']['input']>;
  restrictUsStateIdToLocationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sessionTypeId?: InputMaybe<Scalars['Int']['input']>;
  sessionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  showNonPublic?: InputMaybe<Scalars['Boolean']['input']>;
  sortByName?: InputMaybe<Scalars['Boolean']['input']>;
  sortByRecentlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  specialtyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  supervisesInPerson?: InputMaybe<Scalars['Boolean']['input']>;
  supervisionCredentialId?: InputMaybe<Scalars['Int']['input']>;
  supervisorBandwidthId?: InputMaybe<Scalars['Int']['input']>;
  supervisorProfileDispositionId?: InputMaybe<Scalars['Int']['input']>;
  supervisorProfileDispositionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  usStateId?: InputMaybe<Scalars['Int']['input']>;
  vetted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySessionAttendanceBySessionIdArgs = {
  sessionId: Scalars['Int']['input'];
};


export type QuerySessionByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySessionChargeByIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySessionChargesByAttendeeIdArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySessionsArgs = {
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
  limit: Scalars['Int']['input'];
  matchId?: InputMaybe<Scalars['Int']['input']>;
  missingNotesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noShowOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  sessionChargeId?: InputMaybe<Scalars['String']['input']>;
  sessionDispositionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sessionTypeId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  supervisorId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySessionsForBillingArgs = {
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<SessionsForBillingFilter>;
  sessionChargeId?: InputMaybe<Scalars['String']['input']>;
  sessionDispositionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QuerySuperviseeCompletedHoursArgs = {
  superviseeUserId?: InputMaybe<Scalars['Int']['input']>;
  supervisorUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuperviseeMatchesArgs = {
  includeMatchesForSessionId?: InputMaybe<Scalars['Int']['input']>;
  matchStatusId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuperviseeMatchesGroupedByOrganizationArgs = {
  includeMatchesForSessionId?: InputMaybe<Scalars['Int']['input']>;
  matchStatusId?: InputMaybe<Scalars['Int']['input']>;
  pauseStatus?: InputMaybe<PauseStatus>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuperviseeSessionsSummaryByIdArgs = {
  supervisorUserId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuperviseesByOrganizationProgramIdArgs = {
  organizationProgramId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuperviseesToMatchArgs = {
  accountManagerAdminId: Scalars['Int']['input'];
  excludeMatchedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  excludeUsersInMatchQueue?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupervisionGoalsArgs = {
  superviseeUserId?: InputMaybe<Scalars['Int']['input']>;
  supervisorUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupervisionRuleByIdArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupervisorApplicationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySupervisorApplicationsArgs = {
  clinicalSettingIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hideDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  hideLinkedApplications?: InputMaybe<Scalars['Boolean']['input']>;
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  modalityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset: Scalars['Int']['input'];
  populationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  specialtyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  supervisionCredentialId?: InputMaybe<Scalars['Int']['input']>;
  supervisorApplicationStatusId?: InputMaybe<Scalars['Int']['input']>;
  usStateId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupervisorAvailableTimeslotsArgs = {
  superviseeTimezone: Scalars['String']['input'];
  supervisorUserId: Scalars['Int']['input'];
};


export type QuerySupervisorAvailableTimeslotsByDayArgs = {
  date: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  supervisorUserId: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};


export type QuerySupervisorBookedTimeslotsArgs = {
  input?: InputMaybe<SupervisorBookedTimeslotsInput>;
};


export type QuerySupervisorBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySupervisorIncidentByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupervisorIncidentsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToAdminId?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: SupervisorIncidentsOrderByEnum;
};


export type QuerySupervisorSuperviseeLicensePairingNoteByIdArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupervisorsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryTopicByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUnmatchSuperviseeReasonsArgs = {
  forOrganizationUsers?: InputMaybe<Scalars['Boolean']['input']>;
  forOrganizationUsersRemoval?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUnmatchedSuperviseesArgs = {
  accountManagerAdminId: Scalars['Int']['input'];
  excludeUsersInMatchQueue?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnvettedSupervisorsArgs = {
  externalSupervisorRequestCandidatesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  markedAsNeedsFollowup?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: Scalars['Int']['input'];
  vettingStartedByAdminId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUpcomingSessionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsStatesForOrganizationUsersArgs = {
  organizationId: Scalars['Int']['input'];
  organizationProgramId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserAvailabilitiesByUserIdQueryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserDiscountsByUserIdArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryUserMatchesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  excludeOrganizationUsers?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  roleFilter?: InputMaybe<UserRoleFilter>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersByOrganizationIdArgs = {
  filter?: InputMaybe<UsersByOrganizationIdQueryFilter>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  programId?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortByMostRecentSession?: InputMaybe<Scalars['Boolean']['input']>;
  usStateId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionInput = {
  freeText?: InputMaybe<FreeTextInputQuestion>;
  likertScale?: InputMaybe<LikertScaleInputQuestion>;
  multipleChoice?: InputMaybe<MultipleChoiceInputQuestion>;
  questionType: FormQuestionTypeEnum;
  trueFalse?: InputMaybe<TrueFalseInputQuestion>;
};

export type ReactivateSubscriptionResult = {
  __typename?: 'ReactivateSubscriptionResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Recommendation = {
  __typename?: 'Recommendation';
  approvedAt?: Maybe<Scalars['Date']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  match: Match;
  matchId: Scalars['Int']['output'];
  recommendationText?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['Date']['output']>;
  requestText?: Maybe<Scalars['String']['output']>;
  supervisee: User;
  superviseeUserId: Scalars['Int']['output'];
  supervisor: User;
  supervisorUserId: Scalars['Int']['output'];
};

export type ReferralSource = {
  __typename?: 'ReferralSource';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RefundPaymentInput = {
  sessionChargeId?: InputMaybe<Scalars['String']['input']>;
};

export type RefundPaymentResult = {
  __typename?: 'RefundPaymentResult';
  success: Scalars['Boolean']['output'];
};

export type RegenerateOrganizationInvoiceInput = {
  organizationInvoiceId: Scalars['String']['input'];
  voidReason?: InputMaybe<Scalars['String']['input']>;
};

export type RegenerateOrganizationInvoiceResult = {
  __typename?: 'RegenerateOrganizationInvoiceResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveBounceByUserIdInput = {
  userId: Scalars['Int']['input'];
  userType: UserTypeEnum;
};

export type RemoveBounceByUserIdResult = {
  __typename?: 'RemoveBounceByUserIdResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveSelfFromSessionInput = {
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  sessionCancellationReasonId?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['Int']['input'];
};

export type RemoveSelfFromSessionResult = {
  __typename?: 'RemoveSelfFromSessionResult';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveUserFromSuppressionGroupInput = {
  suppressionGroupId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  userType: UserTypeEnum;
};

export type RemoveUserFromSuppressionGroupResult = {
  __typename?: 'RemoveUserFromSuppressionGroupResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestEmailChangeInput = {
  email: Scalars['String']['input'];
};

export type RequestOpportunitiesCandidateInput = {
  id: Scalars['String']['input'];
};

export type RequestOpportunitiesCandidateResult = {
  __typename?: 'RequestOpportunitiesCandidateResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestOpportunitiesCandidateSupportInput = {
  message: Scalars['String']['input'];
  opportunitiesCandidateId: Scalars['String']['input'];
};

export type RequestOpportunitiesCandidateSupportResult = {
  __typename?: 'RequestOpportunitiesCandidateSupportResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestRecommendationInput = {
  requestText: Scalars['String']['input'];
  superviseeUserId: Scalars['Int']['input'];
};

export type RequestRecommendationResult = {
  __typename?: 'RequestRecommendationResult';
  recommendation?: Maybe<Recommendation>;
  success: Scalars['Boolean']['output'];
};

export type RequestSupervisorTerminationInput = {
  forceTerminate?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rematchableSuperviseeUserIds: Array<Scalars['Int']['input']>;
  supervisorUserId: Scalars['Int']['input'];
  userDeleteReasonId: Scalars['Int']['input'];
  voluntary: Scalars['Boolean']['input'];
};

export type RequestSupervisorTerminationResult = {
  __typename?: 'RequestSupervisorTerminationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResendTransactionInput = {
  sessionChargeId: Scalars['String']['input'];
};

export type ResendTransactionReceiptResult = {
  __typename?: 'ResendTransactionReceiptResult';
  success: Scalars['Boolean']['output'];
};

export type ResetAdminPasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type ResetAdminPasswordResult = {
  __typename?: 'ResetAdminPasswordResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetNewUserPasswordInput = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetNewUserPasswordResult = {
  __typename?: 'ResetNewUserPasswordResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ResetPasswordError {
  TokenExpired = 'TOKEN_EXPIRED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type ResetPasswordErrorResult = {
  __typename?: 'ResetPasswordErrorResult';
  error?: Maybe<ResetPasswordError>;
};

export type ResetPasswordInput = {
  verificationToken: Scalars['String']['input'];
};

export type ResetPasswordResult = ResetPasswordErrorResult | ResetPasswordSuccessResult;

export type ResetPasswordSuccessResult = {
  __typename?: 'ResetPasswordSuccessResult';
  resetPasswordURL?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResumeUserSupervisionInput = {
  userId: Scalars['Int']['input'];
};

export type RetryChargeInput = {
  sessionChargeId: Scalars['String']['input'];
};

export type RetryChargeResult = {
  __typename?: 'RetryChargeResult';
  success: Scalars['Boolean']['output'];
};

export type RevokeOAuthTokenInput = {
  id: Scalars['Int']['input'];
};

export type ScheduleIntroRequestInput = {
  id: Scalars['String']['input'];
  scheduledAt: Scalars['Date']['input'];
};

export type ScheduleIntroRequestResult = {
  __typename?: 'ScheduleIntroRequestResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ScheduleOrganizationUserForRemovalInput = {
  id: Scalars['Int']['input'];
  isSelectedRemovalDateToday: Scalars['Boolean']['input'];
  removalReasonId: Scalars['Int']['input'];
  removalReasonText?: InputMaybe<Scalars['String']['input']>;
  scheduledForRemovalOnDate: Scalars['String']['input'];
};

export type ScheduleOrganizationUserForRemovalResult = {
  __typename?: 'ScheduleOrganizationUserForRemovalResult';
  success: Scalars['Boolean']['output'];
  wasSuperviseeRemovedImmediately: Scalars['Boolean']['output'];
};

export type SearchSupervisorsQueryResult = {
  __typename?: 'SearchSupervisorsQueryResult';
  result: Array<User>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SendIntroCallRequestForOpportunityInput = {
  opportunityId: Scalars['String']['input'];
};

export type SendMissingAttendanceEmailInput = {
  supervisorId: Scalars['Int']['input'];
};

export type SendMissingAttendanceEmailResult = {
  __typename?: 'SendMissingAttendanceEmailResult';
  success: Scalars['Boolean']['output'];
};

export type SendMissingNotesNotificationInput = {
  supervisorId: Scalars['Int']['input'];
};

export type SendMissingNotesNotificationResult = {
  __typename?: 'SendMissingNotesNotificationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendOrganizationInvoiceInput = {
  organizationInvoiceId: Scalars['String']['input'];
};

export type SendOrganizationInvoiceResult = {
  __typename?: 'SendOrganizationInvoiceResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendResetOrganizationAdminPasswordEmailInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type SendResetOrganizationAdminPasswordEmailResult = {
  __typename?: 'SendResetOrganizationAdminPasswordEmailResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendSupervisorApplicationApprovalInput = {
  externalSupervisorRequestId?: InputMaybe<Scalars['Int']['input']>;
  supervisorApplicationId: Scalars['String']['input'];
};

export type Session = {
  __typename?: 'Session';
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledBy?: Maybe<User>;
  cancelledByActorId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isViewerSupervisor: Scalars['Boolean']['output'];
  joinUrl?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['Int']['output'];
  meetingUrl?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationSession?: Maybe<OrganizationSession>;
  payouts: Array<Payout>;
  recurrenceLabel?: Maybe<Scalars['String']['output']>;
  recurrenceRule?: Maybe<SessionRecurrenceRule>;
  /** True if the session's organization requires notes or any of the attendees in the session are in a program that requires notes. DO NOT query this field if querying a list of sessions. */
  requiresNotes?: Maybe<Scalars['Boolean']['output']>;
  scheduledAt: Scalars['Date']['output'];
  sessionAttendees: Array<SessionAttendee>;
  sessionCancellationReason?: Maybe<SessionCancellationReason>;
  sessionCancellationReasonId?: Maybe<Scalars['Int']['output']>;
  sessionDispositionId: Scalars['Int']['output'];
  sessionNoteDrafts: Array<SessionNoteDraft>;
  sessionNotes: Array<SessionNote>;
  sessionType: SessionType;
  sessionTypeId: Scalars['Int']['output'];
  supervisor: User;
  supervisorSignature?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  transfers: Array<Transfer>;
  unavailableParty?: Maybe<User>;
  unavailablePartyUserId?: Maybe<Scalars['Int']['output']>;
  zoomMeetingData?: Maybe<ZoomMeetingData>;
};

export type SessionAttendee = {
  __typename?: 'SessionAttendee';
  attended?: Maybe<Scalars['Boolean']['output']>;
  b2cSessionAttendee?: Maybe<B2CSessionAttendee>;
  billable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  match: Match;
  matchId: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  partialAttendanceMinutes?: Maybe<Scalars['Int']['output']>;
  sessionCharge?: Maybe<SessionCharge>;
  sessionCharges: Array<SessionCharge>;
  signature?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
};

export type SessionAttendeeInputType = {
  attended: Scalars['Boolean']['input'];
  billable: Scalars['Boolean']['input'];
  partialAttendanceMinutes?: InputMaybe<Scalars['Int']['input']>;
  sessionAttendeeUserId: Scalars['Int']['input'];
};

export type SessionAttendeeNpsResponse = {
  __typename?: 'SessionAttendeeNpsResponse';
  additionalFeedback?: Maybe<Scalars['String']['output']>;
  communicationRating?: Maybe<Scalars['Int']['output']>;
  feedbackRating?: Maybe<Scalars['Int']['output']>;
  finalizedAt?: Maybe<Scalars['Date']['output']>;
  goalsRating?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  npsScore?: Maybe<Scalars['Int']['output']>;
  sessionAttendeeId: Scalars['Int']['output'];
  supportRating?: Maybe<Scalars['Int']['output']>;
  trustRating?: Maybe<Scalars['Int']['output']>;
};

export type SessionAttendeeUser = {
  __typename?: 'SessionAttendeeUser';
  attended?: Maybe<Scalars['Boolean']['output']>;
  billable?: Maybe<Scalars['Boolean']['output']>;
  partialAttendanceMinutes?: Maybe<Scalars['Int']['output']>;
  user: User;
};

export type SessionAttendees = {
  __typename?: 'SessionAttendees';
  sessionAttendees: Array<SessionAttendeeUser>;
};

export type SessionCancellationReason = {
  __typename?: 'SessionCancellationReason';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SessionCharge = {
  __typename?: 'SessionCharge';
  amountInCents: Scalars['Int']['output'];
  braintreeTransactionId?: Maybe<Scalars['String']['output']>;
  chargeStatusId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  finalAmountInCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  receiptEmailedAt?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SessionNote = {
  __typename?: 'SessionNote';
  answer: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  question: Scalars['String']['output'];
  sessionId: Scalars['Int']['output'];
};

export type SessionNoteDraft = {
  __typename?: 'SessionNoteDraft';
  answer: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  question: Scalars['String']['output'];
  sessionId: Scalars['Int']['output'];
};

export type SessionNoteDraftInput = {
  answer: Scalars['String']['input'];
  key: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type SessionNoteInput = {
  answer: Scalars['String']['input'];
  key: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type SessionRate = {
  __typename?: 'SessionRate';
  dyadAmountInCents: Scalars['Int']['output'];
  groupAmountInCents: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  individualAmountInCents: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SessionRecurrenceRule = {
  __typename?: 'SessionRecurrenceRule';
  endsAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interval: Scalars['Int']['output'];
  monthlyWeek?: Maybe<Scalars['Int']['output']>;
  occurrences?: Maybe<Scalars['Int']['output']>;
  recurrenceType: Scalars['Int']['output'];
  weeklyDay: Scalars['Int']['output'];
};

export type SessionType = {
  __typename?: 'SessionType';
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum SessionsForBillingFilter {
  B2BOnly = 'B2B_ONLY',
  B2COnly = 'B2C_ONLY',
  Billable = 'BILLABLE',
  NotBillable = 'NOT_BILLABLE'
}

export type SessionsForBillingQueryResult = {
  __typename?: 'SessionsForBillingQueryResult';
  result?: Maybe<Array<Session>>;
};

export type SessionsQueryResult = {
  __typename?: 'SessionsQueryResult';
  result: Array<Session>;
  total: Scalars['Int']['output'];
};

export type SessionsSummaryResult = {
  __typename?: 'SessionsSummaryResult';
  dyadMinutes: Scalars['Int']['output'];
  groupMinutes: Scalars['Int']['output'];
  individualMinutes: Scalars['Int']['output'];
  totalMinutes: Scalars['Int']['output'];
};

export type SetHighPriorityStateLicenseCategoryCombinationInput = {
  highPriority: Scalars['Boolean']['input'];
  licenseCategoryId: Scalars['Int']['input'];
  usStateId: Scalars['Int']['input'];
};

export type SetPreferredCreditCardForOrganizationInput = {
  id: Scalars['String']['input'];
};

export type SetPreferredCreditCardForOrganizationResult = {
  __typename?: 'SetPreferredCreditCardForOrganizationResult';
  success: Scalars['Boolean']['output'];
};

export type SetPreferredCreditCardInput = {
  fromMotivoProduct?: InputMaybe<FromMotivoProduct>;
  id: Scalars['String']['input'];
};

export type SetPreferredCreditCardResult = {
  __typename?: 'SetPreferredCreditCardResult';
  success: Scalars['Boolean']['output'];
};

export type SignSessionNotesAsSuperviseeInput = {
  sessionId: Scalars['Int']['input'];
};

export type SignSessionNotesAsSuperviseeResult = {
  __typename?: 'SignSessionNotesAsSuperviseeResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Specialty = {
  __typename?: 'Specialty';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StripeBalanceTransaction = {
  __typename?: 'StripeBalanceTransaction';
  amount: Scalars['Int']['output'];
  created: Scalars['Int']['output'];
  creditNoteUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  amountDue: Scalars['Int']['output'];
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: StripeInvoiceStatus;
};

export enum StripeInvoiceStatus {
  Deleted = 'deleted',
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export type SubmitCourseFormInput = {
  courseEnrollmentId: Scalars['String']['input'];
  formVersionId: Scalars['String']['input'];
};

export type SubmitCourseFormResult = {
  __typename?: 'SubmitCourseFormResult';
  success: Scalars['Boolean']['output'];
};

export type SubscriptionPrice = {
  __typename?: 'SubscriptionPrice';
  amountInCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SuccessMutationResult = {
  __typename?: 'SuccessMutationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SuccessWithErrorMessageMutationResult = {
  __typename?: 'SuccessWithErrorMessageMutationResult';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SuggestAlternateIntroRequestTimesInput = {
  alternateTimes: Array<Scalars['Date']['input']>;
  introRequestId: Scalars['String']['input'];
};

export type SuggestAlternateIntroRequestTimesResult = {
  __typename?: 'SuggestAlternateIntroRequestTimesResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SuperviseeCompletedHoursResult = {
  __typename?: 'SuperviseeCompletedHoursResult';
  dyadHours: Scalars['Float']['output'];
  groupHours: Scalars['Float']['output'];
  individualHours: Scalars['Float']['output'];
  totalHours: Scalars['Float']['output'];
};

export type SuperviseeOnboardingDataInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  clinicalSettingId?: InputMaybe<Scalars['Int']['input']>;
  hasGraduated?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermission?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecuredEmployment?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecuredPlacement?: InputMaybe<Scalars['Boolean']['input']>;
  isSeeingClients?: InputMaybe<Scalars['Boolean']['input']>;
  isStudent?: InputMaybe<Scalars['Boolean']['input']>;
  joinReasonId?: InputMaybe<Scalars['Int']['input']>;
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  licensureUsStateId?: InputMaybe<Scalars['Int']['input']>;
  needsProvisionalLicense?: InputMaybe<Scalars['Boolean']['input']>;
  placementSite?: InputMaybe<Scalars['String']['input']>;
  supervisionRatesAcceptedAt?: InputMaybe<Scalars['String']['input']>;
  usStateId?: InputMaybe<Scalars['Int']['input']>;
};

export type SuperviseeOnboardingInfo = {
  __typename?: 'SuperviseeOnboardingInfo';
  clinicalSettingId?: Maybe<Scalars['Int']['output']>;
  hasPermission?: Maybe<Scalars['Boolean']['output']>;
  hasSecuredEmployment?: Maybe<Scalars['Boolean']['output']>;
  hasSecuredPlacement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isSeeingClients?: Maybe<Scalars['Boolean']['output']>;
  joinReasonId: Scalars['Int']['output'];
  license?: Maybe<License>;
  licenseCategory?: Maybe<LicenseCategory>;
  licenseCategoryId?: Maybe<Scalars['Int']['output']>;
  licenseId?: Maybe<Scalars['Int']['output']>;
  licensureUsState?: Maybe<UsState>;
  licensureUsStateId?: Maybe<Scalars['Int']['output']>;
  needsProvisionalLicense?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  placementSite?: Maybe<Scalars['String']['output']>;
  referralSourceId?: Maybe<Scalars['Int']['output']>;
  referrerName?: Maybe<Scalars['String']['output']>;
  startSupervisionBy?: Maybe<Scalars['String']['output']>;
  supervisor?: Maybe<User>;
  supervisorUserId: Scalars['Int']['output'];
  worksAtForProfit?: Maybe<Scalars['Boolean']['output']>;
};

export type SuperviseeProfile = {
  __typename?: 'SuperviseeProfile';
  clinicalHours: Scalars['Float']['output'];
  clinicalHoursUpdatedAt?: Maybe<Scalars['Date']['output']>;
  dyadExternalHours: Scalars['Float']['output'];
  groupExternalHours: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  individualExternalHours: Scalars['Float']['output'];
  isStudent?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<License>;
  licenseCategory?: Maybe<LicenseCategory>;
  licenseCategoryId?: Maybe<Scalars['Int']['output']>;
  licenseId?: Maybe<Scalars['Int']['output']>;
  licensureUsState?: Maybe<UsState>;
  licensureUsStateId?: Maybe<Scalars['Int']['output']>;
};

export type SuperviseeProfileInput = {
  clinicalHours?: InputMaybe<Scalars['Float']['input']>;
  dyadExternalHours?: InputMaybe<Scalars['Float']['input']>;
  groupExternalHours?: InputMaybe<Scalars['Float']['input']>;
  individualExternalHours?: InputMaybe<Scalars['Float']['input']>;
  isStudent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuperviseesByOrganizationProgramIdQueryResult = {
  __typename?: 'SuperviseesByOrganizationProgramIdQueryResult';
  result?: Maybe<Array<User>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SupervisionCredential = {
  __typename?: 'SupervisionCredential';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SupervisionGoal = {
  __typename?: 'SupervisionGoal';
  createdAt: Scalars['Date']['output'];
  goals: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  superviseeUserId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SupervisionPausedOrResumedBy = {
  __typename?: 'SupervisionPausedOrResumedBy';
  actorType: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type SupervisionRule = {
  __typename?: 'SupervisionRule';
  additionalSupervisionNotes?: Maybe<Scalars['String']['output']>;
  boardApprovalAdditionalNotes?: Maybe<Scalars['String']['output']>;
  boardApprovalForms?: Maybe<Scalars['String']['output']>;
  boardApprovalReference?: Maybe<Scalars['String']['output']>;
  boardApprovalRequired?: Maybe<Scalars['String']['output']>;
  dyadHoursRequired?: Maybe<Scalars['String']['output']>;
  groupHoursRequired?: Maybe<Scalars['String']['output']>;
  groupSize?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  individualHoursRequired?: Maybe<Scalars['String']['output']>;
  licenseCategory: LicenseCategory;
  licenseCategoryId: Scalars['Int']['output'];
  minimumSupervisionFrequency?: Maybe<Scalars['String']['output']>;
  stateSpecificLicense: Scalars['String']['output'];
  supervisionAgreementRequired?: Maybe<Scalars['String']['output']>;
  supervisionRulesReferences: Scalars['String']['output'];
  supervisionTotalHoursRequired: Scalars['String']['output'];
  telesupervisionBoardContact: Scalars['String']['output'];
  telesupervisionLastUpdatedOn: Scalars['String']['output'];
  telesupervisionMotivoAssessment: Scalars['String']['output'];
  telesupervisionRuleDetails: Scalars['String']['output'];
  telesupervisionRuleLocation: Scalars['String']['output'];
  telesupervisionRuleUrl: Scalars['String']['output'];
  usState: UsState;
  usStateId: Scalars['Int']['output'];
};

export type SupervisorApplication = {
  __typename?: 'SupervisorApplication';
  autoApprove?: Maybe<Scalars['Boolean']['output']>;
  beganPracticingYear?: Maybe<Scalars['Int']['output']>;
  completedOnboardingAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  declineReasonText?: Maybe<Scalars['String']['output']>;
  doesInPerson?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  finalizedAt?: Maybe<Scalars['Date']['output']>;
  finalizedByAdmin?: Maybe<Admin>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  modalities?: Maybe<Array<Modality>>;
  originalLicenses?: Maybe<Scalars['String']['output']>;
  originalStates?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  populationIds?: Maybe<Array<Scalars['Int']['output']>>;
  populations?: Maybe<Array<Population>>;
  referralSourceText?: Maybe<Scalars['String']['output']>;
  resumeDocumentId?: Maybe<Scalars['String']['output']>;
  resumeUserDocument?: Maybe<UserDocument>;
  sessionTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
  sessionTypes?: Maybe<Array<SessionType>>;
  specialties?: Maybe<Array<Specialty>>;
  supervisorApplicationDeclineReason?: Maybe<SupervisorApplicationDeclineReason>;
  supervisorApplicationDeclineReasonId?: Maybe<Scalars['Int']['output']>;
  supervisorApplicationStatusId: Scalars['Int']['output'];
  supervisorApplicationsLicenses: Array<SupervisorApplicationsLicense>;
  supervisorApplicationsSupervisionCredentials?: Maybe<Array<SupervisorApplicationsSupervisionCredential>>;
  supervisorReferralSource?: Maybe<SupervisorReferralSource>;
  supervisorReferralSourceId?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  weeklyAvailableHours?: Maybe<Scalars['Int']['output']>;
  zipcode: Scalars['String']['output'];
};


export type SupervisorApplicationModalitiesArgs = {
  filtered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SupervisorApplicationSpecialtiesArgs = {
  filtered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupervisorApplicationDeclineReason = {
  __typename?: 'SupervisorApplicationDeclineReason';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SupervisorApplicationsLicense = {
  __typename?: 'SupervisorApplicationsLicense';
  id: Scalars['String']['output'];
  license: License;
  licenseId: Scalars['Int']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  supervisorApplicationId: Scalars['String']['output'];
  usState?: Maybe<UsState>;
  usStateId?: Maybe<Scalars['Int']['output']>;
};

export type SupervisorApplicationsQueryResult = {
  __typename?: 'SupervisorApplicationsQueryResult';
  result: Array<SupervisorApplication>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SupervisorApplicationsSupervisionCredential = {
  __typename?: 'SupervisorApplicationsSupervisionCredential';
  id: Scalars['String']['output'];
  supervisionCredential?: Maybe<SupervisionCredential>;
  supervisionCredentialId?: Maybe<Scalars['Int']['output']>;
  supervisorApplicationId: Scalars['String']['output'];
  usState?: Maybe<UsState>;
  usStateId?: Maybe<Scalars['Int']['output']>;
};

export type SupervisorAvailabilityInput = {
  dayOfWeek: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type SupervisorAvailableTimeslotsByDayResult = {
  __typename?: 'SupervisorAvailableTimeslotsByDayResult';
  times: Array<Scalars['String']['output']>;
};

export type SupervisorAvailableTimeslotsResult = {
  __typename?: 'SupervisorAvailableTimeslotsResult';
  timesByDate: Array<AvailableTimeSlot>;
};

export type SupervisorBandwidth = {
  __typename?: 'SupervisorBandwidth';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export type SupervisorBookedTimeslotsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  supervisorUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type SupervisorBookedTimeslotsResult = {
  __typename?: 'SupervisorBookedTimeslotsResult';
  result?: Maybe<Array<BookedTimeSlot>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SupervisorIncident = {
  __typename?: 'SupervisorIncident';
  actionsTaken?: Maybe<Scalars['String']['output']>;
  additionalComments?: Maybe<Scalars['String']['output']>;
  assignedAt?: Maybe<Scalars['Date']['output']>;
  assignedByAdmin?: Maybe<Admin>;
  assignedByAdminId?: Maybe<Scalars['Int']['output']>;
  assignedToAdmin?: Maybe<Admin>;
  assignedToAdminId?: Maybe<Scalars['Int']['output']>;
  complianceIssues: Array<ComplianceIssue>;
  complianceIssuesOther?: Maybe<Scalars['String']['output']>;
  conductIssues: Array<ConductIssue>;
  conductIssuesOther?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdByAdmin: Admin;
  createdByAdminId?: Maybe<Scalars['Int']['output']>;
  hubspotTicketId?: Maybe<Scalars['String']['output']>;
  hubspotTicketUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  incidentDate: Scalars['String']['output'];
  incidentDescription?: Maybe<Scalars['String']['output']>;
  incidentReportMethods: Array<IncidentReportMethod>;
  incidentReportMethodsOther?: Maybe<Scalars['String']['output']>;
  incidentReportStatus: IncidentReportStatus;
  incidentReportStatusId: Scalars['Int']['output'];
  incidentReporterNames?: Maybe<Scalars['String']['output']>;
  incidentReporters: Array<IncidentReporter>;
  incidentReportersOther?: Maybe<Scalars['String']['output']>;
  incidentStrike?: Maybe<SupervisorIncidentStrike>;
  linksToSupportingDocuments?: Maybe<Scalars['String']['output']>;
  possibleImpactOfIncident?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  resolvedByAdmin?: Maybe<Admin>;
  resolvedByAdminId?: Maybe<Scalars['Int']['output']>;
  supervisee?: Maybe<User>;
  superviseeUserId?: Maybe<Scalars['Int']['output']>;
  supervisor: User;
  supervisorIncidentNotes: Array<SupervisorIncidentNote>;
  supervisorUserId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SupervisorIncidentNote = {
  __typename?: 'SupervisorIncidentNote';
  createdAt: Scalars['Date']['output'];
  createdByAdmin: Admin;
  createdByAdminId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  supervisorIncidentId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SupervisorIncidentStrike = {
  __typename?: 'SupervisorIncidentStrike';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdByAdmin?: Maybe<Admin>;
  createdByAdminId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  supervisorIncidentId: Scalars['Int']['output'];
};

export enum SupervisorIncidentsOrderByEnum {
  CreatedAt = 'createdAt',
  IncidentDate = 'incidentDate',
  ResolvedAt = 'resolvedAt',
  UpdatedAt = 'updatedAt'
}

export type SupervisorIncidentsResult = {
  __typename?: 'SupervisorIncidentsResult';
  result: Array<SupervisorIncident>;
  total: Scalars['Int']['output'];
};

export type SupervisorProfile = {
  __typename?: 'SupervisorProfile';
  alignmentSessionCompletedOn?: Maybe<Scalars['String']['output']>;
  beganPracticingYear?: Maybe<Scalars['Int']['output']>;
  bio: Scalars['String']['output'];
  excludeFromAllB2bOpportunities: Scalars['Boolean']['output'];
  excludeFromOrganizationIdsOpportunities: Array<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastVettedByAdminAt?: Maybe<Scalars['Date']['output']>;
  liabilityInsuranceExpirationDate?: Maybe<Scalars['Date']['output']>;
  liabilityInsuranceUserDocument?: Maybe<UserDocument>;
  liabilityInsuranceUserDocumentId?: Maybe<Scalars['String']['output']>;
  markedAsNeedsFollowupAt?: Maybe<Scalars['Date']['output']>;
  npiNumber?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  profileVerifiedAt?: Maybe<Scalars['Date']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  quote: Scalars['String']['output'];
  resumeUserDocument?: Maybe<UserDocument>;
  resumeUserDocumentId?: Maybe<Scalars['String']['output']>;
  sessionTypes: Array<SessionType>;
  supervisesInPerson?: Maybe<Scalars['Boolean']['output']>;
  supervisorBandwidthId: Scalars['Int']['output'];
  supervisorBandwidthIdLastUpdatedAt?: Maybe<Scalars['Date']['output']>;
  supervisorProfileDispositionId: Scalars['Int']['output'];
  supervisorProfilePreferences?: Maybe<SupervisorProfilePreferences>;
  supervisorUnpublishReasonComment?: Maybe<Scalars['String']['output']>;
  supervisorUnpublishReasonId?: Maybe<Scalars['Int']['output']>;
  trainingCompletedOn?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  vetted?: Maybe<Scalars['Boolean']['output']>;
  vettedByAdmin?: Maybe<Admin>;
  vettedByAdminId?: Maybe<Scalars['Int']['output']>;
  vettingNotes?: Maybe<Scalars['String']['output']>;
  vettingStartedByAdmin?: Maybe<Admin>;
  vettingStartedByAdminId?: Maybe<Scalars['Int']['output']>;
  weeklyAvailableHours?: Maybe<Scalars['Float']['output']>;
};

export type SupervisorProfilePreferences = {
  __typename?: 'SupervisorProfilePreferences';
  calendarAfterBufferTimeMinutes: Scalars['Int']['output'];
  calendarAllowInstantBook: Scalars['Boolean']['output'];
  calendarBeforeBufferTimeMinutes: Scalars['Int']['output'];
  calendarMinimumNoticeHours: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  supervisorProfileId: Scalars['Int']['output'];
};

export type SupervisorProfilePreferencesInput = {
  calendarAfterBufferTimeMinutes: Scalars['Int']['input'];
  calendarAllowInstantBook: Scalars['Boolean']['input'];
  calendarBeforeBufferTimeMinutes: Scalars['Int']['input'];
  calendarMinimumNoticeHours: Scalars['Int']['input'];
};

export type SupervisorReferralSource = {
  __typename?: 'SupervisorReferralSource';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SupervisorSuperviseeLicensePairing = {
  __typename?: 'SupervisorSuperviseeLicensePairing';
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  superviseeLicenseCategory: LicenseCategory;
  superviseeLicenseCategoryId: Scalars['Int']['output'];
  superviseeSpecificLicense: License;
  superviseeSpecificLicenseId: Scalars['Int']['output'];
  supervisorCredential?: Maybe<SupervisionCredential>;
  supervisorCredentialId?: Maybe<Scalars['Int']['output']>;
  supervisorLicenseCategory: LicenseCategory;
  supervisorLicenseCategoryId: Scalars['Int']['output'];
  supervisorSpecificLicense: License;
  supervisorSpecificLicenseId: Scalars['Int']['output'];
  usState: UsState;
  usStateId: Scalars['Int']['output'];
};

export type SupervisorTerminationRequest = {
  __typename?: 'SupervisorTerminationRequest';
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  rematchableSuperviseeUserIds?: Maybe<Array<Scalars['Int']['output']>>;
  terminationDate: Scalars['String']['output'];
  userDeleteReasonId: Scalars['Int']['output'];
  voluntary: Scalars['Boolean']['output'];
};

export type SupervisorUnpublishReason = {
  __typename?: 'SupervisorUnpublishReason';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SupervisorWithMissingAttendance = {
  __typename?: 'SupervisorWithMissingAttendance';
  sessions: Array<Session>;
  supervisor: User;
};

export type SupervisorWithMissingNotes = {
  __typename?: 'SupervisorWithMissingNotes';
  sessions?: Maybe<Array<Session>>;
  supervisor?: Maybe<User>;
};

export type SupervisorsWithMissingAttendanceResult = {
  __typename?: 'SupervisorsWithMissingAttendanceResult';
  result: Array<SupervisorWithMissingAttendance>;
};

export type SupervisorsWithMissingNotesResult = {
  __typename?: 'SupervisorsWithMissingNotesResult';
  result?: Maybe<Array<SupervisorWithMissingNotes>>;
};

export type TentativeMatch = {
  __typename?: 'TentativeMatch';
  actor: Actor;
  actorId: Scalars['Int']['output'];
  actorRespondedAt?: Maybe<Scalars['Date']['output']>;
  actorResponse: TentativeMatchResponse;
  actorResponseId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  supervisor: User;
  supervisorRespondedAt?: Maybe<Scalars['Date']['output']>;
  supervisorResponse: TentativeMatchResponse;
  supervisorResponseId?: Maybe<Scalars['Int']['output']>;
  supervisorUserId: Scalars['Int']['output'];
};

export type TentativeMatchResponse = {
  __typename?: 'TentativeMatchResponse';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum Timeslot {
  IntroRequest = 'introRequest',
  ProposedSession = 'proposedSession',
  Session = 'session'
}

export type ToggleOpportunityAutoRequestInput = {
  id: Scalars['String']['input'];
  start: Scalars['Boolean']['input'];
};

export type Topic = {
  __typename?: 'Topic';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Transfer = {
  __typename?: 'Transfer';
  amountInCents: Scalars['Int']['output'];
  billableWorkRecord?: Maybe<BillableWorkRecord>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  paidOutAt?: Maybe<Scalars['Date']['output']>;
  session?: Maybe<Session>;
  stripeTransferId: Scalars['String']['output'];
  stripeTransferLink: Scalars['String']['output'];
};

export type TrueFalseInputQuestion = {
  choices: TrueFalseInputQuestionChoices;
  question: Scalars['String']['input'];
  questionTypeId: Scalars['Int']['input'];
  sort: Scalars['Int']['input'];
};

export type TrueFalseInputQuestionChoices = {
  correctAnswer: Scalars['Boolean']['input'];
};

export type TrueFalseQuestion = {
  __typename?: 'TrueFalseQuestion';
  choices: TrueFalseQuestionChoices;
  id: Scalars['String']['output'];
  question: Scalars['String']['output'];
  questionTypeId: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
};

export type TrueFalseQuestionChoices = {
  __typename?: 'TrueFalseQuestionChoices';
  correctAnswer: Scalars['Boolean']['output'];
};

export type UsState = {
  __typename?: 'USState';
  abbreviation?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type UsStatesLicenseCategory = {
  __typename?: 'USStatesLicenseCategory';
  id: Scalars['Int']['output'];
  licenseCategory: LicenseCategory;
  licenseCategoryId: Scalars['Int']['output'];
  usState?: Maybe<UsState>;
  usStateId: Scalars['Int']['output'];
};

export type UnenrollUserFromCourseInput = {
  courseId: Scalars['String']['input'];
};

export type UnenrollUserFromCourseResult = {
  __typename?: 'UnenrollUserFromCourseResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnmatchSuperviseeReason = {
  __typename?: 'UnmatchSuperviseeReason';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnpublishSupervisorProfileInput = {
  id: Scalars['Int']['input'];
  supervisorUnpublishReasonComment?: InputMaybe<Scalars['String']['input']>;
  supervisorUnpublishReasonId: Scalars['Int']['input'];
};

export type UnpublishSupervisorProfileResult = {
  __typename?: 'UnpublishSupervisorProfileResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnvettedSupervisorsResult = {
  __typename?: 'UnvettedSupervisorsResult';
  result: Array<User>;
  total: Scalars['Int']['output'];
};

export type UpcomingSessionsQueryResult = {
  __typename?: 'UpcomingSessionsQueryResult';
  nextCursor?: Maybe<Scalars['String']['output']>;
  result: Array<Session>;
};

export type UpdateAdminProfileInput = {
  adminRoleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  calendlyUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  slackUserId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zoomUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdminProfileResult = {
  __typename?: 'UpdateAdminProfileResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateBillableWorkAssigneeByIdInput = {
  id: Scalars['String']['input'];
  organizationProgramIds: Array<Scalars['String']['input']>;
};

export type UpdateBillableWorkAssigneeByIdResult = {
  __typename?: 'UpdateBillableWorkAssigneeByIdResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateCourseFormResponseProgressAnswerInput = {
  formQuestionId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateCourseFormResponseProgressInput = {
  answers: Array<UpdateCourseFormResponseProgressAnswerInput>;
  courseEnrollmentId: Scalars['String']['input'];
  formVersionId: Scalars['String']['input'];
};

export type UpdateCourseFormResponseProgressResult = {
  __typename?: 'UpdateCourseFormResponseProgressResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateCourseInput = {
  accreditationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  courseTypeId: Scalars['Int']['input'];
  creditHours: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  evaluationFormId?: InputMaybe<Scalars['String']['input']>;
  flagship?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  licenseCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  masteryFormId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  panelistIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledFor?: InputMaybe<Scalars['Date']['input']>;
  summary: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateCourseResult = {
  __typename?: 'UpdateCourseResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCourseThumbnailInput = {
  id: Scalars['String']['input'];
  thumbnail: Scalars['Upload']['input'];
};

export type UpdateCourseThumbnailResult = {
  __typename?: 'UpdateCourseThumbnailResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCredentialingBodyAccreditationInput = {
  approvalStatementTemplate: Scalars['String']['input'];
  approvedOn: Scalars['String']['input'];
  expiresOn: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  providerNumber: Scalars['String']['input'];
};

export type UpdateCredentialingBodyAccreditationResult = {
  __typename?: 'UpdateCredentialingBodyAccreditationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateExternalSupervisorRequestInput = {
  desiredStartDate?: InputMaybe<Scalars['String']['input']>;
  externalSupervisorRequestId: Scalars['Int']['input'];
  externalSupervisorRequestSourceId?: InputMaybe<Scalars['Int']['input']>;
  externalSupervisorRequestStatusId?: InputMaybe<Scalars['Int']['input']>;
  externalSupervisorRequestUrgencyId?: InputMaybe<Scalars['Int']['input']>;
  isSpecialtyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfSupervisees?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  sessionTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  usStateId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFormInput = {
  graded: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  passingPercentage?: InputMaybe<Scalars['Int']['input']>;
  questions: Array<QuestionInput>;
};

export type UpdateFormResult = {
  __typename?: 'UpdateFormResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateInternalUserNotesInput = {
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type UpdateInternalUserNotesResult = {
  __typename?: 'UpdateInternalUserNotesResult';
  internalNotes?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateIntroRequestByIdInput = {
  availableSlots?: InputMaybe<Array<Scalars['Date']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  clinicalSettingId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  isSeeingClients?: InputMaybe<Scalars['Boolean']['input']>;
  joinReasonId?: InputMaybe<Scalars['Int']['input']>;
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  licensureUsStateId?: InputMaybe<Scalars['Int']['input']>;
  modalitiesIds: Array<Scalars['Int']['input']>;
  needsProvisionalLicense?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  placementSite?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['Date']['input']>;
  specialtiesIds: Array<Scalars['Int']['input']>;
  startSupervisionBy?: InputMaybe<Scalars['String']['input']>;
  usStateId: Scalars['Int']['input'];
};

export type UpdateIntroRequestByIdResult = {
  __typename?: 'UpdateIntroRequestByIdResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateIntroRequestOrganizationInfoInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  clinicalQuestions?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  sessionTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  superviseeInfo: Scalars['String']['input'];
  supervisionStartTime: Scalars['String']['input'];
  weeklyHours: Scalars['Int']['input'];
};

export type UpdateIntroRequestOrganizationInfoResult = {
  __typename?: 'UpdateIntroRequestOrganizationInfoResult';
  id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateJobListingInput = {
  county?: InputMaybe<Scalars['String']['input']>;
  descriptionMarkdown: Scalars['String']['input'];
  externalJobId?: InputMaybe<Scalars['String']['input']>;
  externalJobUrl?: InputMaybe<Scalars['String']['input']>;
  jobListingLocationId?: InputMaybe<Scalars['Int']['input']>;
  licenseCategoryIds: Array<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['Int']['input'];
  salary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  usStateId: Scalars['Int']['input'];
};

export type UpdateMatchDocumentInput = {
  fileName: Scalars['String']['input'];
  matchDocumentId: Scalars['String']['input'];
};

export type UpdateNotificationSubscriptionsInput = {
  invoices?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyReports?: InputMaybe<Scalars['Boolean']['input']>;
  noShowEmails?: InputMaybe<Scalars['Boolean']['input']>;
  organizationAdminId?: InputMaybe<Scalars['Int']['input']>;
  rateIncreases?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorMatchEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNotificationSubscriptionsResult = {
  __typename?: 'UpdateNotificationSubscriptionsResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOpportunitiesCandidateInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type UpdateOpportunitiesCandidateResult = {
  __typename?: 'UpdateOpportunitiesCandidateResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOpportunityInput = {
  id: Scalars['String']['input'];
  licenseCategoryId: Scalars['Int']['input'];
  manualQueue?: InputMaybe<Scalars['Boolean']['input']>;
  modalityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  organizationAdminId?: InputMaybe<Scalars['Int']['input']>;
  populationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  requiresIntroCalls?: InputMaybe<Scalars['Boolean']['input']>;
  sessionTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  specialtyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  supervisionAvailability?: InputMaybe<Scalars['String']['input']>;
  supervisionStartBy?: InputMaybe<Scalars['String']['input']>;
  usStateId: Scalars['Int']['input'];
  weeklyHours?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOpportunityResult = {
  __typename?: 'UpdateOpportunityResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOrganizationAdminInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  lastName: Scalars['String']['input'];
  programIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrganizationAdminProfileInput = {
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  clinicalSettingId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  introCallPreferenceId?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  populationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  requiresNotesInReports?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSupervisorAdminHours?: InputMaybe<Scalars['Boolean']['input']>;
  specialtyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  supervisionAvailability?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationAdminProfileResult = {
  __typename?: 'UpdateOrganizationAdminProfileResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOrganizationAdminResult = {
  __typename?: 'UpdateOrganizationAdminResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOrganizationCheckInsPreferenceInput = {
  hasCheckInsEnabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateOrganizationGrantInput = {
  id: Scalars['String']['input'];
  monthlyGrantCapInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrganizationInput = {
  accountManagerAdminId?: InputMaybe<Scalars['Int']['input']>;
  annualRateIncreasePercent?: InputMaybe<Scalars['Int']['input']>;
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  autoChargeInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  billableWorkRecordCaps?: InputMaybe<Array<BillableWorkRecordCapInput>>;
  canRemoveSupervisees?: InputMaybe<Scalars['Boolean']['input']>;
  contractStartDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Int']['input']>;
  dyadRateTotalInCents?: InputMaybe<Scalars['Int']['input']>;
  dyadTotalPayoutAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  effectiveISODate?: InputMaybe<Scalars['String']['input']>;
  groupRateTotalInCents?: InputMaybe<Scalars['Int']['input']>;
  groupTotalPayoutAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  individualRateTotalInCents?: InputMaybe<Scalars['Int']['input']>;
  individualTotalPayoutAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  introCallPreferenceId?: InputMaybe<Scalars['Int']['input']>;
  invoiceMemo?: InputMaybe<Scalars['String']['input']>;
  licenseCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  modalityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  monthlyAnthemCreditCapInCents?: InputMaybe<Scalars['Int']['input']>;
  monthlyMinimumHours?: InputMaybe<Scalars['Float']['input']>;
  monthlyMinimumInCents?: InputMaybe<Scalars['Int']['input']>;
  monthlyServiceFeeInCents?: InputMaybe<Scalars['Int']['input']>;
  monthlyServiceFeePerSuperviseeInCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingFeeInCents?: InputMaybe<Scalars['Int']['input']>;
  populationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  primaryBillableWorkRecordTypeId?: InputMaybe<Scalars['Int']['input']>;
  requiresNotesInReports?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSupervisorAdminHours?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  sendMeetYourAccountManagerEmail?: InputMaybe<Scalars['Boolean']['input']>;
  specialtyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  stripeCustomerEmail?: InputMaybe<Scalars['String']['input']>;
  supervisionAvailability?: InputMaybe<Scalars['String']['input']>;
  usStateIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  usesInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationProgramNameInput = {
  name: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};

export type UpdateOrganizationProgramSettingsInput = {
  introCallPreferenceId?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['String']['input'];
  requiresNotesInReports?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSupervisorAdminHours?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationResult = {
  __typename?: 'UpdateOrganizationResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationSuperviseeOnboardingRequestInput = {
  blockedReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateOrganizationUserBillingCodeInput = {
  billingCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrganizationUserBillingCodeResult = {
  __typename?: 'UpdateOrganizationUserBillingCodeResult';
  organizationUser?: Maybe<OrganizationUser>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationUserDiscountInput = {
  discountPercentOverride?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePanelistInput = {
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  postnominals?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePanelistResult = {
  __typename?: 'UpdatePanelistResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProfileInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  availabilities?: InputMaybe<Array<UserAvailabilitiesListInput>>;
  beganPracticingYear?: InputMaybe<Scalars['Int']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clinicalSettingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContact?: InputMaybe<EmergencyContactInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  languagesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  liabilityInsuranceExpirationDate?: InputMaybe<Scalars['Date']['input']>;
  liabilityInsuranceUserDocument?: InputMaybe<Scalars['Upload']['input']>;
  modalitiesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  npiNumber?: InputMaybe<Scalars['String']['input']>;
  openZoomSessionsInApp?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  populationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  postnominals?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  prenominals?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['Upload']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  resumeUserDocument?: InputMaybe<Scalars['Upload']['input']>;
  sessionTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  specialtiesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  superviseeProfile?: InputMaybe<SuperviseeProfileInput>;
  supervisesInPerson?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorProfilePreferences?: InputMaybe<SupervisorProfilePreferencesInput>;
  telehealthTrainingUserDocumentIdsToDelete?: InputMaybe<Array<Scalars['String']['input']>>;
  telehealthTrainingUserDocuments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userClinicalTrainings?: InputMaybe<Array<UserClinicalTrainingsInput>>;
  userConnectedCalendars?: InputMaybe<Array<UserConnectedCalendarsInput>>;
  userPrimaryCalendar?: InputMaybe<UserPrimaryCalendarInput>;
  usersDegrees?: InputMaybe<Array<UsersDegreeInput>>;
  usersLicenses?: InputMaybe<Array<UsersLicensesInput>>;
  usersSupervisionCredentials?: InputMaybe<Array<UsersSupervisionCredentialsInput>>;
  weeklyAvailableHours?: InputMaybe<Scalars['Float']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfileResult = {
  __typename?: 'UpdateProfileResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSessionForAdminAttendeeInput = {
  attended?: InputMaybe<Scalars['Boolean']['input']>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  matchId: Scalars['Int']['input'];
  partialAttendanceMinutes?: InputMaybe<Scalars['Int']['input']>;
  sessionAttendeeId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSessionForAdminInput = {
  attendeesInput?: InputMaybe<Array<UpdateSessionForAdminAttendeeInput>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  scheduledAt?: InputMaybe<Scalars['Date']['input']>;
  sessionDispositionId?: InputMaybe<Scalars['Int']['input']>;
  sessionTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSessionForAdminResult = {
  __typename?: 'UpdateSessionForAdminResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateSessionInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  matchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledAt?: InputMaybe<Scalars['Date']['input']>;
  shouldEditThisAndUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSessionResult = {
  __typename?: 'UpdateSessionResult';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateSignatureInput = {
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSignatureResult = {
  __typename?: 'UpdateSignatureResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateStripeAccountMutationInput = {
  businessProfile: BusinessProfileEnum;
};

export type UpdateStripeAccountMutationResult = {
  __typename?: 'UpdateStripeAccountMutationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSuperviseeExternalHoursInput = {
  clinicalHours?: InputMaybe<Scalars['Float']['input']>;
  dyadExternalHours?: InputMaybe<Scalars['Float']['input']>;
  groupExternalHours?: InputMaybe<Scalars['Float']['input']>;
  individualExternalHours?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSuperviseeExternalHoursResult = {
  __typename?: 'UpdateSuperviseeExternalHoursResult';
  success: Scalars['Boolean']['output'];
};

export enum UpdateSuperviseeOnboardingInfoError {
  ActiveIntroRequestOrMatch = 'ACTIVE_INTRO_REQUEST_OR_MATCH',
  OrganizationIntroRequestError = 'ORGANIZATION_INTRO_REQUEST_ERROR'
}

export type UpdateSuperviseeOnboardingInfoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  clinicalSettingId?: InputMaybe<Scalars['Int']['input']>;
  hasSecuredEmployment?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecuredPlacement?: InputMaybe<Scalars['Boolean']['input']>;
  isSeeingClients?: InputMaybe<Scalars['Boolean']['input']>;
  joinReasonId?: InputMaybe<Scalars['Int']['input']>;
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  licensureUsStateId?: InputMaybe<Scalars['Int']['input']>;
  modalitiesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  needsProvisionalLicense?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  placementSite?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  referralSourceId?: InputMaybe<Scalars['Int']['input']>;
  referrerName?: InputMaybe<Scalars['String']['input']>;
  specialtiesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startSupervisionBy?: InputMaybe<Scalars['String']['input']>;
  supervisorUserId?: InputMaybe<Scalars['Int']['input']>;
  usStateId?: InputMaybe<Scalars['Int']['input']>;
  worksAtForProfit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSuperviseeOnboardingInfoResult = {
  __typename?: 'UpdateSuperviseeOnboardingInfoResult';
  error?: Maybe<UpdateSuperviseeOnboardingInfoError>;
  success: Scalars['Boolean']['output'];
  superviseeOnboardingInfo?: Maybe<SuperviseeOnboardingInfo>;
};

export type UpdateSuperviseeProgramInput = {
  programId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type UpdateSuperviseesInProgramInput = {
  programId: Scalars['String']['input'];
  userIds: Array<Scalars['Int']['input']>;
};

export type UpdateSuperviseesInProgramResult = {
  __typename?: 'UpdateSuperviseesInProgramResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSupervisionGoalInput = {
  goals: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateSupervisionGoalResult = {
  __typename?: 'UpdateSupervisionGoalResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSupervisorBandwidthInput = {
  supervisorBandwidthId: Scalars['Int']['input'];
  supervisorUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSupervisorBandwidthResult = {
  __typename?: 'UpdateSupervisorBandwidthResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSupervisorIncidentInput = {
  actionsTaken?: InputMaybe<Scalars['String']['input']>;
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  assignedToAdminId?: InputMaybe<Scalars['Int']['input']>;
  complianceIssueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  complianceIssuesOther?: InputMaybe<Scalars['String']['input']>;
  conductIssueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  conductIssuesOther?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  incidentDate?: InputMaybe<Scalars['String']['input']>;
  incidentDescription?: InputMaybe<Scalars['String']['input']>;
  incidentReportMethods?: InputMaybe<Array<Scalars['Int']['input']>>;
  incidentReportMethodsOther?: InputMaybe<Scalars['String']['input']>;
  incidentReportStatusId?: InputMaybe<Scalars['Int']['input']>;
  incidentReporterNames?: InputMaybe<Scalars['String']['input']>;
  incidentReporters?: InputMaybe<Array<Scalars['Int']['input']>>;
  incidentReportersOther?: InputMaybe<Scalars['String']['input']>;
  linksToSupportingDocuments?: InputMaybe<Scalars['String']['input']>;
  possibleImpactOfIncident?: InputMaybe<Scalars['String']['input']>;
  recommendations?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupervisorInformationByUserIdInput = {
  alignmentSessionCompletedOn?: InputMaybe<Scalars['String']['input']>;
  beganPracticingYear?: InputMaybe<Scalars['Int']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  clinicalSettingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeFromAllB2bOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromOrganizationIdsOpportunities?: InputMaybe<Array<Scalars['Int']['input']>>;
  languagesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  liabilityInsuranceExpirationDate?: InputMaybe<Scalars['Date']['input']>;
  liabilityInsuranceUserDocument?: InputMaybe<Scalars['Upload']['input']>;
  modalitiesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  npiNumber?: InputMaybe<Scalars['String']['input']>;
  populationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  postnominals?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  prenominals?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['Upload']['input']>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  resumeUserDocument?: InputMaybe<Scalars['Upload']['input']>;
  sessionTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  specialtiesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  telehealthTrainingUserDocumentIdsToDelete?: InputMaybe<Array<Scalars['String']['input']>>;
  telehealthTrainingUserDocuments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  trainingCompletedOn?: InputMaybe<Scalars['String']['input']>;
  userClinicalTrainings?: InputMaybe<Array<UserClinicalTrainingsInput>>;
  userId: Scalars['Int']['input'];
  usersDegrees?: InputMaybe<Array<UsersDegreeInput>>;
  usersLicenses?: InputMaybe<Array<UsersLicensesInput>>;
  usersSupervisionCredentials?: InputMaybe<Array<UsersSupervisionCredentialsInput>>;
};

export type UpdateSupervisorInformationResult = {
  __typename?: 'UpdateSupervisorInformationResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSupervisorVettingStartedByAdminIdInput = {
  supervisorUserId: Scalars['Int']['input'];
};

export type UpdateTopicInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTopicResult = {
  __typename?: 'UpdateTopicResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateUserFromSupervisorApplicationInput = {
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  beganPracticingYear?: InputMaybe<Scalars['Int']['input']>;
  clinicalSettingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isFinalApplicationStep?: InputMaybe<Scalars['Boolean']['input']>;
  liabilityInsuranceExpirationDate?: InputMaybe<Scalars['Date']['input']>;
  liabilityInsuranceUserDocument?: InputMaybe<Scalars['Upload']['input']>;
  modalityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  populationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resumeUserDocument?: InputMaybe<Scalars['Upload']['input']>;
  sessionTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  specialtyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  supervisesInPerson?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorApplicationId?: InputMaybe<Scalars['String']['input']>;
  supervisorBandwidthId?: InputMaybe<Scalars['Int']['input']>;
  telehealthTrainingUserDocuments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  usersLicenses?: InputMaybe<Array<UsersLicensesInput>>;
  usersSupervisionCredentials?: InputMaybe<Array<UsersSupervisionCredentialsInput>>;
  weeklyAvailableHours?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserHolidayBonusGoalExtraSessionCreditInput = {
  description: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateUserHolidayBonusGoalInput = {
  id: Scalars['Int']['input'];
  qualifyingSessionCountGoal: Scalars['Int']['input'];
};

export type UpdateUserNotificationPreferencesInput = {
  userNotificationPreferences: Array<UserNotificationPreferenceInputType>;
};

export type UpdateUserPrimaryCalendarInput = {
  id: Scalars['String']['input'];
  oauthTokenId: Scalars['Int']['input'];
};

export type UpdateUserProfileInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubspotId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  licensureUsStateId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['Upload']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
  zoomUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfileResult = {
  __typename?: 'UpdateUserProfileResult';
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

export type UpdateVettingNotesForSupervisorInput = {
  markedAsNeedsFollowup: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
  vettingNotes: Scalars['String']['input'];
};

export type UpsertFeatureFlagInput = {
  everyone: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpsertFeatureFlagResult = {
  __typename?: 'UpsertFeatureFlagResult';
  success: Scalars['Boolean']['output'];
};

export type UsStatesForOrganizationUsersResult = {
  __typename?: 'UsStatesForOrganizationUsersResult';
  usStates: Array<UsState>;
};

export type User = BaseUser & {
  __typename?: 'User';
  activeIntroRequestsAsSupervisee: Array<IntroRequest>;
  activeUserSupervisionPause?: Maybe<UserSupervisionPause>;
  actorId: Scalars['Int']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  attestationEsignDocument?: Maybe<EsignDocument>;
  avatarPath?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  baaEsignDocument?: Maybe<EsignDocument>;
  blockedAt?: Maybe<Scalars['Date']['output']>;
  canSuperviseesBookSessions: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  clinicalSettings: Array<ClinicalSetting>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creditCards?: Maybe<Array<CreditCard>>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emergencyContact?: Maybe<EmergencyContact>;
  enrolledCourses?: Maybe<Array<Course>>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  hasPrimaryCalendar: Scalars['Boolean']['output'];
  hasSetPassword: Scalars['Boolean']['output'];
  hubspotId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  isSupervisee: Scalars['Boolean']['output'];
  isSupervisor: Scalars['Boolean']['output'];
  languages: Array<Language>;
  largeAvatar?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  latLng?: Maybe<LatLng>;
  learningTermsAcceptedAt?: Maybe<Scalars['Date']['output']>;
  mediumAvatar?: Maybe<Scalars['String']['output']>;
  modalities?: Maybe<Array<Modality>>;
  opportunities: Array<Opportunity>;
  organization?: Maybe<Organization>;
  organizationSuperviseeOnboardingRequest?: Maybe<OrganizationSuperviseeOnboardingRequest>;
  organizationUser?: Maybe<OrganizationUser>;
  passwordSetAt?: Maybe<Scalars['Date']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  populations: Array<Population>;
  postnominals?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  prenominals?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Array<Recommendation>>;
  signature?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  smallAvatar?: Maybe<Scalars['String']['output']>;
  specialties: Array<Specialty>;
  stateId?: Maybe<Scalars['Int']['output']>;
  stripeConnectedAccountId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeVerified?: Maybe<Scalars['Boolean']['output']>;
  superviseeMatches: Array<Match>;
  superviseeOnboardingInfo?: Maybe<SuperviseeOnboardingInfo>;
  superviseeProfile?: Maybe<SuperviseeProfile>;
  supervisorApplication?: Maybe<SupervisorApplication>;
  supervisorIncidentStrikes: Array<SupervisorIncidentStrike>;
  supervisorIncidents: Array<SupervisorIncident>;
  supervisorMatches: Array<Match>;
  supervisorProfile?: Maybe<SupervisorProfile>;
  supervisorTerminationRequest?: Maybe<SupervisorTerminationRequest>;
  telehealthTrainingUserDocuments?: Maybe<Array<UserDocument>>;
  timezone?: Maybe<Scalars['String']['output']>;
  userAvailabilities: Array<UserAvailability>;
  userBookedTimeslots?: Maybe<Array<BookedTimeSlot>>;
  userClinicalTrainings: Array<UserClinicalTraining>;
  userDocuments?: Maybe<Array<UserDocument>>;
  userHolidayBonusGoal?: Maybe<UserHolidayBonusGoal>;
  userPrimaryCalendar?: Maybe<UserPrimaryCalendar>;
  userSubscription?: Maybe<UsersSubscription>;
  userSupervisionPauses: Array<UserSupervisionPause>;
  usersClinicalSettings: Array<UsersClinicalSetting>;
  usersDegrees: Array<UsersDegree>;
  usersLicenses: Array<UsersLicense>;
  usersModalities: Array<UsersModality>;
  usersPopulations: Array<UsersPopulation>;
  usersSpecialties: Array<UsersSpecialty>;
  usersSupervisionCredentials: Array<UsersSupervisionCredential>;
  zipcode?: Maybe<Scalars['String']['output']>;
  zoomUserId?: Maybe<Scalars['String']['output']>;
};


export type UserModalitiesArgs = {
  filtered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserOrganizationUserArgs = {
  deletedForOrganizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type UserSpecialtiesArgs = {
  filtered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserSupervisorIncidentsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserSupervisorMatchesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAvailabilitiesListInput = {
  dayOfWeek: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type UserAvailability = {
  __typename?: 'UserAvailability';
  dayOfWeek: Scalars['Int']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserAvailabilityResult = {
  __typename?: 'UserAvailabilityResult';
  availabilities: Array<UserAvailability>;
  weeklyAvailableHours?: Maybe<Scalars['Float']['output']>;
};

export type UserClinicalTraining = {
  __typename?: 'UserClinicalTraining';
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type UserClinicalTrainingsInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};

export type UserConnectedCalendar = {
  __typename?: 'UserConnectedCalendar';
  calendarId: Scalars['String']['output'];
  calendarName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  oauthTokenId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserConnectedCalendarsInput = {
  calendarId: Scalars['String']['input'];
  oauthTokenId: Scalars['Int']['input'];
};

export type UserDeleteReason = {
  __typename?: 'UserDeleteReason';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  voluntary?: Maybe<Scalars['Boolean']['output']>;
};

export type UserDiscount = {
  __typename?: 'UserDiscount';
  deletedAt?: Maybe<Scalars['Date']['output']>;
  discountType?: Maybe<DiscountType>;
  id?: Maybe<Scalars['String']['output']>;
  usedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserDocument = {
  __typename?: 'UserDocument';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userDocumentType: UserDocumentType;
  userId: Scalars['Int']['output'];
};

export type UserDocumentType = {
  __typename?: 'UserDocumentType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UserHolidayBonusExtraSessionCredit = {
  __typename?: 'UserHolidayBonusExtraSessionCredit';
  createdAt: Scalars['Date']['output'];
  createdByAdmin: Admin;
  createdByAdminId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  userHolidayBonusGoalId: Scalars['Int']['output'];
};

export type UserHolidayBonusGoal = {
  __typename?: 'UserHolidayBonusGoal';
  goalAchievedEmailSentAt?: Maybe<Scalars['Date']['output']>;
  halfwayToGoalEmailSentAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  qualifyingSessionCount: Scalars['Int']['output'];
  qualifyingSessionCountGoal: Scalars['Int']['output'];
  user: User;
  userFullName: Scalars['String']['output'];
  userHolidayBonusExtraSessionCredits: Array<UserHolidayBonusExtraSessionCredit>;
  userId: Scalars['Int']['output'];
};

export type UserMatch = {
  __typename?: 'UserMatch';
  deactivatedAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  matchStatus?: Maybe<MatchStatus>;
  matchStatusId?: Maybe<Scalars['Int']['output']>;
  platformOnly?: Maybe<Scalars['Boolean']['output']>;
  sessionRate?: Maybe<SessionRate>;
  smallAvatar?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserMatchesResult = {
  __typename?: 'UserMatchesResult';
  superviseeMatches?: Maybe<Array<UserMatch>>;
  supervisorMatches?: Maybe<Array<UserMatch>>;
};

export type UserNotificationPreferenceInputType = {
  email: Scalars['Boolean']['input'];
  sms: Scalars['Boolean']['input'];
  userNotificationTriggerId: Scalars['Int']['input'];
};

export type UserNotificationPreferenceType = {
  __typename?: 'UserNotificationPreferenceType';
  email: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  sms: Scalars['Boolean']['output'];
  userNotificationTriggerId: Scalars['Int']['output'];
};

export type UserNotificationPreferencesByCategoryType = {
  __typename?: 'UserNotificationPreferencesByCategoryType';
  categoryName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  preferences: Array<UserNotificationPreferenceType>;
};

export type UserPrimaryCalendar = {
  __typename?: 'UserPrimaryCalendar';
  calendarId: Scalars['String']['output'];
  calendarName: Scalars['String']['output'];
  oauthTokenId: Scalars['Int']['output'];
};

export type UserPrimaryCalendarInput = {
  calendarId: Scalars['String']['input'];
  oauthTokenId: Scalars['Int']['input'];
};

export enum UserRoleFilter {
  PublishedSupervisors = 'PUBLISHED_SUPERVISORS'
}

export type UserSignupSourceDataInput = {
  referralcode?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type UserSupervisionPause = {
  __typename?: 'UserSupervisionPause';
  id: Scalars['Int']['output'];
  supervisionPausedAt: Scalars['Date']['output'];
  supervisionPausedBy: SupervisionPausedOrResumedBy;
  supervisionPausedByActor: Actor;
  supervisionPausedByActorId: Scalars['Int']['output'];
  supervisionPausedReasonText?: Maybe<Scalars['String']['output']>;
  supervisionResumedAt?: Maybe<Scalars['Date']['output']>;
  supervisionResumedBy?: Maybe<SupervisionPausedOrResumedBy>;
  supervisionResumedByActor?: Maybe<Actor>;
  supervisionResumedByActorId?: Maybe<Scalars['Int']['output']>;
  supervisionResumesOn?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export enum UserTypeEnum {
  OrganizationAdmin = 'organization_admin',
  User = 'user'
}

export type UserWithError = {
  __typename?: 'UserWithError';
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum UsersByOrganizationIdQueryFilter {
  AwaitingMatch = 'AWAITING_MATCH',
  Inactive = 'INACTIVE',
  Matched = 'MATCHED',
  NotInProgram = 'NOT_IN_PROGRAM',
  Pending = 'PENDING',
  Removed = 'REMOVED'
}

export type UsersByOrganizationIdQueryResult = {
  __typename?: 'UsersByOrganizationIdQueryResult';
  result: Array<User>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UsersClinicalSetting = {
  __typename?: 'UsersClinicalSetting';
  clinicalSetting: ClinicalSetting;
  clinicalSettingId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UsersDegree = {
  __typename?: 'UsersDegree';
  degree: Degree;
  degreeId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  universitySuggestedName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type UsersDegreeInput = {
  degreeId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  universitySuggestedName: Scalars['String']['input'];
};

export type UsersLanguage = {
  __typename?: 'UsersLanguage';
  id: Scalars['Int']['output'];
  language: Language;
  languageId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UsersLicense = {
  __typename?: 'UsersLicense';
  approvedStatus?: Maybe<Scalars['String']['output']>;
  boardApprovalVerifiedAt?: Maybe<Scalars['Date']['output']>;
  boardApprovedDetailsText?: Maybe<Scalars['String']['output']>;
  clinicalLicenseYear?: Maybe<Scalars['Int']['output']>;
  currentVerificationStatus?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isAbleToSupervise: Scalars['Boolean']['output'];
  isMonitoringEnabled: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  issuedYear?: Maybe<Scalars['Int']['output']>;
  license: License;
  licenseId: Scalars['Int']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseUserDocument?: Maybe<UserDocument>;
  licenseUserDocumentId?: Maybe<Scalars['String']['output']>;
  licenseVerifiedAt?: Maybe<Scalars['Date']['output']>;
  otherUserDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  otherUserDocuments?: Maybe<Array<UserDocument>>;
  stateId: Scalars['Int']['output'];
  trainingUserDocument?: Maybe<UserDocument>;
  trainingUserDocumentId?: Maybe<Scalars['String']['output']>;
  usState: UsState;
  userId: Scalars['Int']['output'];
  verifiableLicenseId?: Maybe<Scalars['String']['output']>;
  verificationUrl?: Maybe<Scalars['String']['output']>;
};

export type UsersLicenseQueryInput = {
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  usStateId: Scalars['Int']['input'];
};

export type UsersLicensesInput = {
  boardApprovedDetailsText?: InputMaybe<Scalars['String']['input']>;
  clinicalLicenseYear?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAbleToSupervise?: InputMaybe<Scalars['Boolean']['input']>;
  issuedYear?: InputMaybe<Scalars['Int']['input']>;
  licenseDocument?: InputMaybe<Scalars['Upload']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  otherDocumentIdsToDelete?: InputMaybe<Array<Scalars['String']['input']>>;
  otherDocuments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  trainingDocument?: InputMaybe<Scalars['Upload']['input']>;
};

export type UsersModality = {
  __typename?: 'UsersModality';
  modality: Modality;
  modalityId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UsersPopulation = {
  __typename?: 'UsersPopulation';
  population: Population;
  populationId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UsersQueryResult = {
  __typename?: 'UsersQueryResult';
  result: Array<User>;
  total: Scalars['Int']['output'];
};

export type UsersSpecialty = {
  __typename?: 'UsersSpecialty';
  specialty: Specialty;
  specialtyId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UsersSubscription = {
  __typename?: 'UsersSubscription';
  active?: Maybe<Scalars['Boolean']['output']>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  subscriptionPrice?: Maybe<SubscriptionPrice>;
  subscriptionPriceId?: Maybe<Scalars['Int']['output']>;
  subscriptionProduct?: Maybe<SubscriptionProduct>;
  subscriptionProductId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UsersSupervisionCredential = {
  __typename?: 'UsersSupervisionCredential';
  credentialCertificateExpiresOn?: Maybe<Scalars['String']['output']>;
  credentialCertificateUserDocument?: Maybe<UserDocument>;
  credentialCertificateUserDocumentId?: Maybe<Scalars['String']['output']>;
  credentialNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  stateId: Scalars['Int']['output'];
  supervisionCredential: SupervisionCredential;
  supervisionCredentialId: Scalars['Int']['output'];
  usState: UsState;
  userId: Scalars['Int']['output'];
  verifiedAt?: Maybe<Scalars['Date']['output']>;
};

export type UsersSupervisionCredentialsInput = {
  credentialCertificateExpiresOn?: InputMaybe<Scalars['String']['input']>;
  credentialCertificateFile?: InputMaybe<Scalars['Upload']['input']>;
  credentialNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  stateId: Scalars['Int']['input'];
  supervisionCredentialId: Scalars['Int']['input'];
};

export enum VetSupervisorFieldToVerifyEnum {
  All = 'all',
  BoardApproval = 'boardApproval',
  License = 'license',
  Profile = 'profile',
  SupervisionCredential = 'supervisionCredential'
}

export type VetSupervisorInput = {
  fieldToVerify: VetSupervisorFieldToVerifyEnum;
  supervisorUserId: Scalars['Int']['input'];
  usersLicenseIdOrUsersSupervisionCredentialId?: InputMaybe<Scalars['Int']['input']>;
};

export type Viewer = BaseUser & {
  __typename?: 'Viewer';
  accessRevokedCalendar?: Maybe<Scalars['String']['output']>;
  activeIntroRequestsAsSupervisee: Array<IntroRequest>;
  actorId: Scalars['Int']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  adminRoles?: Maybe<Array<AdminRole>>;
  attestationEsignDocument?: Maybe<EsignDocument>;
  avatarPath?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  baaEsignDocument?: Maybe<EsignDocument>;
  canAccessBillableWork: Scalars['Boolean']['output'];
  canAccessMotivoLearning: Scalars['Boolean']['output'];
  canSuperviseesBookSessions: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  clinicalSettings: Array<ClinicalSetting>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creditCards?: Maybe<Array<CreditCard>>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emergencyContact?: Maybe<EmergencyContact>;
  enrolledCourses?: Maybe<Array<Course>>;
  featureFlags?: Maybe<Array<Scalars['String']['output']>>;
  firstName?: Maybe<Scalars['String']['output']>;
  frontSignatureDetails?: Maybe<FrontSignatureDetails>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasPrimaryCalendar: Scalars['Boolean']['output'];
  hasSetPassword: Scalars['Boolean']['output'];
  hubspotId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  isCypress?: Maybe<Scalars['Boolean']['output']>;
  isSupervisee: Scalars['Boolean']['output'];
  isSupervisor: Scalars['Boolean']['output'];
  languages: Array<Language>;
  largeAvatar?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latLng?: Maybe<LatLng>;
  learningTermsAcceptedAt?: Maybe<Scalars['Date']['output']>;
  mediumAvatar?: Maybe<Scalars['String']['output']>;
  missingFields?: Maybe<Array<Scalars['String']['output']>>;
  modalities?: Maybe<Array<Modality>>;
  openIntroRequestsCount?: Maybe<Scalars['Int']['output']>;
  openZoomSessionsInApp: Scalars['Boolean']['output'];
  opportunities: Array<Opportunity>;
  /** This viewer field is app-dependent. On aphrodite, this field indicates the organization you are an employee of. On astraea, this field indicates the organization you are an admin of. */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  /** A list of programs the viewer has access to */
  organizationPrograms: Array<OrganizationProgram>;
  organizationRoleId?: Maybe<Scalars['Int']['output']>;
  organizationSuperviseeOnboardingRequest?: Maybe<OrganizationSuperviseeOnboardingRequest>;
  organizationUser?: Maybe<OrganizationUser>;
  passwordSetAt?: Maybe<Scalars['Date']['output']>;
  pendingEmail?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<OrganizationAdminPermissionModel>;
  phone?: Maybe<Scalars['String']['output']>;
  populations: Array<Population>;
  postnominals?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  prenominals?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  recommendations: Array<Recommendation>;
  scope: Scalars['String']['output'];
  signature?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  smallAvatar?: Maybe<Scalars['String']['output']>;
  specialties: Array<Specialty>;
  stateId?: Maybe<Scalars['Int']['output']>;
  stripeConnectedAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectedAccountOnboardingLink?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeExpressDashboardLink?: Maybe<Scalars['String']['output']>;
  stripeVerified?: Maybe<Scalars['Boolean']['output']>;
  superviseeMatches: Array<Match>;
  superviseeOnboardingInfo?: Maybe<SuperviseeOnboardingInfo>;
  superviseeProfile?: Maybe<SuperviseeProfile>;
  supervisorApplication?: Maybe<SupervisorApplication>;
  supervisorMatches: Array<Match>;
  supervisorProfile?: Maybe<SupervisorProfile>;
  supervisorTerminationRequest?: Maybe<SupervisorTerminationRequest>;
  telehealthTrainingUserDocuments?: Maybe<Array<UserDocument>>;
  timezone?: Maybe<Scalars['String']['output']>;
  userAvailabilities: Array<UserAvailability>;
  userBookedTimeslots?: Maybe<Array<BookedTimeSlot>>;
  userClinicalTrainings: Array<UserClinicalTraining>;
  userConnectedCalendars?: Maybe<Array<UserConnectedCalendar>>;
  userDocuments: Array<UserDocument>;
  userHolidayBonusGoal?: Maybe<UserHolidayBonusGoal>;
  userPrimaryCalendar?: Maybe<UserPrimaryCalendar>;
  userSubscription?: Maybe<UsersSubscription>;
  usersClinicalSettings: Array<UsersClinicalSetting>;
  usersDegrees: Array<UsersDegree>;
  usersLicenses: Array<UsersLicense>;
  usersModalities: Array<UsersModality>;
  usersPopulations: Array<UsersPopulation>;
  usersSpecialties: Array<UsersSpecialty>;
  usersSupervisionCredentials: Array<UsersSupervisionCredential>;
  zipcode?: Maybe<Scalars['String']['output']>;
  zoomUserId?: Maybe<Scalars['String']['output']>;
};


export type ViewerModalitiesArgs = {
  filtered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ViewerOrganizationUserArgs = {
  deletedForOrganizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type ViewerSpecialtiesArgs = {
  filtered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ViewerStripeConnectedAccountOnboardingLinkArgs = {
  linkType?: InputMaybe<Scalars['String']['input']>;
};


export type ViewerSupervisorMatchesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WriteRecommendationInput = {
  id: Scalars['String']['input'];
  recommendationText: Scalars['String']['input'];
};

export type WriteRecommendationResult = {
  __typename?: 'WriteRecommendationResult';
  success: Scalars['Boolean']['output'];
};

export type ZoomMeetingData = {
  __typename?: 'ZoomMeetingData';
  duration?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  participantsCount?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type BillableWorkRecordsForOrganizationAdminQueryQueryVariables = Exact<{
  beforeDateString: Scalars['String']['input'];
  afterDateString: Scalars['String']['input'];
  organizationProgramId?: InputMaybe<Scalars['String']['input']>;
}>;


export type BillableWorkRecordsForOrganizationAdminQueryQuery = { __typename?: 'Query', billableWorkRecordsForOrganizationAdmin: { __typename?: 'BillableWorkRecordsForOrganizationAdminResult', total: number, result: Array<{ __typename?: 'BillableWorkRecord', id: string, completedOn: string, duration: number, description?: string | null, assigneeUser: { __typename?: 'User', id: number, fullName: string }, organization: { __typename?: 'Organization', id: number, name: string }, organizationProgram?: { __typename?: 'OrganizationProgram', id: string, name: string } | null, billableWorkRecordType: { __typename?: 'BillableWorkRecordType', id: number, name: string } }> } };

export type SupervisorByOpportunityCandidateIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SupervisorByOpportunityCandidateIdQuery = { __typename?: 'Query', opportunitiesCandidateById: { __typename?: 'OpportunitiesCandidate', id: string, supervisor?: { __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string, displayName: string, mediumAvatar?: string | null, timezone?: string | null, actorId: number, supervisorProfile?: { __typename?: 'SupervisorProfile', quote: string, bio: string } | null, usersModalities: Array<{ __typename?: 'UsersModality', modality: { __typename?: 'Modality', id: number, name: string } }>, usersSpecialties: Array<{ __typename?: 'UsersSpecialty', specialty: { __typename?: 'Specialty', id: number, name: string } }>, usersDegrees: Array<{ __typename?: 'UsersDegree', universitySuggestedName?: string | null, degree: { __typename?: 'Degree', id: number, name: string } }>, usersLicenses: Array<{ __typename?: 'UsersLicense', licenseNumber?: string | null, isAbleToSupervise: boolean, license: { __typename?: 'License', name: string, displayName: string }, usState: { __typename?: 'USState', name: string } }>, usersSupervisionCredentials: Array<{ __typename?: 'UsersSupervisionCredential', supervisionCredential: { __typename?: 'SupervisionCredential', id: number, name: string }, usState: { __typename?: 'USState', id: number, abbreviation?: string | null } }> } | null } };

export type ScheduleIntroRequestMutationMutationVariables = Exact<{
  input: ScheduleIntroRequestInput;
}>;


export type ScheduleIntroRequestMutationMutation = { __typename?: 'Mutation', scheduleIntroRequest?: { __typename?: 'ScheduleIntroRequestResult', success?: boolean | null } | null };

export type AcceptIntroRequestForMatchMutationMutationVariables = Exact<{
  input: AcceptIntroRequestForMatchInput;
}>;


export type AcceptIntroRequestForMatchMutationMutation = { __typename?: 'Mutation', acceptIntroRequestForMatch?: { __typename?: 'AcceptIntroRequestForMatchResult', success?: boolean | null } | null };

export type SuggestAlternateIntroRequestTimesMutationMutationVariables = Exact<{
  input: SuggestAlternateIntroRequestTimesInput;
}>;


export type SuggestAlternateIntroRequestTimesMutationMutation = { __typename?: 'Mutation', suggestAlternateIntroRequestTimes?: { __typename?: 'SuggestAlternateIntroRequestTimesResult', success?: boolean | null } | null };

export type DeclineIntroRequestMutationMutationVariables = Exact<{
  input: DeclineIntroRequestInput;
}>;


export type DeclineIntroRequestMutationMutation = { __typename?: 'Mutation', declineIntroRequest?: { __typename?: 'DeclineIntroRequestResult', success?: boolean | null } | null };

export type IntroRequestsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type IntroRequestsQueryQuery = { __typename?: 'Query', introRequests?: { __typename?: 'IntroRequestsResult', total?: number | null, result?: Array<{ __typename?: 'IntroRequest', id: string, scheduledAt?: any | null, introRequestStatusId: number, availableSlots: Array<any>, createdAt: any, supervisor: { __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string, avatarUrl?: string | null }, organizationAdmin?: { __typename?: 'OrganizationAdmin', id: number, firstName: string, lastName: string, fullName: string } | null }> | null } | null };

export type IntroRequestsDashboardNotificationQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type IntroRequestsDashboardNotificationQueryQuery = { __typename?: 'Query', introRequests?: { __typename?: 'IntroRequestsResult', total?: number | null, result?: Array<{ __typename?: 'IntroRequest', id: string }> | null } | null };

export type IntroRequestByIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type IntroRequestByIdQueryQuery = { __typename?: 'Query', introRequestById: { __typename?: 'IntroRequest', id: string, introRequestDeclineReasonId?: number | null, introRequestStatusId: number, meetingUrl?: string | null, joinUrl?: string | null, scheduledAt?: any | null, createdAt: any, updatedAt?: any | null, availableSlots: Array<any>, organizationAdmin?: { __typename?: 'OrganizationAdmin', id: number, firstName: string, lastName: string, fullName: string, actorId: number, organization: { __typename?: 'Organization', id: number, name: string, clinicalSettingId?: number | null, requiresNotesInReports: boolean, requiresSupervisorAdminHours: boolean } } | null, supervisor: { __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string, actorId: number, displayName: string, supervisorProfile?: { __typename?: 'SupervisorProfile', quote: string, bio: string } | null, usersModalities: Array<{ __typename?: 'UsersModality', modality: { __typename?: 'Modality', id: number, name: string } }>, usersSpecialties: Array<{ __typename?: 'UsersSpecialty', specialty: { __typename?: 'Specialty', id: number, name: string } }>, usersDegrees: Array<{ __typename?: 'UsersDegree', universitySuggestedName?: string | null, degree: { __typename?: 'Degree', id: number, name: string } }>, usersLicenses: Array<{ __typename?: 'UsersLicense', licenseNumber?: string | null, isAbleToSupervise: boolean, license: { __typename?: 'License', name: string, displayName: string }, usState: { __typename?: 'USState', name: string } }>, usersSupervisionCredentials: Array<{ __typename?: 'UsersSupervisionCredential', supervisionCredential: { __typename?: 'SupervisionCredential', id: number, name: string }, usState: { __typename?: 'USState', id: number, abbreviation?: string | null } }> }, match?: { __typename?: 'Match', id: number, createdAt: any } | null } };

export type FindOrCreateChatMutationMutationVariables = Exact<{
  input: FindOrCreateChatInput;
}>;


export type FindOrCreateChatMutationMutation = { __typename?: 'Mutation', findOrCreateChat: { __typename?: 'FindOrCreateChatResult', id: string, success: boolean } };

export type PotentialChatParticipantsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PotentialChatParticipantsQueryQuery = { __typename?: 'Query', potentialChatParticipants?: { __typename?: 'PotentialChatParticipantsResult', result: Array<{ __typename?: 'ChatActor', id: number, fullName: string, firstName: string, lastName: string, smallAvatar?: string | null }> } | null };

export type ChatMessagesQueryQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatMessagesQueryQuery = { __typename?: 'Query', chatMessages: { __typename?: 'ChatMessagesResult', nextCursor?: string | null, result: Array<{ __typename?: 'ChatMessage', id: string, createdAt: any, chatId: string, senderActorId: number, text: string }> } };

export type ChatQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ChatQueryQuery = { __typename?: 'Query', chat?: { __typename?: 'Chat', id: string, isActive: boolean, participants: Array<{ __typename?: 'ChatActor', id: number, fullName: string, firstName: string, lastName: string, smallAvatar?: string | null }> } | null };

export type ChatsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatsQueryQuery = { __typename?: 'Query', chats: Array<{ __typename?: 'Chat', id: string, isActive: boolean, latestChatMessage?: { __typename?: 'ChatMessage', id: string, text: string, createdAt: any } | null, participants: Array<{ __typename?: 'ChatActor', id: number, fullName: string, firstName: string, lastName: string, smallAvatar?: string | null }> }> };

export type ChatsWithUnreadMessagesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatsWithUnreadMessagesQueryQuery = { __typename?: 'Query', chatsWithUnreadMessages: Array<{ __typename?: 'Chat', id: string }> };

export type ViewerActorQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerActorQueryQuery = { __typename?: 'Query', viewerActor?: { __typename?: 'Actor', id: number } | null };

export type CreateIntroRequestOrganizationInfoMutationMutationVariables = Exact<{
  input: CreateIntroRequestOrganizationInfoInput;
}>;


export type CreateIntroRequestOrganizationInfoMutationMutation = { __typename?: 'Mutation', createIntroRequestOrganizationInfo?: { __typename?: 'CreateIntroRequestOrganizationInfoResult', success?: boolean | null, id?: string | null } | null };

export type UpdateIntroRequestOrganizationInfoMutationMutationVariables = Exact<{
  input: UpdateIntroRequestOrganizationInfoInput;
}>;


export type UpdateIntroRequestOrganizationInfoMutationMutation = { __typename?: 'Mutation', updateIntroRequestOrganizationInfo?: { __typename?: 'UpdateIntroRequestOrganizationInfoResult', success?: boolean | null, id?: string | null } | null };

export type CreateIntroRequestMutationMutationVariables = Exact<{
  input: CreateIntroRequestInput;
}>;


export type CreateIntroRequestMutationMutation = { __typename?: 'Mutation', createIntroRequest: { __typename?: 'CreateIntroRequestResult', success?: boolean | null, error?: string | null, introRequestId?: string | null } };

export type EmployerOnboardingFormQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployerOnboardingFormQueryQuery = { __typename?: 'Query', clinicalSettings: Array<{ __typename?: 'ClinicalSetting', id: number, name: string }> };

export type SupervisorByUserIdQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SupervisorByUserIdQueryQuery = { __typename?: 'Query', userById: { __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string } };

export type SupervisorAvailableTimeslotsQueryQueryVariables = Exact<{
  superviseeTimezone: Scalars['String']['input'];
  supervisorUserId: Scalars['Int']['input'];
}>;


export type SupervisorAvailableTimeslotsQueryQuery = { __typename?: 'Query', supervisorAvailableTimeslots?: { __typename?: 'SupervisorAvailableTimeslotsResult', timesByDate: Array<{ __typename?: 'AvailableTimeSlot', date: string, times: Array<string> }> } | null };

export type NumberOfOpenIntroRequestsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type NumberOfOpenIntroRequestsQueryQuery = { __typename?: 'Query', introRequests?: { __typename?: 'IntroRequestsResult', total?: number | null } | null };

export type IntroRequestOrganizationInfoByIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type IntroRequestOrganizationInfoByIdQueryQuery = { __typename?: 'Query', introRequestOrganizationInfoById?: { __typename?: 'IntroRequestOrganizationInfo', id?: string | null, superviseeInfo?: string | null, supervisionStartTime?: string | null, weeklyHours?: number | null, sessionTypeIds?: Array<number> | null, clinicalQuestions?: string | null, additionalDetails?: string | null } | null };

export type OrganizationProgramsWithDetailsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationProgramsWithDetailsQueryQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id?: number | null, organizationPrograms: Array<{ __typename?: 'OrganizationProgram', id: string, name: string, introCallPreferenceId?: number | null, requiresNotesInReports?: boolean | null, organizationAdmins: Array<{ __typename?: 'OrganizationAdmin', id: number, fullName: string }>, organizationUsers: Array<{ __typename?: 'OrganizationUser', id: number, user: { __typename?: 'User', id: number, firstName: string, lastName: string, mediumAvatar?: string | null } }> }> } };

export type CreateOrganizationProgramMutationMutationVariables = Exact<{
  input: CreateOrganizationProgramInput;
}>;


export type CreateOrganizationProgramMutationMutation = { __typename?: 'Mutation', createOrganizationProgram?: { __typename?: 'CreateOrganizationProgramResult', success?: boolean | null } | null };

export type DeleteOrganizationProgramMutationMutationVariables = Exact<{
  input: DeleteOrganizationProgramInput;
}>;


export type DeleteOrganizationProgramMutationMutation = { __typename?: 'Mutation', deleteOrganizationProgram?: { __typename?: 'DeleteOrganizationProgramResult', success?: boolean | null } | null };

export type UpdateSuperviseesInProgramMutationMutationVariables = Exact<{
  input: UpdateSuperviseesInProgramInput;
}>;


export type UpdateSuperviseesInProgramMutationMutation = { __typename?: 'Mutation', updateSuperviseesInProgram?: { __typename?: 'SuccessMutationResult', success?: boolean | null } | null };

export type AssignOrganizationProgramDirectorMutationMutationVariables = Exact<{
  input: AssignOrganizationProgramDirectorInput;
}>;


export type AssignOrganizationProgramDirectorMutationMutation = { __typename?: 'Mutation', assignOrganizationProgramDirector?: { __typename?: 'AssignOrganizationProgramDirectorResult', success?: boolean | null } | null };

export type UpdateOrganizationProgramSettingsMutationMutationVariables = Exact<{
  input: UpdateOrganizationProgramSettingsInput;
}>;


export type UpdateOrganizationProgramSettingsMutationMutation = { __typename?: 'Mutation', updateOrganizationProgramSettings?: { __typename?: 'SuccessMutationResult', success?: boolean | null } | null };

export type OrganizationProgramByIdQueryQueryVariables = Exact<{
  organizationProgramId: Scalars['String']['input'];
}>;


export type OrganizationProgramByIdQueryQuery = { __typename?: 'Query', organizationProgramById: { __typename?: 'OrganizationProgram', id: string, name: string, requiresNotesInReports?: boolean | null, introCallPreferenceId?: number | null, requiresSupervisorAdminHours?: boolean | null } };

export type SuperviseesByOrganizationProgramIdQueryQueryVariables = Exact<{
  organizationProgramId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuperviseesByOrganizationProgramIdQueryQuery = { __typename?: 'Query', superviseesByOrganizationProgramId?: { __typename?: 'SuperviseesByOrganizationProgramIdQueryResult', total?: number | null, result?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string, supervisorMatches: Array<{ __typename?: 'Match', id: number, supervisorId: number, matchStatusId: number }> }> | null } | null };

export type OrganizationSupervisorsOutsideProgramQueryQueryVariables = Exact<{
  matchStatusId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationSupervisorsOutsideProgramQueryQuery = { __typename?: 'Query', organizationSupervisors?: { __typename?: 'OrganizationSupervisorsResult', result?: Array<{ __typename?: 'OrganizationSupervisorsDataType', supervisor: { __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string, superviseeMatches: Array<{ __typename?: 'Match', id: number, matchStatusId: number }> } }> | null } | null };

export type OrganizationSuperviseesOutsideProgramQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  filter?: InputMaybe<UsersByOrganizationIdQueryFilter>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortByMostRecentSession?: InputMaybe<Scalars['Boolean']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationSuperviseesOutsideProgramQuery = { __typename?: 'Query', usersByOrganizationId: { __typename?: 'UsersByOrganizationIdQueryResult', total?: number | null, result: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string, supervisorMatches: Array<{ __typename?: 'Match', id: number, supervisorId: number, matchStatusId: number }> }> } };

export type OrganizationProgramDirectorsByOrganizationIdQueryQueryVariables = Exact<{
  organizationId: Scalars['Int']['input'];
}>;


export type OrganizationProgramDirectorsByOrganizationIdQueryQuery = { __typename?: 'Query', organizationProgramDirectorsByOrganizationId?: Array<{ __typename?: 'OrganizationAdmin', id: number, firstName: string, lastName: string, fullName: string, organizationPrograms: Array<{ __typename?: 'OrganizationProgram', id: string }> }> | null };

export type SessionsQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  sessionTypeId?: InputMaybe<Scalars['Int']['input']>;
  sessionDispositionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  noShowOnly?: InputMaybe<Scalars['Boolean']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SessionsQueryQuery = { __typename?: 'Query', sessions: { __typename?: 'SessionsQueryResult', total: number, result: Array<{ __typename?: 'Session', id: number, scheduledAt: any, duration: number, createdBy: number, sessionDispositionId: number, cancelledAt?: any | null, cancellationReason?: string | null, sessionType: { __typename?: 'SessionType', displayName: string }, supervisor: { __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string, mediumAvatar?: string | null }, sessionAttendees: Array<{ __typename?: 'SessionAttendee', attended?: boolean | null, billable?: boolean | null, partialAttendanceMinutes?: number | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string, mediumAvatar?: string | null, organizationUser?: { __typename?: 'OrganizationUser', id: number, organizationProgram?: { __typename?: 'OrganizationProgram', id: string, name: string } | null } | null } }>, organizationSession?: { __typename?: 'OrganizationSession', id: string, organization: { __typename?: 'Organization', id: number, name: string, organizationUsers?: Array<{ __typename?: 'OrganizationUser', id: number, user: { __typename?: 'User', id: number, fullName: string, mediumAvatar?: string | null } }> | null } } | null, sessionNotes: Array<{ __typename?: 'SessionNote', id: number, question: string, answer: string }>, cancelledBy?: { __typename?: 'User', id: number, fullName: string } | null, unavailableParty?: { __typename?: 'User', id: number, fullName: string } | null, sessionCancellationReason?: { __typename?: 'SessionCancellationReason', id: number, name: string } | null, recurrenceRule?: { __typename?: 'SessionRecurrenceRule', id: string } | null }> } };

export type OrganizationByIdQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type OrganizationByIdQueryQuery = { __typename?: 'Query', organizationById: { __typename?: 'Organization', id: number, name: string, canRemoveSupervisees: boolean, organizationUsers?: Array<{ __typename?: 'OrganizationUser', id: number, user: { __typename?: 'User', fullName: string, id: number } }> | null } };

export type UpcomingSessionsQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpcomingSessionsQueryQuery = { __typename?: 'Query', upcomingSessions: { __typename?: 'UpcomingSessionsQueryResult', result: Array<{ __typename?: 'Session', id: number, scheduledAt: any, duration: number, sessionDispositionId: number, sessionType: { __typename?: 'SessionType', displayName: string }, supervisor: { __typename?: 'User', id: number, fullName: string, mediumAvatar?: string | null }, sessionAttendees: Array<{ __typename?: 'SessionAttendee', attended?: boolean | null, partialAttendanceMinutes?: number | null, user: { __typename?: 'User', id: number, fullName: string, mediumAvatar?: string | null } }>, sessionNotes: Array<{ __typename?: 'SessionNote', id: number, question: string, answer: string }> }> } };

export type OrganizationSummaryByIdQueryQueryVariables = Exact<{
  organizationId: Scalars['Int']['input'];
  programId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationSummaryByIdQueryQuery = { __typename?: 'Query', organizationSummaryById?: { __typename?: 'OrganizationSummaryByIdQueryResult', userCount?: number | null, pendingUserCount?: number | null, inactiveUserCount?: number | null, totalMinutes?: number | null, organization?: { __typename?: 'Organization', id: number, usesInvoice: boolean } | null } | null };

export type UserByIdQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  deletedForOrganizationId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserByIdQueryQuery = { __typename?: 'Query', userById: { __typename?: 'User', id: number, smallAvatar?: string | null, mediumAvatar?: string | null, firstName: string, lastName: string, avatarUrl?: string | null, fullName: string, usersLicenses: Array<{ __typename?: 'UsersLicense', license: { __typename?: 'License', name: string }, usState: { __typename?: 'USState', abbreviation?: string | null } }>, organizationSuperviseeOnboardingRequest?: { __typename?: 'OrganizationSuperviseeOnboardingRequest', usState: { __typename?: 'USState', id: number, name: string, abbreviation?: string | null }, licenseCategory: { __typename?: 'LicenseCategory', id: number, name: string, displayName: string, abbreviation: string } } | null, organizationUser?: { __typename?: 'OrganizationUser', id: number, deletedAt?: any | null, scheduledForRemovalOn?: string | null } | null } };

export type SessionsSummaryByIdQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SessionsSummaryByIdQuery = { __typename?: 'Query', superviseeSessionsSummaryById?: { __typename?: 'SessionsSummaryResult', totalMinutes: number, individualMinutes: number, dyadMinutes: number, groupMinutes: number } | null };

export type CreateSetupIntentForOrganizationMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSetupIntentForOrganizationMutationMutation = { __typename?: 'Mutation', createSetupIntentForOrganization?: { __typename?: 'CreateSetupIntentForOrganizationResult', clientSecret?: string | null } | null };

export type DeleteCreditCardForOrganizationMutationMutationVariables = Exact<{
  input: DeleteCreditCardForOrganizationInput;
}>;


export type DeleteCreditCardForOrganizationMutationMutation = { __typename?: 'Mutation', deleteCreditCardForOrganization?: { __typename?: 'DeleteCreditCardForOrganizationSuccessResult', success: boolean } | { __typename?: 'Error', message?: string | null } | { __typename?: 'FinalCardDeletionError', message?: string | null, finalCardDeletionError?: boolean | null } | null };

export type SetPreferredCreditCardForOrganizationMutationMutationVariables = Exact<{
  input: SetPreferredCreditCardForOrganizationInput;
}>;


export type SetPreferredCreditCardForOrganizationMutationMutation = { __typename?: 'Mutation', setPreferredCreditCardForOrganization?: { __typename?: 'SetPreferredCreditCardForOrganizationResult', success: boolean } | null };

export type CreateCreditCardForOrganizationMutationMutationVariables = Exact<{
  input: CreateCreditCardForOrganizationInput;
}>;


export type CreateCreditCardForOrganizationMutationMutation = { __typename?: 'Mutation', createCreditCardForOrganization?: { __typename?: 'CreateCreditCardForOrganizationResult', success: boolean } | null };

export type OrganizationCreditCardsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationCreditCardsQueryQuery = { __typename?: 'Query', organizationCreditCards?: Array<{ __typename?: 'OrganizationCreditCard', id: string, lastFourDigits: string, expirationMonth: number, expirationYear: number, preferred: boolean, cardType: string }> | null };

export type OrganizationInvoicesTabQueryQueryVariables = Exact<{
  organizationId: Scalars['Int']['input'];
}>;


export type OrganizationInvoicesTabQueryQuery = { __typename?: 'Query', organizationInvoicesByOrganizationId: Array<{ __typename?: 'OrganizationInvoice', id: string, month: number, year: number, stripeInvoice?: { __typename?: 'StripeInvoice', id: string, amountDue: number, status: StripeInvoiceStatus, hostedInvoiceUrl?: string | null } | null }> };

export type UpdateNotificationSubscriptionsMutationMutationVariables = Exact<{
  input: UpdateNotificationSubscriptionsInput;
}>;


export type UpdateNotificationSubscriptionsMutationMutation = { __typename?: 'Mutation', updateNotificationSubscriptions?: { __typename?: 'UpdateNotificationSubscriptionsResult', success?: boolean | null } | null };

export type NotificationSubscriptionsForOrganizationAdminQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationSubscriptionsForOrganizationAdminQueryQuery = { __typename?: 'Query', notificationSubscriptionsForOrganizationAdmin?: { __typename?: 'OrganizationAdminNotificationSubscription', id: number, noShowEmails: boolean, invoices: boolean, supervisorMatchEmails: boolean, monthlyReports: boolean, rateIncreases: boolean } | null };

export type DeleteOrganizationAdminMutationMutationVariables = Exact<{
  input: DeleteOrganizationAdminInput;
}>;


export type DeleteOrganizationAdminMutationMutation = { __typename?: 'Mutation', deleteOrganizationAdmin: { __typename?: 'SuccessMutationResult', success?: boolean | null } };

export type CreateOrganizationAdminMutationMutationVariables = Exact<{
  input: CreateOrganizationAdminInput;
}>;


export type CreateOrganizationAdminMutationMutation = { __typename?: 'Mutation', createOrganizationAdmin?: { __typename?: 'CreateOrganizationAdminResult', success?: boolean | null } | null };

export type UpdateOrganizationAdminMutationMutationVariables = Exact<{
  input: UpdateOrganizationAdminInput;
}>;


export type UpdateOrganizationAdminMutationMutation = { __typename?: 'Mutation', updateOrganizationAdmin?: { __typename?: 'UpdateOrganizationAdminResult', success?: boolean | null } | null };

export type OrganizationFormOptionsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationFormOptionsQueryQuery = { __typename?: 'Query', specialties: Array<{ __typename?: 'Specialty', id: number, name: string }>, populations: Array<{ __typename?: 'Population', id: number, name: string }> };

export type OrganizationAdminsQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
}>;


export type OrganizationAdminsQueryQuery = { __typename?: 'Query', organizationAdmins?: { __typename?: 'OrganizationAdminsQueryResult', total?: number | null, result?: Array<{ __typename?: 'OrganizationAdmin', id: number, fullName: string, firstName: string, lastName: string, email: string, organizationRole: { __typename?: 'OrganizationRole', id: number, name: string }, organizationPrograms: Array<{ __typename?: 'OrganizationProgram', id: string, name: string }> }> | null } | null };

export type OrganizationTeamMembersQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type OrganizationTeamMembersQueryQuery = { __typename?: 'Query', organizationTeamMembers: { __typename?: 'OrganizationTeamMembersQueryResult', total: number, result: Array<{ __typename?: 'OrganizationAdmin', id: number, fullName: string, firstName: string, lastName: string, passwordSetAt?: any | null, email: string, organizationRole: { __typename?: 'OrganizationRole', id: number, name: string }, organizationPrograms: Array<{ __typename?: 'OrganizationProgram', id: string, name: string }> }> } };

export type OrganizationRolesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationRolesQueryQuery = { __typename?: 'Query', organizationRoles: Array<{ __typename?: 'OrganizationRole', id: number, name: string }> };

export type UpdateOrganizationAdminProfileMutationMutationVariables = Exact<{
  input: UpdateOrganizationAdminProfileInput;
}>;


export type UpdateOrganizationAdminProfileMutationMutation = { __typename?: 'Mutation', updateOrganizationAdminProfile?: { __typename?: 'UpdateOrganizationAdminProfileResult', success?: boolean | null } | null };

export type ResetOrganizationAdminPasswordMutationMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetOrganizationAdminPasswordMutationMutation = { __typename?: 'Mutation', resetOrganizationAdminPassword?: { __typename?: 'ResetPasswordErrorResult', error?: ResetPasswordError | null } | { __typename?: 'ResetPasswordSuccessResult', success: boolean, resetPasswordURL?: string | null } | null };

export type GeneralSettingsFormQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralSettingsFormQueryQuery = { __typename?: 'Query', clinicalSettings: Array<{ __typename?: 'ClinicalSetting', id: number, name: string }> };

export type CreateOrganizationUserMutationMutationVariables = Exact<{
  input: CreateOrganizationUserInput;
}>;


export type CreateOrganizationUserMutationMutation = { __typename?: 'Mutation', createOrganizationUser?: { __typename?: 'SuccessWithErrorMessageMutationResult', success?: boolean | null } | null };

export type UnmatchSuperviseeReasonsQueryQueryVariables = Exact<{
  forOrganizationUsersRemoval: Scalars['Boolean']['input'];
}>;


export type UnmatchSuperviseeReasonsQueryQuery = { __typename?: 'Query', unmatchSuperviseeReasons: Array<{ __typename?: 'UnmatchSuperviseeReason', id: number, name: string, description?: string | null }> };

export type UsStatesForOrganizationUsersQueryQueryVariables = Exact<{
  organizationId: Scalars['Int']['input'];
  organizationProgramId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsStatesForOrganizationUsersQueryQuery = { __typename?: 'Query', usStatesForOrganizationUsers: { __typename?: 'UsStatesForOrganizationUsersResult', usStates: Array<{ __typename?: 'USState', id: number, name: string }> } };

export type CreateUsersForOrganizationMutationMutationVariables = Exact<{
  input: CreateUsersForOrganizationInput;
}>;


export type CreateUsersForOrganizationMutationMutation = { __typename?: 'Mutation', createUsersForOrganization?: { __typename?: 'CreateUsersForOrganizationResult', statuses?: Array<{ __typename?: 'CreateUsersForOrganizationStatus', code: CreateUsersForOrganizationStatusCode, email?: string | null, user?: { __typename?: 'User', email?: string | null, fullName: string, id: number } | null }> | null } | null };

export type CreateB2BMatchMutationMutationVariables = Exact<{
  input: CreateB2BMatchInput;
}>;


export type CreateB2BMatchMutationMutation = { __typename?: 'Mutation', createB2BMatch?: { __typename?: 'CreateB2BMatchResult', success?: boolean | null } | null };

export type DeleteOrganizationUserMutationMutationVariables = Exact<{
  input: DeleteOrganizationUserInput;
}>;


export type DeleteOrganizationUserMutationMutation = { __typename?: 'Mutation', deleteOrganizationUser?: { __typename?: 'SuccessMutationResult', success?: boolean | null } | null };

export type ScheduleOrganizationUserForRemovalMutationMutationVariables = Exact<{
  input: ScheduleOrganizationUserForRemovalInput;
}>;


export type ScheduleOrganizationUserForRemovalMutationMutation = { __typename?: 'Mutation', scheduleOrganizationUserForRemoval?: { __typename?: 'ScheduleOrganizationUserForRemovalResult', success: boolean, wasSuperviseeRemovedImmediately: boolean } | null };

export type BouncedEmailsUpdateUserProfileMutationMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type BouncedEmailsUpdateUserProfileMutationMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename?: 'UpdateUserProfileResult', user?: { __typename?: 'User', id: number } | null, errors?: Array<{ __typename?: 'Error', message?: string | null, code?: string | null }> | null } | null };

export type CancelScheduledOrganizationUserRemovalMutationMutationVariables = Exact<{
  input: CancelScheduledOrganizationUserRemovalInput;
}>;


export type CancelScheduledOrganizationUserRemovalMutationMutation = { __typename?: 'Mutation', cancelScheduledOrganizationUserRemoval?: { __typename?: 'CancelScheduledOrganizationUserRemovalResult', success: boolean } | null };

export type OrganizationMatchesByOrganizationIdQueryQueryVariables = Exact<{
  matchStatusId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationMatchesByOrganizationIdQueryQuery = { __typename?: 'Query', organizationMatchesByOrganizationId?: { __typename?: 'OrganizationMatchesByOrganizationIdQueryResult', result: Array<{ __typename?: 'OrganizationMatch', matchStatusId: number, supervisor?: { __typename?: 'User', id: number, firstName: string, lastName: string, displayName: string, smallAvatar?: string | null, supervisorProfile?: { __typename?: 'SupervisorProfile', supervisorBandwidthId: number } | null, usersLicenses: Array<{ __typename?: 'UsersLicense', license: { __typename?: 'License', id: number, displayName: string }, usState: { __typename?: 'USState', abbreviation?: string | null } }> } | null }> } | null };

export type UsersByOrganizationIdQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  filter?: InputMaybe<UsersByOrganizationIdQueryFilter>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortByMostRecentSession?: InputMaybe<Scalars['Boolean']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  usStateId?: InputMaybe<Scalars['Int']['input']>;
  isRemovedTab: Scalars['Boolean']['input'];
}>;


export type UsersByOrganizationIdQuery = { __typename?: 'Query', usersByOrganizationId: { __typename?: 'UsersByOrganizationIdQueryResult', total?: number | null, result: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string, mediumAvatar?: string | null, email?: string | null, supervisorMatches: Array<{ __typename?: 'Match', id: number, supervisorId: number, matchStatusId: number, supervisor: { __typename?: 'User', id: number, displayName: string } }>, organization?: { __typename?: 'Organization', id: number, name: string } | null, organizationUser?: { __typename?: 'OrganizationUser', id: number, userId: number, billingCode?: string | null, matchEmailSentAt?: any | null, scheduledForRemovalOn?: string | null, deletedAt?: any | null, approvedBySupervisorAt?: any | null, removalReasonText?: string | null, recentSession?: { __typename?: 'Session', id: number, scheduledAt: any } | null, upcomingSession?: { __typename?: 'Session', id: number, scheduledAt: any } | null, organizationProgram?: { __typename?: 'OrganizationProgram', id: string, name: string } | null, unmatchSuperviseeReason?: { __typename?: 'UnmatchSuperviseeReason', id: number, name: string } | null } | null, organizationSuperviseeOnboardingRequest?: { __typename?: 'OrganizationSuperviseeOnboardingRequest', usState: { __typename?: 'USState', id: number, name: string, abbreviation?: string | null }, licenseCategory: { __typename?: 'LicenseCategory', id: number, name: string, displayName: string, abbreviation: string } } | null }> } };

export type OrganizationSuperviseeOnboardingOptionsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSuperviseeOnboardingOptionsQueryQuery = { __typename?: 'Query', usStates: Array<{ __typename?: 'USState', id: number, name: string }>, licenseCategories: Array<{ __typename?: 'LicenseCategory', id: number, displayName: string }> };

export type SupervisorBandwidthsQueryVariables = Exact<{ [key: string]: never; }>;


export type SupervisorBandwidthsQuery = { __typename?: 'Query', supervisorBandwidths: Array<{ __typename?: 'SupervisorBandwidth', id: number, name?: string | null }> };

export type BouncedEmailsQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BouncedEmailsQueryQuery = { __typename?: 'Query', bouncedEmails?: { __typename?: 'BouncedEmailsQueryResult', total?: number | null, result?: Array<{ __typename?: 'UserWithError', error?: string | null, user?: { __typename?: 'User', id: number, fullName: string, email?: string | null, organizationUser?: { __typename?: 'OrganizationUser', id: number, organization: { __typename?: 'Organization', id: number, name: string } } | null } | null }> | null } | null };

export type OrganizationSupervisorsQueryVariables = Exact<{
  matchStatusId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationSupervisorsQuery = { __typename?: 'Query', organizationSupervisors?: { __typename?: 'OrganizationSupervisorsResult', total?: number | null, result?: Array<{ __typename?: 'OrganizationSupervisorsDataType', supervisor: { __typename?: 'User', id: number, firstName: string, lastName: string, displayName: string, mediumAvatar?: string | null, fullName: string, email?: string | null, actorId: number }, supervisees: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string, fullName: string }> }> | null } | null };

export type SupervisorAvailableTimeslotsByDayQueryQueryVariables = Exact<{
  supervisorUserId: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
}>;


export type SupervisorAvailableTimeslotsByDayQueryQuery = { __typename?: 'Query', supervisorAvailableTimeslotsByDay?: { __typename?: 'SupervisorAvailableTimeslotsByDayResult', times: Array<string> } | null };

export type UserAvailabilitiesByUserIdQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserAvailabilitiesByUserIdQueryQuery = { __typename?: 'Query', userAvailabilitiesByUserIdQuery: { __typename?: 'UserAvailabilityResult', weeklyAvailableHours?: number | null, availabilities: Array<{ __typename?: 'UserAvailability', id: string, dayOfWeek: number, startTime: string, endTime: string }> } };

export type ViewerQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQueryQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id?: number | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, phone?: string | null, mediumAvatar?: string | null, organizationId?: number | null, scope: string, organizationRoleId?: number | null, featureFlags?: Array<string> | null, openIntroRequestsCount?: number | null, timezone?: string | null, canAccessBillableWork: boolean, organizationPrograms: Array<{ __typename?: 'OrganizationProgram', id: string, name: string }>, permissions?: { __typename?: 'OrganizationAdminPermissionModel', permissionNames: Array<OrganizationAdminPermissionName>, programIds?: Array<string> | null } | null, organization?: { __typename?: 'Organization', id: number, name: string, clinicalSettingId?: number | null, requiresNotesInReports: boolean, requiresSupervisorAdminHours: boolean, isEnterprise: boolean, usesInvoice: boolean, hasAssignedEmployerCareManager: boolean, requiresPaymentInformation?: boolean | null, supervisionAvailability?: string | null, introCallPreferenceId: number, populations: Array<{ __typename?: 'Population', id: number, name: string }>, specialties: Array<{ __typename?: 'Specialty', id: number, name: string }> } | null } };

export type RequiresPaymentInformationQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RequiresPaymentInformationQueryQuery = { __typename?: 'Query', organizationCreditCards?: Array<{ __typename?: 'OrganizationCreditCard', id: string }> | null, organizationById: { __typename?: 'Organization', id: number, usesInvoice: boolean } };

export type LicensesLookupQueryQueryVariables = Exact<{
  licenseCategoryId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LicensesLookupQueryQuery = { __typename?: 'Query', licenses: Array<{ __typename?: 'License', id: number, displayName: string }> };


export const BillableWorkRecordsForOrganizationAdminQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillableWorkRecordsForOrganizationAdminQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeDateString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterDateString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationProgramId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billableWorkRecordsForOrganizationAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"beforeDateString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeDateString"}}},{"kind":"Argument","name":{"kind":"Name","value":"afterDateString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterDateString"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationProgramId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationProgramId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationProgram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billableWorkRecordType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<BillableWorkRecordsForOrganizationAdminQueryQuery, BillableWorkRecordsForOrganizationAdminQueryQueryVariables>;
export const SupervisorByOpportunityCandidateIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupervisorByOpportunityCandidateId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunitiesCandidateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"actorId"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersModalities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersSpecialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersDegrees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"degree"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"universitySuggestedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersLicenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"usState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAbleToSupervise"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersSupervisionCredentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supervisionCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupervisorByOpportunityCandidateIdQuery, SupervisorByOpportunityCandidateIdQueryVariables>;
export const ScheduleIntroRequestMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScheduleIntroRequestMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleIntroRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleIntroRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ScheduleIntroRequestMutationMutation, ScheduleIntroRequestMutationMutationVariables>;
export const AcceptIntroRequestForMatchMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptIntroRequestForMatchMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptIntroRequestForMatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptIntroRequestForMatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AcceptIntroRequestForMatchMutationMutation, AcceptIntroRequestForMatchMutationMutationVariables>;
export const SuggestAlternateIntroRequestTimesMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SuggestAlternateIntroRequestTimesMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuggestAlternateIntroRequestTimesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestAlternateIntroRequestTimes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SuggestAlternateIntroRequestTimesMutationMutation, SuggestAlternateIntroRequestTimesMutationMutationVariables>;
export const DeclineIntroRequestMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeclineIntroRequestMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeclineIntroRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"declineIntroRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeclineIntroRequestMutationMutation, DeclineIntroRequestMutationMutationVariables>;
export const IntroRequestsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntroRequestsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"introRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"introRequestStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"availableSlots"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntroRequestsQueryQuery, IntroRequestsQueryQueryVariables>;
export const IntroRequestsDashboardNotificationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntroRequestsDashboardNotificationQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"introRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"waitingForViewer"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<IntroRequestsDashboardNotificationQueryQuery, IntroRequestsDashboardNotificationQueryQueryVariables>;
export const IntroRequestByIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntroRequestByIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"introRequestById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"introRequestDeclineReasonId"}},{"kind":"Field","name":{"kind":"Name","value":"introRequestStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"meetingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"joinUrl"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"actorId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"clinicalSettingId"}},{"kind":"Field","name":{"kind":"Name","value":"requiresNotesInReports"}},{"kind":"Field","name":{"kind":"Name","value":"requiresSupervisorAdminHours"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"actorId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersModalities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersSpecialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersDegrees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"degree"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"universitySuggestedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersLicenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"usState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAbleToSupervise"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersSupervisionCredentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supervisionCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"match"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableSlots"}}]}}]}}]} as unknown as DocumentNode<IntroRequestByIdQueryQuery, IntroRequestByIdQueryQueryVariables>;
export const FindOrCreateChatMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FindOrCreateChatMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FindOrCreateChatInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findOrCreateChat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<FindOrCreateChatMutationMutation, FindOrCreateChatMutationMutationVariables>;
export const PotentialChatParticipantsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PotentialChatParticipantsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"potentialChatParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"smallAvatar"}}]}}]}}]}}]} as unknown as DocumentNode<PotentialChatParticipantsQueryQuery, PotentialChatParticipantsQueryQueryVariables>;
export const ChatMessagesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatMessagesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"senderActorId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<ChatMessagesQueryQuery, ChatMessagesQueryQueryVariables>;
export const ChatQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"smallAvatar"}}]}}]}}]}}]} as unknown as DocumentNode<ChatQueryQuery, ChatQueryQueryVariables>;
export const ChatsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latestChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"smallAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<ChatsQueryQuery, ChatsQueryQueryVariables>;
export const ChatsWithUnreadMessagesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatsWithUnreadMessagesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatsWithUnreadMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChatsWithUnreadMessagesQueryQuery, ChatsWithUnreadMessagesQueryQueryVariables>;
export const ViewerActorQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerActorQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerActor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ViewerActorQueryQuery, ViewerActorQueryQueryVariables>;
export const CreateIntroRequestOrganizationInfoMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIntroRequestOrganizationInfoMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIntroRequestOrganizationInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIntroRequestOrganizationInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateIntroRequestOrganizationInfoMutationMutation, CreateIntroRequestOrganizationInfoMutationMutationVariables>;
export const UpdateIntroRequestOrganizationInfoMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntroRequestOrganizationInfoMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIntroRequestOrganizationInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntroRequestOrganizationInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateIntroRequestOrganizationInfoMutationMutation, UpdateIntroRequestOrganizationInfoMutationMutationVariables>;
export const CreateIntroRequestMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIntroRequestMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIntroRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIntroRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"introRequestId"}}]}}]}}]} as unknown as DocumentNode<CreateIntroRequestMutationMutation, CreateIntroRequestMutationMutationVariables>;
export const EmployerOnboardingFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmployerOnboardingFormQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clinicalSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<EmployerOnboardingFormQueryQuery, EmployerOnboardingFormQueryQueryVariables>;
export const SupervisorByUserIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupervisorByUserIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<SupervisorByUserIdQueryQuery, SupervisorByUserIdQueryQueryVariables>;
export const SupervisorAvailableTimeslotsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupervisorAvailableTimeslotsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"superviseeTimezone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supervisorUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supervisorAvailableTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"superviseeTimezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"superviseeTimezone"}}},{"kind":"Argument","name":{"kind":"Name","value":"supervisorUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supervisorUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesByDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"times"}}]}}]}}]}}]} as unknown as DocumentNode<SupervisorAvailableTimeslotsQueryQuery, SupervisorAvailableTimeslotsQueryQueryVariables>;
export const NumberOfOpenIntroRequestsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NumberOfOpenIntroRequestsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"introRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"openForViewer"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<NumberOfOpenIntroRequestsQueryQuery, NumberOfOpenIntroRequestsQueryQueryVariables>;
export const IntroRequestOrganizationInfoByIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntroRequestOrganizationInfoByIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"introRequestOrganizationInfoById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"superviseeInfo"}},{"kind":"Field","name":{"kind":"Name","value":"supervisionStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyHours"}},{"kind":"Field","name":{"kind":"Name","value":"sessionTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"clinicalQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}}]}}]}}]} as unknown as DocumentNode<IntroRequestOrganizationInfoByIdQueryQuery, IntroRequestOrganizationInfoByIdQueryQueryVariables>;
export const OrganizationProgramsWithDetailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationProgramsWithDetailsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationPrograms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"introCallPreferenceId"}},{"kind":"Field","name":{"kind":"Name","value":"requiresNotesInReports"}},{"kind":"Field","name":{"kind":"Name","value":"organizationAdmins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationProgramsWithDetailsQueryQuery, OrganizationProgramsWithDetailsQueryQueryVariables>;
export const CreateOrganizationProgramMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganizationProgramMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationProgramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganizationProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateOrganizationProgramMutationMutation, CreateOrganizationProgramMutationMutationVariables>;
export const DeleteOrganizationProgramMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrganizationProgramMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOrganizationProgramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrganizationProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteOrganizationProgramMutationMutation, DeleteOrganizationProgramMutationMutationVariables>;
export const UpdateSuperviseesInProgramMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSuperviseesInProgramMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSuperviseesInProgramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSuperviseesInProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateSuperviseesInProgramMutationMutation, UpdateSuperviseesInProgramMutationMutationVariables>;
export const AssignOrganizationProgramDirectorMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignOrganizationProgramDirectorMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignOrganizationProgramDirectorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignOrganizationProgramDirector"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AssignOrganizationProgramDirectorMutationMutation, AssignOrganizationProgramDirectorMutationMutationVariables>;
export const UpdateOrganizationProgramSettingsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationProgramSettingsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationProgramSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationProgramSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationProgramSettingsMutationMutation, UpdateOrganizationProgramSettingsMutationMutationVariables>;
export const OrganizationProgramByIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationProgramByIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationProgramId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationProgramById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationProgramId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationProgramId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiresNotesInReports"}},{"kind":"Field","name":{"kind":"Name","value":"introCallPreferenceId"}},{"kind":"Field","name":{"kind":"Name","value":"requiresSupervisorAdminHours"}}]}}]}}]} as unknown as DocumentNode<OrganizationProgramByIdQueryQuery, OrganizationProgramByIdQueryQueryVariables>;
export const SuperviseesByOrganizationProgramIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuperviseesByOrganizationProgramIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationProgramId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superviseesByOrganizationProgramId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationProgramId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationProgramId"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorId"}},{"kind":"Field","name":{"kind":"Name","value":"matchStatusId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<SuperviseesByOrganizationProgramIdQueryQuery, SuperviseesByOrganizationProgramIdQueryQueryVariables>;
export const OrganizationSupervisorsOutsideProgramQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationSupervisorsOutsideProgramQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchStatusId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationSupervisors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchStatusId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchStatusId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"superviseeMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchStatusId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationSupervisorsOutsideProgramQueryQuery, OrganizationSupervisorsOutsideProgramQueryQueryVariables>;
export const OrganizationSuperviseesOutsideProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationSuperviseesOutsideProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersByOrganizationIdQueryFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortByMostRecentSession"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersByOrganizationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortByMostRecentSession"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortByMostRecentSession"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorId"}},{"kind":"Field","name":{"kind":"Name","value":"matchStatusId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<OrganizationSuperviseesOutsideProgramQuery, OrganizationSuperviseesOutsideProgramQueryVariables>;
export const OrganizationProgramDirectorsByOrganizationIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationProgramDirectorsByOrganizationIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationProgramDirectorsByOrganizationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationPrograms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationProgramDirectorsByOrganizationIdQueryQuery, OrganizationProgramDirectorsByOrganizationIdQueryQueryVariables>;
export const SessionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SessionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionDispositionIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noShowOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"beforeDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"afterDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionDispositionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionDispositionIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"noShowOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noShowOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionAttendees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationProgram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attended"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"partialAttendanceMinutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionDispositionId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unavailableParty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionCancellationReason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<SessionsQueryQuery, SessionsQueryQueryVariables>;
export const OrganizationByIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationByIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canRemoveSupervisees"}},{"kind":"Field","name":{"kind":"Name","value":"organizationUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationByIdQueryQuery, OrganizationByIdQueryQueryVariables>;
export const UpcomingSessionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpcomingSessionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionDispositionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionAttendees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attended"}},{"kind":"Field","name":{"kind":"Name","value":"partialAttendanceMinutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpcomingSessionsQueryQuery, UpcomingSessionsQueryQueryVariables>;
export const OrganizationSummaryByIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationSummaryByIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationSummaryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"pendingUserCount"}},{"kind":"Field","name":{"kind":"Name","value":"inactiveUserCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"usesInvoice"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationSummaryByIdQueryQuery, OrganizationSummaryByIdQueryQueryVariables>;
export const UserByIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserByIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletedForOrganizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"smallAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"usersLicenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationSuperviseeOnboardingRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licenseCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deletedForOrganizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletedForOrganizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledForRemovalOn"}}]}}]}}]}}]} as unknown as DocumentNode<UserByIdQueryQuery, UserByIdQueryQueryVariables>;
export const SessionsSummaryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SessionsSummaryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superviseeSessionsSummaryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"individualMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"dyadMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"groupMinutes"}}]}}]}}]} as unknown as DocumentNode<SessionsSummaryByIdQuery, SessionsSummaryByIdQueryVariables>;
export const CreateSetupIntentForOrganizationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSetupIntentForOrganizationMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSetupIntentForOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}}]}}]} as unknown as DocumentNode<CreateSetupIntentForOrganizationMutationMutation, CreateSetupIntentForOrganizationMutationMutationVariables>;
export const DeleteCreditCardForOrganizationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCreditCardForOrganizationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCreditCardForOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCreditCardForOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCreditCardForOrganizationSuccessResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalCardDeletionError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"finalCardDeletionError"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCreditCardForOrganizationMutationMutation, DeleteCreditCardForOrganizationMutationMutationVariables>;
export const SetPreferredCreditCardForOrganizationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPreferredCreditCardForOrganizationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetPreferredCreditCardForOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPreferredCreditCardForOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SetPreferredCreditCardForOrganizationMutationMutation, SetPreferredCreditCardForOrganizationMutationMutationVariables>;
export const CreateCreditCardForOrganizationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCreditCardForOrganizationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCreditCardForOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCreditCardForOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateCreditCardForOrganizationMutationMutation, CreateCreditCardForOrganizationMutationMutationVariables>;
export const OrganizationCreditCardsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationCreditCardsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationCreditCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastFourDigits"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}}]}}]}}]} as unknown as DocumentNode<OrganizationCreditCardsQueryQuery, OrganizationCreditCardsQueryQueryVariables>;
export const OrganizationInvoicesTabQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationInvoicesTabQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationInvoicesByOrganizationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"stripeInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amountDue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hostedInvoiceUrl"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationInvoicesTabQueryQuery, OrganizationInvoicesTabQueryQueryVariables>;
export const UpdateNotificationSubscriptionsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotificationSubscriptionsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateNotificationSubscriptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationSubscriptionsMutationMutation, UpdateNotificationSubscriptionsMutationMutationVariables>;
export const NotificationSubscriptionsForOrganizationAdminQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationSubscriptionsForOrganizationAdminQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationSubscriptionsForOrganizationAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"noShowEmails"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorMatchEmails"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyReports"}},{"kind":"Field","name":{"kind":"Name","value":"rateIncreases"}}]}}]}}]} as unknown as DocumentNode<NotificationSubscriptionsForOrganizationAdminQueryQuery, NotificationSubscriptionsForOrganizationAdminQueryQueryVariables>;
export const DeleteOrganizationAdminMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrganizationAdminMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOrganizationAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrganizationAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteOrganizationAdminMutationMutation, DeleteOrganizationAdminMutationMutationVariables>;
export const CreateOrganizationAdminMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganizationAdminMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganizationAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateOrganizationAdminMutationMutation, CreateOrganizationAdminMutationMutationVariables>;
export const UpdateOrganizationAdminMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationAdminMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationAdminMutationMutation, UpdateOrganizationAdminMutationMutationVariables>;
export const OrganizationFormOptionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationFormOptionsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"populations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrganizationFormOptionsQueryQuery, OrganizationFormOptionsQueryQueryVariables>;
export const OrganizationAdminsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationAdminsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationAdmins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationPrograms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<OrganizationAdminsQueryQuery, OrganizationAdminsQueryQueryVariables>;
export const OrganizationTeamMembersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationTeamMembersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeamMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"passwordSetAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationPrograms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<OrganizationTeamMembersQueryQuery, OrganizationTeamMembersQueryQueryVariables>;
export const OrganizationRolesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationRolesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrganizationRolesQueryQuery, OrganizationRolesQueryQueryVariables>;
export const UpdateOrganizationAdminProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationAdminProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationAdminProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationAdminProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationAdminProfileMutationMutation, UpdateOrganizationAdminProfileMutationMutationVariables>;
export const ResetOrganizationAdminPasswordMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetOrganizationAdminPasswordMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetOrganizationAdminPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordSuccessResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"resetPasswordURL"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordErrorResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<ResetOrganizationAdminPasswordMutationMutation, ResetOrganizationAdminPasswordMutationMutationVariables>;
export const GeneralSettingsFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GeneralSettingsFormQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clinicalSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GeneralSettingsFormQueryQuery, GeneralSettingsFormQueryQueryVariables>;
export const CreateOrganizationUserMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganizationUserMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganizationUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateOrganizationUserMutationMutation, CreateOrganizationUserMutationMutationVariables>;
export const UnmatchSuperviseeReasonsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnmatchSuperviseeReasonsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"forOrganizationUsersRemoval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unmatchSuperviseeReasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"forOrganizationUsersRemoval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"forOrganizationUsersRemoval"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UnmatchSuperviseeReasonsQueryQuery, UnmatchSuperviseeReasonsQueryQueryVariables>;
export const UsStatesForOrganizationUsersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsStatesForOrganizationUsersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationProgramId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usStatesForOrganizationUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationProgramId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationProgramId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usStates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UsStatesForOrganizationUsersQueryQuery, UsStatesForOrganizationUsersQueryQueryVariables>;
export const CreateUsersForOrganizationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUsersForOrganizationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUsersForOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUsersForOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateUsersForOrganizationMutationMutation, CreateUsersForOrganizationMutationMutationVariables>;
export const CreateB2BMatchMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateB2BMatchMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateB2BMatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createB2BMatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateB2BMatchMutationMutation, CreateB2BMatchMutationMutationVariables>;
export const DeleteOrganizationUserMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrganizationUserMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOrganizationUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrganizationUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteOrganizationUserMutationMutation, DeleteOrganizationUserMutationMutationVariables>;
export const ScheduleOrganizationUserForRemovalMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScheduleOrganizationUserForRemovalMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleOrganizationUserForRemovalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleOrganizationUserForRemoval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"wasSuperviseeRemovedImmediately"}}]}}]}}]} as unknown as DocumentNode<ScheduleOrganizationUserForRemovalMutationMutation, ScheduleOrganizationUserForRemovalMutationMutationVariables>;
export const BouncedEmailsUpdateUserProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BouncedEmailsUpdateUserProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<BouncedEmailsUpdateUserProfileMutationMutation, BouncedEmailsUpdateUserProfileMutationMutationVariables>;
export const CancelScheduledOrganizationUserRemovalMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelScheduledOrganizationUserRemovalMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelScheduledOrganizationUserRemovalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelScheduledOrganizationUserRemoval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CancelScheduledOrganizationUserRemovalMutationMutation, CancelScheduledOrganizationUserRemovalMutationMutationVariables>;
export const OrganizationMatchesByOrganizationIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationMatchesByOrganizationIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchStatusId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMatchesByOrganizationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchStatusId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchStatusId"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"smallAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supervisorBandwidthId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersLicenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationMatchesByOrganizationIdQueryQuery, OrganizationMatchesByOrganizationIdQueryQueryVariables>;
export const UsersByOrganizationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersByOrganizationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersByOrganizationIdQueryFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortByMostRecentSession"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usStateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isRemovedTab"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersByOrganizationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortByMostRecentSession"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortByMostRecentSession"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"usStateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usStateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRemovedTab"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"supervisorMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorId"}},{"kind":"Field","name":{"kind":"Name","value":"matchStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRemovedTab"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deletedForOrganizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"billingCode"}},{"kind":"Field","name":{"kind":"Name","value":"matchEmailSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledForRemovalOn"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"recentSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"upcomingSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedBySupervisorAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationProgram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unmatchSuperviseeReason"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRemovedTab"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removalReasonText"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRemovedTab"}}}]}]}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationSuperviseeOnboardingRequest"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRemovedTab"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licenseCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<UsersByOrganizationIdQuery, UsersByOrganizationIdQueryVariables>;
export const OrganizationSuperviseeOnboardingOptionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationSuperviseeOnboardingOptionsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usStates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licenseCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<OrganizationSuperviseeOnboardingOptionsQueryQuery, OrganizationSuperviseeOnboardingOptionsQueryQueryVariables>;
export const SupervisorBandwidthsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupervisorBandwidths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supervisorBandwidths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SupervisorBandwidthsQuery, SupervisorBandwidthsQueryVariables>;
export const BouncedEmailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BouncedEmailsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bouncedEmails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<BouncedEmailsQueryQuery, BouncedEmailsQueryQueryVariables>;
export const OrganizationSupervisorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationSupervisors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchStatusId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationSupervisors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchStatusId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchStatusId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"actorId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supervisees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<OrganizationSupervisorsQuery, OrganizationSupervisorsQueryVariables>;
export const SupervisorAvailableTimeslotsByDayQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupervisorAvailableTimeslotsByDayQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supervisorUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supervisorAvailableTimeslotsByDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supervisorUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supervisorUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"duration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration"}}},{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"times"}}]}}]}}]} as unknown as DocumentNode<SupervisorAvailableTimeslotsByDayQueryQuery, SupervisorAvailableTimeslotsByDayQueryQueryVariables>;
export const UserAvailabilitiesByUserIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserAvailabilitiesByUserIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAvailabilitiesByUserIdQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weeklyAvailableHours"}}]}}]}}]} as unknown as DocumentNode<UserAvailabilitiesByUserIdQueryQuery, UserAvailabilitiesByUserIdQueryQueryVariables>;
export const ViewerQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mediumAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationPrograms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRoleId"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionNames"}},{"kind":"Field","name":{"kind":"Name","value":"programIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"clinicalSettingId"}},{"kind":"Field","name":{"kind":"Name","value":"requiresNotesInReports"}},{"kind":"Field","name":{"kind":"Name","value":"requiresSupervisorAdminHours"}},{"kind":"Field","name":{"kind":"Name","value":"isEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"usesInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"hasAssignedEmployerCareManager"}},{"kind":"Field","name":{"kind":"Name","value":"requiresPaymentInformation"}},{"kind":"Field","name":{"kind":"Name","value":"supervisionAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"introCallPreferenceId"}},{"kind":"Field","name":{"kind":"Name","value":"populations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureFlags"}},{"kind":"Field","name":{"kind":"Name","value":"openIntroRequestsCount"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessBillableWork"}},{"kind":"Field","name":{"kind":"Name","value":"organizationPrograms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerQueryQuery, ViewerQueryQueryVariables>;
export const RequiresPaymentInformationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RequiresPaymentInformationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationCreditCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"usesInvoice"}}]}}]}}]} as unknown as DocumentNode<RequiresPaymentInformationQueryQuery, RequiresPaymentInformationQueryQueryVariables>;
export const LicensesLookupQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LicensesLookupQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licenseCategoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"licenseCategoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licenseCategoryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<LicensesLookupQueryQuery, LicensesLookupQueryQueryVariables>;